import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { Row, Col } from 'reactstrap';
import { Icon } from 'semantic-ui-react';
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import {FormattedMessage, useIntl} from 'react-intl';
import DataServiceSQL from "../../DataService/DataServiceSQL";
import PatientFunctionsGetter from "../../Controller/getSQLPatientFunctions.js";
import { userIsPsadStaff, userIsInPsadStructure, userIsPractitioner, userRpps, userIsSuperAdmin, userIsAdmin } from "../../Controller/userRoles.js";
import CopyableId from '../Common/CopyableId.js';
import DeviceForm from '../Device/DeviceForm.js';
import AddDevicePopup from '../Device/AddDevicePopup.js';
import DeleteDevicePopup from '../Device/DeleteDevicePopup.js';
import InvalidObject from '../Common/InvalidObject.js';
import ValidationPopup from '../../Popup/ValidationPopup.js';
import AddPhoneNumberPopup from '../Patient/AddPhoneNumberPopup.js';
import axios from "axios";
import DatePicker from 'react-date-picker'
import "../Common/DatePickerStyle.css";
import "../Common/DatePickerCalendar.css";
import Utils from "../Common/Utils.js";
import Switch from "react-switch";
import { Switch2, Switch3, SwitchLabel, SwitchRadio, SwitchSelection } from '../Common/SwitchStyles.js'
import MonitoringSwitch from '../Common/MonitoringSwitch.js'
import AddPractitionerPopup from '../Correspondant/AddPractitionerPopup.js';
import { Card } from 'antd'
import { Range, getTrackBackground } from 'react-range';
import { Tooltip } from 'react-tooltip'

const { Meta } = Card;

import 'react-phone-number-input/style.css'
import PhoneInput, {isValidPhoneNumber, parsePhoneNumber} from 'react-phone-number-input'

import default_device from '../Device/DeviceDefaultParams.js';


const PatientParamsEditTab = (props) => {
  let workingOnCancel = false //pass to true if trying to deal with the cancel modification button
  const intl = useIntl()
  const noAssociationMsg = intl.messages["param.noAssociation"];
  const manualAssociationMsg = intl.messages["param.manualAssociation"];

  const [firstname, setFirstname] = useState(props.profileData.Patient_Data.firstname);
  const [lastname, setLastname] = useState(props.profileData.Patient_Data.lastname);
  const [birthdate, setBirthdate] = useState(new Date(props.profileData.Patient_Data.birthdate));
  const [location, setLocation] = useState(props.profileData.Patient_Data.location);
  const [group, setGroup] = useState(props.profileData.Patient_Data.group);

  const [mailalert, setMailalert] = useState(props.profileData.Patient_Data.alerts.mail_alert);
  const [mailalertMultirecipient, setMailalertMultirecipient] = useState(Utils.contactListsToMultiRecipient(props.profileData.Patient_Data.alerts.mail_alert, props.profileData.Patient_Data.alerts.mail_alert_reminder, props.profileData.Patient_Data.alerts.mail_alert_night, props.profileData.Patient_Data.alerts.mail_alert_reminder_night));
  const [smsalert, setSmsalert] = useState(Utils.smsAlertParse(props.profileData.Patient_Data.alerts.sms_alert));
  const [smsalertMultirecipient, setSmsalertMultirecipient] = useState(Utils.contactListsToMultiRecipient(props.profileData.Patient_Data.alerts.sms_alert, props.profileData.Patient_Data.alerts.sms_alert_reminder, props.profileData.Patient_Data.alerts.sms_alert_night, props.profileData.Patient_Data.alerts.sms_alert_reminder_night));
  const [recall, setRecall] = useState(props.profileData.Patient_Data.alert_recall);

  const [displayFeverParams, setDisplayFeverParams] = useState(Boolean(props.profileData.Patient_Data.alerts.fever_alert.activated));
  const [feverAlert, setFeverAlert] = useState(props.profileData.Patient_Data.alerts.fever_alert);
  const [checkedFever, setCheckedFever] = useState(Boolean(props.profileData.Patient_Data.alerts.fever_alert.activated));

  const [position, setPosition] = useState(props.profileData.Patient_Data.alerts.pos_alert.threshold);
 
  const [displaySPO2Params, setDisplaySPO2Params] = useState(Boolean(props.profileData.Patient_Data.alerts.SPO2_alert.activated));
  const [SPO2Alert, setSPO2Alert] = useState(props.profileData.Patient_Data.alerts.SPO2_alert);
  const [checkedSPO2, setCheckedSPO2] = useState(Boolean(props.profileData.Patient_Data.alerts.SPO2_alert.activated));
  
  const [displayPRParams, setDisplayPRParams] = useState(Boolean(props.profileData.Patient_Data.alerts.PR_alert.activated));
  const [PRAlert, setPRAlert] = useState(props.profileData.Patient_Data.alerts.PR_alert);
  const [checkedPR, setCheckedPR] = useState(Boolean(props.profileData.Patient_Data.alerts.PR_alert.activated));

  const [PRTensionAlert, setPRTensionAlert] = useState(props.profileData.Patient_Data.alerts.bloodpressure_PR_alert);
  const [checkedPRTension, setCheckedPRTension] = useState(Boolean(props.profileData.Patient_Data.alerts.bloodpressure_PR_alert.activated));
  const [systolicHighAlert, setSystolicHighAlert] = useState(props.profileData.Patient_Data.alerts.bloodpressure_sys_high_alert);
  const [checkedSystolicHigh, setCheckedSystolicHigh] = useState(Boolean(props.profileData.Patient_Data.alerts.bloodpressure_sys_high_alert.activated));
  const [diastolicHighAlert, setDiastolicHighAlert] = useState(props.profileData.Patient_Data.alerts.bloodpressure_dia_alert);
  const [checkedDiastolicHigh, setCheckedDiastolicHigh] = useState(Boolean(props.profileData.Patient_Data.alerts.bloodpressure_dia_alert.activated));
  const [weightAlert, setWeightAlert] =     useState(props.profileData.Patient_Data.alerts.weight_alert);
  const [checkedWeight, setCheckedWeight] = useState(Boolean(props.profileData.Patient_Data.alerts.weight_alert.activated));
  const [eq5dAlert, setEq5dAlert] = useState(props.profileData.Patient_Data.alerts.eq5d_alert);
  const [checkedEQ5D, setCheckedEQ5D] = useState(Boolean(props.profileData.Patient_Data.alerts.eq5d_alert.activated));
  const [eq5dScaleAlert, setEq5dScaleAlert] = useState(props.profileData.Patient_Data.alerts.eq5d_scale_alert);
  const [checkedEQ5DScale, setCheckedEQ5DScale] = useState(Boolean(props.profileData.Patient_Data.alerts.eq5d_scale_alert.activated));
  const [sf36Alert, setSf36Alert] = useState(props.profileData.Patient_Data.alerts.sf36_alert);
  const [checkedSF36, setCheckedSF36] = useState(Boolean(props.profileData.Patient_Data.alerts.sf36_alert.activated));
  const [mdasiAlert, setMDASIAlert] = useState(props.profileData.Patient_Data.alerts.mdasi_alert);
  const [checkedMDASI, setCheckedMDASI] = useState(Boolean(props.profileData.Patient_Data.alerts.mdasi_alert.activated));
  const [painAlert, setPainAlert] = useState(props.profileData.Patient_Data.alerts.pain_alert);
  const [checkedPain, setCheckedPain] = useState(Boolean(props.profileData.Patient_Data.alerts.pain_alert.activated));

  const [breathingAlert, setBreathingAlert] = useState(props.profileData.Patient_Data.alerts.breathing_rate_alert);
  const [checkedBreathing, setCheckedBreathing] = useState(Boolean(props.profileData.Patient_Data.alerts.breathing_rate_alert.activated));

  const [breathingOxygenRateAlert, setBreathingOxygenRateAlert] = useState(props.profileData.Patient_Data.alerts.breathing_oxygen_rate_alert);
  const [checkedBreathingOxygenRate, setCheckedBreathingOxygenRate] = useState(Boolean(props.profileData.Patient_Data.alerts.breathing_oxygen_rate_alert.activated));

  const [breathingLeakageAlert, setBreathingLeakageAlert] = useState(props.profileData.Patient_Data.alerts.breathing_leakage_alert);
  const [checkedBreathingLeakage, setCheckedBreathingLeakage] = useState(Boolean(props.profileData.Patient_Data.alerts.breathing_leakage_alert.activated));

  const [breathingLeakage95Alert, setBreathingLeakage95Alert] = useState(props.profileData.Patient_Data.alerts.breathing_leakage95_alert || { threshold: 24, sup_or_inf: 'sup', delay: 0, activated: false });
  const [checkedBreathingLeakage95, setCheckedBreathingLeakage95] = useState(Boolean((props.profileData.Patient_Data.alerts.breathing_leakage95_alert || {}).activated));

  const [breathingAhiAlert, setBreathingAhiAlert] = useState(props.profileData.Patient_Data.alerts.breathing_ahi_alert || { threshold: 15, sup_or_inf: 'sup', delay: 0, activated: false });
  const [checkedBreathingAhi, setCheckedBreathingAhi] = useState(Boolean((props.profileData.Patient_Data.alerts.breathing_ahi_alert || {}).activated));

  const [breathingObservanceAlert, setBreathingObservanceAlert] = useState(props.profileData.Patient_Data.alerts.breathing_observance_alert);
  const [checkedBreathingObservance, setCheckedBreathingObservance] = useState(Boolean(props.profileData.Patient_Data.alerts.breathing_observance_alert.activated));

  const [moduleActivation, setModuleActivation] = useState(props.profileData.Patient_Data.module_activation);

  const [checkedDetach, setCheckedDetach] = useState(Boolean(props.profileData.Patient_Data.alerts.detach_alert.activated));

  const [checkedBattery, setCheckedBattery] = useState(props.profileData.Patient_Data.alerts.battery_alert.activated);

  const [checkedReminder, setCheckedReminder] = useState(Boolean(props.profileData.Patient_Data.alerts.reminder_alert.activated));
  const [checkedReminderList, setCheckedReminderList] = useState(Utils.fillReminder(props.profileData.Patient_Data.alerts.reminder_alert.alerts_params, props.subscription_info.features));
  const [reminderFirstPhone, setReminderFirstPhone] = useState(Utils.smsAlertParse(props.profileData.Patient_Data.alerts.sms_alert_reminder));
  //const [reminderSecondPhone, setReminderSecondPhone] = useState(props.profileData.Patient_Data.alerts.reminder_alert.second_phone);
  const [newReminderHours, setNewReminderHours] = useState(Utils.fillNewReminderHours());
  const [checkedReminderTucky, setCheckedReminderTucky] = useState(Boolean(Utils.get_reminder_from_type(props.profileData.Patient_Data.alerts.reminder_alert.alerts_params, "tucky_reminder")));
  const [checkedReminderOximeter, setCheckedReminderOximeter] = useState(Boolean(Utils.get_reminder_from_type(props.profileData.Patient_Data.alerts.reminder_alert.alerts_params, "oximeter_reminder")));
  const [checkedReminderTensiometer, setCheckedReminderTensiometer] = useState(Boolean(Utils.get_reminder_from_type(props.profileData.Patient_Data.alerts.reminder_alert.alerts_params, "tensiometer_reminder")));
  const [checkedReminderScale, setCheckedReminderScale] = useState(Boolean(Utils.get_reminder_from_type(props.profileData.Patient_Data.alerts.reminder_alert.alerts_params, "scale_reminder")));
  const [checkedReminderEQ5D, setCheckedReminderEQ5D] = useState(Boolean(Utils.get_reminder_from_type(props.profileData.Patient_Data.alerts.reminder_alert.alerts_params, "healthform_reminder_eq5d")));
  const [checkedReminderSF36, setCheckedReminderSF36] = useState(Boolean(Utils.get_reminder_from_type(props.profileData.Patient_Data.alerts.reminder_alert.alerts_params, "healthform_reminder_sf36")));
  const [checkedReminderMDASI, setCheckedReminderMDASI] = useState(Boolean(Utils.get_reminder_from_type(props.profileData.Patient_Data.alerts.reminder_alert.alerts_params, "healthform_reminder_mdasi")));
  const [checkedReminderAlimentation, setCheckedReminderAlimentation] = useState(Boolean(Utils.get_reminder_from_type(props.profileData.Patient_Data.alerts.reminder_alert.alerts_params, "healthform_reminder_alimentation")));
  const [checkedReminderPain, setCheckedReminderPain] = useState(Boolean(Utils.get_reminder_from_type(props.profileData.Patient_Data.alerts.reminder_alert.alerts_params, "pain_reminder")));
  const [checkedReminderNiv, setCheckedReminderNiv] = useState(Boolean(Utils.get_reminder_from_type(props.profileData.Patient_Data.alerts.reminder_alert.alerts_params, "niv_reminder")));
  const [checkedReminderOxi, setCheckedReminderOxi] = useState(Boolean(Utils.get_reminder_from_type(props.profileData.Patient_Data.alerts.reminder_alert.alerts_params, "oxi_reminder")));
  const [reminderToDelete, setReminderToDelete] = useState("");

  const [checkedSound, setCheckedSound] = useState(props.profileData.Patient_Data.alerts.sound_alert);

  const [painLevel, setPainLevel] = useState([0]);

  const [submitted, setsubmitted] = useState(false);
  const [message, setmessage] = useState("");

  const [displayInvalidValuePopup, setDisplayInvalidValuePopup] = useState(false);
  const [displayValidationPopup, setDisplayValidationPopup] = useState(false);

  const [prev_monitoring_selected, setPreviousMonitoringSelected] = useState(props.profileData.Patient_Data.monitoring_activation);
  const [displayTuckyParams, setDisplayTuckyParams] = useState(props.profileData.Patient_Data.devices.device1.id !== 'dissociate');
  const [displayOximeterParams, setDisplayOximeterParams] = useState(props.profileData.Patient_Data.devices.device2.id !== 'dissociate');
  const [displayTensiometerParams, setDisplayTensiometerParams] = useState(props.profileData.Patient_Data.devices.device3.id !== 'dissociate');
  const [displayScaleParams, setDisplayScaleParams] = useState(props.profileData.Patient_Data.devices.device4.id !== 'dissociate');
  const [selectedGw, setSelectedGw] =                               useState(props.profileData.Patient_Data.devices.gateway);
  const [selectedDeviceList, setSelectedDeviceList] =               useState(props.profileData.Patient_Data.devices);

  // The viewer's structure device list augmented with the patient's own resolved
  // devices that live in another structure (shared patient). Used so the param-edit
  // shows the same device cards/options the patient owner sees, instead of wiping
  // or hiding cross-structure devices.
  const effectiveDeviceList = (() => {
    const base = Array.isArray(props.device_list) ? [...props.device_list] : [];
    const resolved = props.profileData.Patient_Data.devices_resolved;
    if (resolved) {
      ["device1", "device2", "device3", "device4", "device5"].forEach(slot => {
        const r = resolved[slot];
        if (r && r.id && r.id !== "dissociate" && !base.some(d => d.id_device === r.id)) {
          base.push({ id_device: r.id, type: r.type, nickname: r.nickname, sn: r.sn });
        }
      });
    }
    return base;
  })();

  // Same idea for the gateway: include the patient's resolved gateway when it lives
  // in another structure (shared patient) so the gateway selector shows it.
  const effectiveGwList = (() => {
    const base = Array.isArray(props.gw_list) ? [...props.gw_list] : [];
    const rg = props.profileData.Patient_Data.devices_resolved && props.profileData.Patient_Data.devices_resolved.gateway;
    if (rg && rg.id && rg.id !== "dissociate" && !base.some(g => g.id_gw === rg.id)) {
      base.push({ id_gw: rg.id, gw_name: rg.name || rg.nickname, nickname: rg.nickname, fullname: rg.nickname });
    }
    return base;
  })();

  const [displayAddDevicePopup, setDisplayAddDevicePopup] = useState(false);
  const [displayDeleteDevicePopup, setDisplayDeleteDevicePopup] = useState(false);
  const [displayDeletePatientPopup, setDisplayDeletePatientPopup] = useState(false);
  const [deleteDeviceID, setDeleteDeviceID] = useState("");

  const [displayAlertModes, setDisplayAlertModes] = useState((props.profileData.Patient_Data.monitoring_activation === "gateway")||(props.profileData.Patient_Data.monitoring_activation === "smartphone")||(props.profileData.Patient_Data.monitoring_activation === "no_device"));

  const [devicesVisible, setDevicesVisible] = useState(Utils.testIsDevicesAndGatewayAssociate(props.profileData.Patient_Data.devices));
  const [modulesVisible, setModulesVisible] = useState(Utils.testAnyModuleUsed(props.profileData.Patient_Data.module_activation));
  const [healthformsVisible, setHealthformsVisible] = useState(Utils.testAnyModuleUsed(props.profileData.Patient_Data.module_activation));
  const [smartphoneVisible, setSmartphoneVisible] = useState(Utils.testSmartphoneDisplay(props.profileData.Patient_Data.module_activation));

  const [addSign, setAddSign] = useState(<i className="fas fa-plus fa-2xl action mr-2" style={{color:"white"}}></i>);

  const savedPatient = props.profileData;
  const [rerender, setRerender] = useState(false);
  const [openDurationCondition, setOpenDurationCondition] = useState(null);

  useEffect(() => {
    if (!openDurationCondition) {
      return undefined;
    }

    const closePopup = () => setOpenDurationCondition(null);
    const handleOutsideClick = (event) => {
      const target = event.target;
      if (target && typeof target.closest === "function" && target.closest('[data-duration-condition-popup="true"]')) {
        return;
      }
      closePopup();
    }
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closePopup();
      }
    }

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);
    document.addEventListener("keydown", handleKeyDown);
    window.addEventListener("resize", closePopup);
    window.addEventListener("scroll", closePopup, true);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
      document.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("resize", closePopup);
      window.removeEventListener("scroll", closePopup, true);
    }
  }, [openDurationCondition]);

  const getDurationConditionPopupPosition = (target) => {
    if (typeof window === "undefined" || !target || typeof target.getBoundingClientRect !== "function") {
      return { top: 0, left: 0, width: 480 };
    }

    const rect = target.getBoundingClientRect();
    const gutter = 12;
    const width = Math.min(520, Math.max(280, window.innerWidth - (gutter * 2)));
    const estimatedHeight = 96;
    const shouldOpenAbove = rect.bottom + estimatedHeight + gutter > window.innerHeight && rect.top > estimatedHeight + gutter;
    const top = shouldOpenAbove ? rect.top - estimatedHeight - 6 : rect.bottom + 6;
    const left = Math.min(
      Math.max(gutter, rect.right - width),
      window.innerWidth - width - gutter
    );

    return { top, left, width };
  }

  const toggleDurationConditionPopup = (alertName, event) => {
    event.preventDefault();
    event.stopPropagation();

    const popupPosition = getDurationConditionPopupPosition(event.currentTarget);
    setOpenDurationCondition(current => (
      current && current.alertName === alertName
        ? null
        : { alertName, ...popupPosition }
    ));
  }

  // Per-type alert state used by the duration-condition popup, keyed by the canonical
  // alert type (alertParams.type set by alert_filling)
  const alertStateByType = {
    fever_alert: [feverAlert, setFeverAlert],
    PR_alert: [PRAlert, setPRAlert],
    SPO2_alert: [SPO2Alert, setSPO2Alert],
    bloodpressure_PR_alert: [PRTensionAlert, setPRTensionAlert],
    bloodpressure_sys_high_alert: [systolicHighAlert, setSystolicHighAlert],
    bloodpressure_dia_alert: [diastolicHighAlert, setDiastolicHighAlert],
    weight_alert: [weightAlert, setWeightAlert],
    eq5d_alert: [eq5dAlert, setEq5dAlert],
    eq5d_scale_alert: [eq5dScaleAlert, setEq5dScaleAlert],
    sf36_alert: [sf36Alert, setSf36Alert],
    mdasi_alert: [mdasiAlert, setMDASIAlert],
    pain_alert: [painAlert, setPainAlert],
    breathing_rate_alert: [breathingAlert, setBreathingAlert],
    breathing_oxygen_rate_alert: [breathingOxygenRateAlert, setBreathingOxygenRateAlert],
    breathing_leakage_alert: [breathingLeakageAlert, setBreathingLeakageAlert],
    breathing_leakage95_alert: [breathingLeakage95Alert, setBreathingLeakage95Alert],
    breathing_ahi_alert: [breathingAhiAlert, setBreathingAhiAlert],
    breathing_observance_alert: [breathingObservanceAlert, setBreathingObservanceAlert],
  }

  // Mirror of the backend defaults (PatientDefaultParams_backend.js): minimum minutes
  // between two exceedances counted by the duration condition
  const REST_DURATION_DEFAULTS = {
    breathing_rate_alert: 720,
    breathing_leakage_alert: 720,
    breathing_leakage95_alert: 720,
    breathing_ahi_alert: 720,
    breathing_observance_alert: 720,
  }
  const getRestDurationDefault = (alertType) => REST_DURATION_DEFAULTS[alertType] !== undefined ? REST_DURATION_DEFAULTS[alertType] : 60
  const getRestDurationValue = (alertType, alertParams) => {
    const rest = alertParams ? alertParams.rest_duration : undefined
    return rest !== undefined && rest !== null && rest !== "" ? rest : getRestDurationDefault(alertType)
  }

  const PERIOD_MINUTES = { minute: 1, hour: 60, day: 1440, week: 10080 }
  const ENGINE_EVALUATION_MINUTES = 1.5
  const REST_DURATION_STEP_MINUTES = 0.5
  // Minimum-gap tuning only applies to minute-based windows (hour/day/week windows are wide
  // enough that the type's default rest is fine). In that regime the gap floor is a flat 2 min,
  // and the feasibility rule is: count x rest must stay 2 min below the window.
  const MIN_REST_FLOOR_MINUTES = 2
  const WINDOW_SAFETY_MINUTES = 2
  const isMinuteWindow = (periodValue) => periodValue === "minute"
  const formatDurationValue = (value) => Number(Number(value).toFixed(2))
  const getWindowMinutes = (windowValue, periodValue) => {
    const period = ["minute", "hour", "day", "week"].includes(periodValue) ? periodValue : "day"
    return (parseInt(windowValue) || 0) * (PERIOD_MINUTES[period] || 0)
  }
  // Minimum enforced gap between two counted exceedances. For minute-based windows the floor is
  // a flat 2 min; otherwise (or for a single occurrence) one engine cycle (90 s) is enough.
  const getMinRestDuration = (countNum, periodValue) => {
    const count = parseInt(countNum) || 0
    if (count < 2 || !isMinuteWindow(periodValue)) {
      return ENGINE_EVALUATION_MINUTES
    }
    return MIN_REST_FLOOR_MINUTES
  }
  // Largest rest that still counts `count` exceedances safely: count x rest must stay 2 min below
  // the window, so rest <= (window - 2) / count, rounded down to the step (e.g. (14 - 2) / 4 -> 3,
  // so 4 x 3 = 12 = 14 - 2). Returns null when the period condition is inactive.
  const getMaxSafeRestDuration = (countNum, windowMinutes) => {
    if (!(countNum >= 2) || !(windowMinutes > 0)) {
      return null
    }
    const safeWindow = windowMinutes - WINDOW_SAFETY_MINUTES
    if (safeWindow <= 0) {
      return 0
    }
    return formatDurationValue(Math.max(0, Math.floor((safeWindow / countNum) / REST_DURATION_STEP_MINUTES) * REST_DURATION_STEP_MINUTES))
  }
  const applyAutoRestDuration = (alertType, alertParams) => {
    const period = alertParams.threshold_exceedance_period
    if (!isMinuteWindow(period)) {
      // Gap tuning only applies to minute-based windows; leave the stored/default rest untouched.
      return alertParams
    }
    const countNum = parseInt(alertParams.threshold_exceeded_count) || 1
    const windowMinutes = getWindowMinutes(alertParams.threshold_exceedance_window, period)
    const defaultRest = getRestDurationDefault(alertType)
    const minRestMinutes = getMinRestDuration(countNum, period)
    const maxRestMinutes = getMaxSafeRestDuration(countNum, windowMinutes)
    const currentRestMinutes = parseFloat(getRestDurationValue(alertType, alertParams)) || 0
    let nextRestMinutes = currentRestMinutes
    if (countNum >= 2 && windowMinutes > 0) {
      if (windowMinutes / countNum >= defaultRest) {
        // Window comfortably fits the default spacing -> keep the default value.
        if (nextRestMinutes > defaultRest) {
          nextRestMinutes = defaultRest
        }
      } else if (maxRestMinutes !== null && nextRestMinutes > maxRestMinutes) {
        // Too tight for the default -> pull down to the feasible ceiling ((window - 2) / count).
        nextRestMinutes = maxRestMinutes
      }
    }
    if (nextRestMinutes < minRestMinutes) {
      nextRestMinutes = minRestMinutes
    }
    nextRestMinutes = formatDurationValue(nextRestMinutes)
    if (currentRestMinutes === nextRestMinutes) {
      return alertParams
    }
    return { ...alertParams, rest_duration: nextRestMinutes }
  }

  // Blocking feasibility check (minute-based windows only): counting X exceedances spaced >= rest
  // apart can never succeed safely unless X * rest stays 2 min below the window.
  const getDurationConditionConflict = (alertType, alertParams) => {
    const params = alertParams || {}
    const countNum = parseInt(params.threshold_exceeded_count)
    const period = params.threshold_exceedance_period
    if (!(countNum >= 2)) {
      const restMinutesForSingle = parseFloat(getRestDurationValue(alertType, params)) || 0
      return countNum >= 1 && restMinutesForSingle < getMinRestDuration(countNum, period)
    }
    if (!isMinuteWindow(period)) {
      return false
    }
    const windowMinutes = getWindowMinutes(params.threshold_exceedance_window, period)
    const restMinutes = parseFloat(getRestDurationValue(alertType, params)) || 0
    if (restMinutes < getMinRestDuration(countNum, period)) {
      return true
    }
    return windowMinutes > 0 && (countNum * restMinutes) > (windowMinutes - WINDOW_SAFETY_MINUTES)
  }

  // Displayed duration-condition trio: the stored values when they exist, otherwise the
  // legacy equivalent "1 exceedance over `delay` minute(s)" so the popup shows the real
  // current behaviour of a legacy patient instead of an arbitrary suggestion
  const getDisplayedDurationCondition = (alertParams) => {
    const params = alertParams || {}
    const hasPeriodConfig = params.threshold_exceeded_count !== undefined && params.threshold_exceeded_count !== null && params.threshold_exceeded_count !== ""
    if (hasPeriodConfig) {
      return {
        count: params.threshold_exceeded_count,
        window: params.threshold_exceedance_window ?? 1,
        period: params.threshold_exceedance_period ?? "day",
      }
    }
    return {
      count: 1,
      window: Math.max(parseInt(params.delay) || 0, 1),
      period: "minute",
    }
  }

  const handleDurationConditionChange = (alertType, field, value) => {
    const alertState = alertStateByType[alertType]
    if (!alertState) {
      return
    }
    const [alertParams, setAlertParams] = alertState
    props.setChangeOngoing(true)
    if (field === "rest_duration") {
      const displayed = getDisplayedDurationCondition(alertParams)
      const countNum = parseInt(displayed.count) || 1
      const minRestMinutes = getMinRestDuration(countNum, displayed.period)
      const restValue = value === "" ? value : formatDurationValue(Math.max(parseFloat(value) || 0, minRestMinutes))
      setAlertParams({ ...alertParams, rest_duration: restValue })
    }
    else {
      // persist the displayed count/window/period trio as soon as one field is edited
      const displayed = getDisplayedDurationCondition(alertParams)
      const nextAlertParams = {
        ...alertParams,
        threshold_exceeded_count: field === "threshold_exceeded_count" ? value : displayed.count,
        threshold_exceedance_window: field === "threshold_exceedance_window" ? value : displayed.window,
        threshold_exceedance_period: field === "threshold_exceedance_period" ? value : displayed.period,
      }
      setAlertParams(applyAutoRestDuration(alertType, nextAlertParams))
    }
  }

  // Copy the duration-condition fields into the saved alert object. The trio is only
  // written when the practitioner edited the popup (absent keys = legacy immediate alert).
  const applyDurationCondition = (target_alert, state_alert) => {
    if (!target_alert || !state_alert) {
      return
    }
    if (state_alert.threshold_exceeded_count !== undefined && state_alert.threshold_exceeded_count !== null && state_alert.threshold_exceeded_count !== "") {
      target_alert.threshold_exceeded_count = parseInt(state_alert.threshold_exceeded_count) || 1
      target_alert.threshold_exceedance_window = parseInt(state_alert.threshold_exceedance_window) || 1
      target_alert.threshold_exceedance_period = ["minute", "hour", "day", "week"].includes(state_alert.threshold_exceedance_period) ? state_alert.threshold_exceedance_period : "day"
    }
    if (state_alert.rest_duration !== undefined && state_alert.rest_duration !== null && state_alert.rest_duration !== "") {
      target_alert.rest_duration = parseFloat(state_alert.rest_duration) || 0
    }
  }

  const testValidPhoneNumber = (phone_number) => {
    let ret = isValidPhoneNumber(phone_number)
    //block the phone number that starts with '+' but contains the '0' at beginning
    if (phone_number[0] === '+' && phone_number[3] === '0')  {
      ret = false
    }
    return ret
  }

  const getEmptyDevice = () => {
    let ret = {
      id: "dissociate",
      id_old: "",
      nickname: "",
      sn: "",
      type: ""
    }
    props.setChangeOngoing(true);
    return ret
  }

  const getEmptyGateway = () => {
    let ret = {
      fullname: "Smartphone",
      gw_name: "dissociate",
      id: "dissociate",
      id_gw: "dissociate",
      id_old: "dissociate",
      nickname: "--"
    }
    setDisplayAlertModes(false)
    props.changeDisplayDevices("no")
    return ret
  }

  const checkDeviceIsInList = (id) => {
    let ret = false;
    effectiveDeviceList.forEach(device => {
      if (device.id_device === id) {
        ret = true;
      }
    })
    return ret
  }

  const checkGatewayIsInList = (selected) => {
    let ret = false;
    effectiveGwList.forEach(gw => {
      if (gw.id_gw === selected.id || gw.id_gw === selected.id_gw) {
        ret = gw;
        ret.id = gw.id_gw
      }
    })
    return ret
  }

//actions when changes occurs on device list
  useEffect(() => {
    let new_selected_device_list = selectedDeviceList
    // A device that is not in the viewer's structure list but IS the patient's own
    // resolved device (shared patient, device owned by another structure) must be
    // kept, not wiped. Only genuinely-removed devices are cleared.
    const resolvedDevices = props.profileData.Patient_Data.devices_resolved;
    const isPatientOwnDevice = (slot, id) =>
      !!resolvedDevices && !!resolvedDevices[slot] && resolvedDevices[slot].id === id && id !== "dissociate";
    if (selectedDeviceList.device1.id !== "dissociate") {
      let found = checkDeviceIsInList(selectedDeviceList.device1.id);
      if (found === false && !isPatientOwnDevice("device1", selectedDeviceList.device1.id)) {
        new_selected_device_list.device1 = getEmptyDevice();
      }
    }
    if (selectedDeviceList.device2.id !== "dissociate") {
      let found = checkDeviceIsInList(selectedDeviceList.device2.id);
      if (found === false && !isPatientOwnDevice("device2", selectedDeviceList.device2.id)) {
        new_selected_device_list.device2 = getEmptyDevice();
      }
    }
    if (selectedDeviceList.device3.id !== "dissociate") {
      let found = checkDeviceIsInList(selectedDeviceList.device3.id);
      if (found === false && !isPatientOwnDevice("device3", selectedDeviceList.device3.id)) {
        new_selected_device_list.device3 = getEmptyDevice();
      }
    }
    if (selectedDeviceList.device4.id !== "dissociate") {
      let found = checkDeviceIsInList(selectedDeviceList.device4.id);
      if (found === false && !isPatientOwnDevice("device4", selectedDeviceList.device4.id)) {
        new_selected_device_list.device4 = getEmptyDevice();
      }
    }
    if (
      (props.displayDevicesParams === "gateway")
      &&
      (new_selected_device_list.device1.id === "dissociate"
      && new_selected_device_list.device2.id === "dissociate"
      && new_selected_device_list.device3.id === "dissociate"
      && new_selected_device_list.device4.id === "dissociate")
      && !Utils.testAnyModuleUsed(props.profileData.Patient_Data.module_activation)
      ) {
        let new_gw = getEmptyGateway();
        setSelectedGw(new_gw)
      }
    setSelectedDeviceList(new_selected_device_list);
  },[props.device_list])

//actions when changes occurs on gateway list
  useEffect(() => {
    let empty_gw_list = [{id_gw: 'dissociate', gw_name: '', nickname: '--', fullname: '--'}]
    if (JSON.stringify(effectiveGwList) !== JSON.stringify(empty_gw_list)) {
      if (props.displayDevicesParams !== "no" && props.changeOngoing === false) {
        let found = checkGatewayIsInList(selectedGw)
    let new_gw
    if (found !== false) {
      new_gw = effectiveGwList.find(gw => gw.id_gw === selectedGw.id)
          if (new_gw === undefined) {
            new_gw = effectiveGwList.find(gw => gw.id_gw === selectedGw.id_gw)
          }
        new_gw.id = new_gw.id_gw
          if (new_gw.id_gw === "dissociate") {
            props.changeDisplayDevices(props.profileData.Patient_Data.monitoring_activation)
    }
    else {
            props.changeDisplayDevices("gateway")
    }
    setSelectedGw(new_gw);
    }
    else {
          // Only clear if real gateways are loaded. If gw_list contains only
          // the "dissociate" sentinel, the list is still loading — don't wipe
          // the current selection, which will be restored on the next effect run.
          const hasRealGateways = effectiveGwList.some(gw => gw.id_gw !== "dissociate");
          // For a shared patient the gateway can belong to another structure, so it is
          // absent from the viewer's gw_list even though the patient really has one.
          // Don't wipe the resolved devices/gateway in that case.
          const patientGatewayId = props.profileData.Patient_Data.devices.gateway && props.profileData.Patient_Data.devices.gateway.id;
          const patientHasRealGateway = patientGatewayId && patientGatewayId !== "dissociate";
          if (hasRealGateways && !patientHasRealGateway) {
            new_gw = getEmptyGateway();
            let new_selected_device_list = selectedDeviceList;
            new_selected_device_list.device1 = getEmptyDevice();
            new_selected_device_list.device2 = getEmptyDevice();
            new_selected_device_list.device3 = getEmptyDevice();
            new_selected_device_list.device4 = getEmptyDevice();
            setSelectedDeviceList(new_selected_device_list);
            setSelectedGw(new_gw);
          }
    }
      }
    }
  },[props.gw_list])

  // Auto-select the single available gateway when a first device is added
  useEffect(() => {
    if (devicesVisible && selectedGw.id_gw === "dissociate") {
      const realGateways = effectiveGwList.filter(gw => gw.id_gw !== "dissociate")
      if (realGateways.length === 1) {
        const gw = { ...realGateways[0], id: realGateways[0].id_gw, id_old: props.profileData.Patient_Data.devices.gateway.id }
        let new_selected_device_list = selectedDeviceList
        new_selected_device_list.gateway = gw
        setSelectedGw(gw)
        setSelectedDeviceList(new_selected_device_list)
        props.changeDisplayDevices("gateway")
        props.setChangeOngoing(true)
      }
    }
  }, [devicesVisible])

  const cleanModulesDisplays = (to_hide) => {
    let new_display_devices = devicesVisible
    let new_display_modules = modulesVisible
    let new_display_healthforms = healthformsVisible
    let new_display_smartphone = smartphoneVisible

    if (to_hide === "devices" &&
        (
        selectedDeviceList.device1.id !== "dissociate"
      ||selectedDeviceList.device2.id !== "dissociate"
      ||selectedDeviceList.device3.id !== "dissociate"
      ||selectedDeviceList.device4.id !== "dissociate"
        )
      ) {
      new_display_devices = true
    }
    let x = 0;
    while (moduleActivation[x] && new_display_modules === false && new_display_healthforms === false && new_display_smartphone === false) {
      if (moduleActivation[x].used === true) {
        switch (moduleActivation[x].name) {
          case "EQ5D":
          case "SF36":
          case "MDASI":
          case "alimentation":
          case "pain":
            if (to_hide === "healthforms") {
            new_display_healthforms = true
            }
            break
          case "niv":
          case "oxigen_therapy":
            if (to_hide === "modules") {
            new_display_modules = true
            }
            break
          case "tucky_smartphone":
            if (to_hide === "smartphone") {
            new_display_smartphone = true
            }
            break
        }
      }
      x++;
    }
    setDevicesVisible(new_display_devices)
    setModulesVisible(new_display_modules)
    setHealthformsVisible(new_display_healthforms)
    setSmartphoneVisible(new_display_smartphone)
  }

  // ###### INPUT ELEMENTS RENDERS ######

  //Function to render input components
  const renderInput = (type, nameID, defaultValue, min, max, step, precision, handleChange) => {
    if(type === "text"){
      return(<input type={type} id={nameID} name={nameID} defaultValue={defaultValue} style={{width: "100%", border: "1px solid gray"}} onChange={handleChange}/>)
    }
    else if(type === "number"){
      return(<input type="number" id={nameID} name={nameID} min={min} max={max} step={step} precision={precision} defaultValue={defaultValue} style={{width: "100%", border: "1px solid gray"}} onChange={handleChange}/>)
    }
    else{
      return null;
    }
  }
  

  // ###### SELECT ELEMENTS RENDERS ######

  const renderSelect = (nameID, list, defaultValue, handleChange, deviceType) => {
    if((nameID === "device1_add")||(nameID==="device2_add")||(nameID==="device3_add")||(nameID==="device4_add")||(nameID==="device5_add")){
      if (list[0] === undefined || list[0].id_device !== "dissociate") {
        if (nameID==="device5_add" && list.find((e) => e.id_device === "manual") === undefined) {
          list.unshift({ 'id_device':"manual", 'sn':"manual", 'nickname': manualAssociationMsg, 'fullname':manualAssociationMsg, 'type': 'NIV' });          
        }
        else if (nameID!=="device5_add") {
        list.unshift({ 'id_device':"dissociate", 'sn':"dissociate", 'nickname': '--', 'fullname':noAssociationMsg, 'type': 'none' });
      }
      }
      if (typeof(deviceType) !== "object") {
        deviceType = [deviceType]
      }
      return(
        <select id={nameID} name={nameID} defaultValue={defaultValue} style={{width: "100%", border: "1px solid gray", marginBottom:"1%"}} onChange={handleChange} disabled={nameID==="device5_add"}>
          {
            list.map((device,index)=> {
              let fullname
              if (device.sn !== "dissociate") {
                fullname = device.nickname + " (" + device.sn + ")"
              }
              else {
                fullname = device.nickname
              }
              if((deviceType.includes(device.type))||(device.type === 'none')){
                return (<option value={device.id_device} key={index}>{fullname}</option>);
              }
              else{
                return (null);
              }
            })
          }
        </select>
      )
    }

    //Case group select
    if(nameID === "group"){
      return(
        <select id={nameID} name={nameID} value={group.id_group} onChange={handleChangeGroup} style={{width: "100%", border: "1px solid gray"}}>
          {
              list.map((obj,index)=> {
                if (obj.id_group !== "monitored") {                  
                let key = props.profileData.Patient_Data.id_patient+"group"+index
                return <option value={obj.id_group} key={key}>{obj.group_name}</option>;
                }
              })
          }
        </select>
      )
    }

    //Case monitoring activation select
    else if(nameID ==="monitoring_activation"){
      return(
        <select id={nameID} name={nameID} defaultValue={defaultValue} style={{width: "100%", border: "1px solid gray"}} onChange={handleChange}>
          <FormattedMessage id="param.deactivated" key={props.profileData.Patient_Data.id_patient+"monitoring_activation"+"0"}>
             {(message) => <option value={"no"}>{message}</option>}
          </FormattedMessage>
          <option value={"smartphone"} key={props.profileData.Patient_Data.id_patient+"monitoring_activation"+"0"}>Smartphone</option>
          <option value={"gateway"} key={props.profileData.Patient_Data.id_patient+"monitoring_activation"+"0"}>Gateway</option>
        </select>
      )
    }

    //Case device select 
    else if((nameID === "device1")||(nameID==="device2")||(nameID==="device3")||(nameID==="device4")||(nameID==="device5")){
      if (nameID==="device5" && list.find((e) => e.id_device === "manual") === undefined) {
        list.unshift({ 'id_device':"manual", 'sn':"manual", 'nickname': manualAssociationMsg, 'fullname':manualAssociationMsg, 'type': 'NIV' });
      }
      if (list[0].id_device === "dissociate") {
        list.shift()
      }
      if (typeof(deviceType) !== "object") {
        deviceType = [deviceType]
      }
      return(
        <select id={nameID} name={nameID} value={selectedDeviceList[nameID].id} style={{width: "100%", border: "1px solid gray", marginBottom:"1%"}} onChange={handleChange} disabled={nameID==="device5" || props.profileData.Patient_Data.can_manage_devices === false}>
          {
              list.map((device,index)=> {
              if((deviceType.includes(device.type))||(device.type === 'none')){
                  let key = ""+props.profileData.Patient_Data.id_patient+"device"+device.type+index
                  return (<option value={device.id_device} key={key}>{device.nickname} ( {device.sn} )</option>);
                }
                else{
                  return (null);
                }
              })
          }
        </select>
      )
    }

    //Case gateway select
    else if(nameID === "gateway"){
      return(
        <select id={nameID} name={nameID} value={selectedGw.id_gw} onChange={handleChangeGateway} style={{width: "100%", border: "1px solid gray"}}>
          {
            list.map((gw,index)=> {
              return <option value={gw.id_gw} key={index}>{gw.fullname}</option>;
            })
          }
        </select>
      );
    }

    //Case position select
    else if(nameID === "position"){
      return(
        <select id={nameID} name={nameID} defaultValue={defaultValue} value={position} onChange={handleChangePosition} style={{width: "100%", border: "1px solid gray", marginBottom:"1%"}}>
          <FormattedMessage id="param.deactivated" key={props.profileData.Patient_Data.id_patient+"position"+"0"} defaultMessage="Deactivated">
             {(message) => <option value={"0"}>{message}</option>}
          </FormattedMessage>
          <FormattedMessage id="param.standupPosition" key={props.profileData.Patient_Data.id_patient+"position"+"1"} defaultMessage="At standing up">
             {(message) => <option value={"1"}>{message}</option>}
          </FormattedMessage>
          <FormattedMessage id="param.backPosition" key={props.profileData.Patient_Data.id_patient+"position"+"2"} defaultMessage="Dorsal decubitus">
             {(message) => <option value={"2"}>{message}</option>}
          </FormattedMessage>
          <FormattedMessage id="param.bellyPosition" key={props.profileData.Patient_Data.id_patient+"position"+"4"} defaultMessage="Ventral decubitus">
             {(message) => <option value={"4"}>{message}</option>}
          </FormattedMessage>
          <FormattedMessage id="param.sidePosition" key={props.profileData.Patient_Data.id_patient+"position"+"24"} defaultMessage="Lateral decubitus">
             {(message) => <option value={"24"}>{message}</option>}
          </FormattedMessage>
          <FormattedMessage id="param.allPosition" key={props.profileData.Patient_Data.id_patient+"position"+"31"} defaultMessage="At all position changes">
             {(message) => <option value={"31"}>{message}</option>}
          </FormattedMessage>
        </select>
      )
    }

    else{
      return null;
    }
  }


  // ###### SWITCH ELEMENTS RENDER ######

  const getSwitchCheckedIcon = (type) => {
    switch (type) {
      case "daynight":
        return (<Icon name='sun' inverted style={{position:'absolute', top:0, right:"0px"}}/>)
        break;
      default:
        return (
          <svg
            height="100%"
            width="100%"
            viewBox="-2 -5 17 21"
            style={{ position: "absolute", top: 0 }}
          >
            <path
              d="M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0"
              fill="#fff"
              fillRule="evenodd"
      />
          </svg>
        )
        break;
    }
  }

  const getSwitchUncheckedIcon = (type) => {
    switch (type) {
      case "daynight":
        return (<Icon name='moon' inverted style={{position:'absolute', top:"0px", right:"0px"}}/>)
        break;
      default:
        return (
          <svg
            viewBox="-2 -5 14 20"
            height="100%"
            width="100%"
            style={{ position: "absolute", top: 0 }}
          >
            <path
              d="M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12"
              fill="#fff"
              fillRule="evenodd"
            />
          </svg>
        )
        break;
    }
  }

  const getSwitchOncolor = (type) => {
    switch (type) {
      case "daynight":
        return ("#F1C72A")
        break;
      case "disabled":
        return ("#888")
        break;
      default:
        return ("#080")
        break;
    }
  }

  const getSwitchOffcolor = (type) => {
    switch (type) {
      case "daynight":
        return ("#30677F")
        break;
      default:
        return ("#888")
        break;
    }
  }

  //Function to render switch elements
  const renderSwitch = (ID, handleChange, checked, type) => {
    let this_oncolor = getSwitchOncolor(type)
    let this_offcolor = getSwitchOffcolor(type)
    let this_checkedIcon = getSwitchCheckedIcon(type)
    let this_uncheckedIcon = getSwitchUncheckedIcon(type)
    return(
      <Switch
        id={ID}
        onChange={handleChange}
        checked={checked}
        className="react-switch"
        height = {20}
        width = {46}
        onColor = {this_oncolor}
        offColor = {this_offcolor}
        checkedIcon = {this_checkedIcon}
        uncheckedIcon = {this_uncheckedIcon}
        disabled = {type === "disabled"}
      />
    );
  }

  const titleCase = str =>
    str.split(/\s+/).map(w => w[0].toUpperCase() + w.slice(1)).join(' ');

  const ClickableLabel = ({ title, onChange, id }) =>
    <SwitchLabel onClick={() => onChange(title)} className={id}>
      {title}
    </SwitchLabel>;

  const ConcealedRadio = ({ value, selected }) => 
    <SwitchRadio type="radio" name="switch" checked={selected === value} />;

  const selectionStyle = (liste_monitoring) => {
    return {
      left: `${liste_monitoring.indexOf(liste_monitoring.find(item => item.id === props.displayDevicesParams)) / 3 * 100}%`,
    };
  };

  const handleSwitchChange = async (val) => {
    // No device management right on a shared patient: ignore changes (backend also enforces).
    if (props.profileData.Patient_Data.can_manage_devices === false) return;
    let new_id
    if (val) {
      if (props.profileData.Patient_Data.niv_provider !== "internal") {
        let id_device = await PatientFunctionsGetter.prismacloudPatientById(props.profileData.Patient_Data.id_patient)
        if (id_device !== undefined) {
          let new_selected_device_list = selectedDeviceList
          new_selected_device_list.device5.id_old = "dissociate"
          new_selected_device_list.device5.id = id_device
          setSelectedDeviceList(new_selected_device_list);
          if (props.profileData.Patient_Data.niv_provider === "lowenstein" || props.profileData.Patient_Data.niv_provider === "resmed") {
            let x = 0;
            while (props.profileData.Patient_Data.module_activation[x]) {
              if (props.profileData.Patient_Data.module_activation[x].name === "niv") {
                props.profileData.Patient_Data.module_activation[x].used = true
              }
              x++;
            }
            setModuleActivation(props.profileData.Patient_Data.module_activation)
          }
        }
      }

      if (props.profileData.Patient_Data.monitoring_activation !== undefined && props.profileData.Patient_Data.monitoring_activation === "gateway") {
        new_id = "gateway"
      }
      else {
        new_id = "no_device"
      }
    }
    else {
      if (props.profileData.Patient_Data.niv_provider !== "internal") {
        let new_selected_device_list = selectedDeviceList
        new_selected_device_list.device5.id_old = new_selected_device_list.device5.id
        new_selected_device_list.device5.id = "dissociate"
        setSelectedDeviceList(new_selected_device_list);
      }
      new_id = "no"
      var result = effectiveGwList.filter(obj => {
        return obj.id_gw === "dissociate"
      })
    }
    props.changeDisplayDevices(new_id);
    setDisplayAlertModes(!displayAlertModes)
    props.setChangeOngoing(true)
  };

  const checkDisplayDeviceParams = () => {
    if (props.displayDevicesParams === "no"){
      return false;
    }
    else {
      return true;
    }
  };

  const createSwitchMonitoring = () => {
    let switch_id = "monitoring" + props.profileData.Patient_Data.id_patient
    return (
      <center>
        <MonitoringSwitch
          id={switch_id}
          checked={checkDisplayDeviceParams()}
          onChange={handleSwitchChange}
        />
      </center>
      )
  }

  const handleClickButton = () => {
    setDisplayAddDevicePopup(!displayAddDevicePopup)
  }

  const handleNewPhoneNumberNotif = () => {
    let number_list = [...smsalert]
    number_list.unshift("");
    setSmsalert(number_list)
    props.setChangeOngoing(true);
  }

  const handleNewPhoneNumberReminderFirst = () => {
    let number_list = [...reminderFirstPhone]
    number_list.unshift("");
    setReminderFirstPhone(number_list)
    props.setChangeOngoing(true);
  }

  const findSetCheckedReminder = (type) => {
    let ret;

    switch (type) {
      case "tucky_reminder":
        ret = handleChangeReminderTuckyCheck;
        break
      case "oximeter_reminder":
        ret = handleChangeReminderOximeterCheck;
        break
      case "tensiometer_reminder":
        ret = handleChangeReminderTensiometerCheck;
        break
      case "scale_reminder":
        ret = handleChangeReminderScaleCheck;
        break
      case "healthform_reminder_eq5d":
        ret = handleChangeReminderHealthformEQ5DCheck;
        break
      case "healthform_reminder_sf36":
        ret = handleChangeReminderHealthformSF36Check;
        break
      case "healthform_reminder_mdasi":
        ret = handleChangeReminderHealthformMDASICheck;
        break
      case "healthform_reminder_alimentation":
        ret = handleChangeReminderHealthformAlimentationCheck;
        break
      case "pain_reminder":
        ret = handleChangeReminderPainCheck;
        break
      case "niv_reminder":
        ret = handleChangeReminderNivCheck;
        break
      case "oxi_reminder":
        ret = handleChangeReminderOxiCheck;
        break
    }

    return ret
  }

  const findCheckedReminder = (type) => {
    let ret;

    switch (type) {
      case "tucky_reminder":
        ret = checkedReminderTucky;
        break
      case "oximeter_reminder":
        ret = checkedReminderOximeter;
        break
      case "tensiometer_reminder":
        ret = checkedReminderTensiometer;
        break
      case "scale_reminder":
        ret = checkedReminderScale;
        break
      case "healthform_reminder_eq5d":
        ret = checkedReminderEQ5D;
        break
      case "healthform_reminder_sf36":
        ret = checkedReminderSF36;
        break
      case "healthform_reminder_mdasi":
        ret = checkedReminderMDASI;
        break
      case "healthform_reminder_alimentation":
        ret = checkedReminderAlimentation;
        break
      case "pain_reminder":
        ret = checkedReminderPain;
        break
      case "niv_reminder":
        ret = checkedReminderNiv;
        break
      case "oxi_reminder":
        ret = checkedReminderOxi;
        break
    }

    return ret
  }

  const handleClickButtonDelete = (event, type) => {
    setReminderToDelete(Utils.deviceTypeToReminderType(type))
    setDeleteDeviceID(event.target.id)
    if (type === "Tucky_smartphone") {
      setDeleteDeviceID("tucky_smartphone")
    }
    setDisplayDeleteDevicePopup(!displayDeleteDevicePopup)
  }

  const handleClickButtonDeletePhoneNumber = (event) => {
    let index_changed = event.target.id.split("sms_alert")[1]
    let new_sms_alert = [...smsalert];
    new_sms_alert.splice(index_changed, 1)
    if (typeof(new_sms_alert[0]) === "undefined") {
      new_sms_alert[0] = '';
    }
    setSmsalert(new_sms_alert);
    props.setChangeOngoing(true)
  }

  const handleClickButtonDeleteReminderFirstPhone = (event, index) => {
    let new_list = [...reminderFirstPhone];
    new_list.slice() //the slice is needed to make react understand that reminderFirstPhone is updated
    new_list.splice(index, 1)
    setReminderFirstPhone(new_list);
    props.setChangeOngoing(true)
  }

  const handleClickButtonDeleteReminder = (type) => {
    let new_reminder = checkedReminderList
    let i = 0
    while (new_reminder[i]) {
      if (new_reminder[i].alert_type === type) {
        new_reminder.splice(i, 1);
      }
      i++;
    }
    setCheckedReminderList(new_reminder)
    props.setChangeOngoing(true)
  }

  const handleClickButtonUpdateReminder = (type) => {
    setNewReminder(type)
    setDisplayNewReminder(true)
  }

  // ###### ROW ELEMENTS RENDERS ######

  //Function to return row with device selector
  const renderDeviceSelectRow = (nameID, list, defaultValue, handleDisplay, deviceType, titleID, defaultTitle) => {
    return(
      <Row style={{paddingBottom:"2%"}}>
        {titleID !== "" ?
        <Col style={{maxWidth:"20%"}}>
          <FormattedMessage id={titleID} defaultMessage={defaultTitle}/>
        </Col>
          :
          <Col style={{maxWidth:"20%"}}>
          </Col>
        }
        <Col style={{maxWidth:"70%"}}>
          {renderSelect(nameID, list, defaultValue, handleDisplay, deviceType)}
        </Col>
      </Row>
    )
  }

  const getNewReminderHour = (type) => {
    let ret = "";
    let i = 0;
    while (newReminderHours[i] && ret === "") {
      if (newReminderHours[i].type === type) {
        ret = newReminderHours[i].value
      }
      i++;
    }
    return (ret)
  }

  const testHoursDisabled = (hours_number) => {
    let ret = false;

    if (hours_number >= 4) {
      ret = true;
    }

    return ret
  }


  const renderReminderRow = (titleID, defaultTitle, alertName, handleSwitchChange, isChecked, type) => {
    let hours_number = 0
    let input_value = 2
    let tooltip_id = "tooltip-reminder-" + props.profileData.Patient_Data.id_patient + "-" + type
    let tooltip_id_reminder_delay = "tooltip-reminder-" + props.profileData.Patient_Data.id_patient + "-" + type + "-" + alertName + "_delay"
    if (type === "disabled" && checkedReminderList.find(function(element){return(element.alert_type===alertName)}) === undefined) {
      let new_checked_reminder_list = checkedReminderList
      new_checked_reminder_list.push({alert_type: alertName, alert_hours: "--:--", time_margin: 2, last_search: "none"})
      setCheckedReminderList(new_checked_reminder_list)
    }
    return (
      <Row>
        <Col style={{maxWidth:"35%"}}>
        <Row style={{paddingRight:"0px"}}>
          <Tooltip style={{ zIndex: 99 }} id={tooltip_id}>
            {props.select_tooltip("param.reminderMode.tooltip")}
          </Tooltip>
          <Tooltip style={{ zIndex: 99 }} id={tooltip_id_reminder_delay}>
            {props.select_tooltip("param.reminderMode.tooltip.reminder.delay")}
          </Tooltip>
            <Col style={{textAlign:"left", width:"14%"}} data-tooltip-id={tooltip_id} data-tooltip-place="bottom">
            <FormattedMessage id={titleID} defaultMessage={defaultTitle}/>
          </Col>
            <Col style={{textAlign:"right"}}>
              {renderSwitch(alertName, handleSwitchChange, isChecked, type)}
          </Col>
          </Row>
        </Col>
        <Col>
          <Row style={{paddingRight:"0px"}}>
            {isChecked && checkedReminderList.find(function(element){return(element.alert_type===alertName)}) !== undefined ?
            <Col style={{paddingRight:"0px"}}>
            {
                checkedReminderList.find(function(element){return(element.alert_type===alertName)}).alert_hours.split(",").map((obj,index)=> {
                let key = "reminder_time_margin_"+index
                  if (checkedReminderList.find(function(element){return(element.alert_type===alertName)}) !== undefined) {
                    hours_number = checkedReminderList.find(function(element){return(element.alert_type===alertName)}).alert_hours.split(",").length
                    input_value = checkedReminderList.find(function(element){return(element.alert_type===alertName)}).time_margin
                  }
                  return (
                    <Row style={{paddingRight:"0px"}}>
                      <Col style={{textAlign:"left", paddingLeft:"20px", paddingRight:"0px", maxWidth:"38%"}}>
                        <input type="time" id="start_hour" key={key} name="{props.profileData.Patient_Data.alerts.reminder_alert}" value={obj} style={{border: "1px solid gray", width: "100%"}} onChange={event => handleChangeReminderHours(event.target.value, index, alertName)}/>
                  </Col>
                  {index === 0 ?
                        <Col style={{textAlign:"right", paddingLeft:"10px", paddingRight:"0px", maxWidth:"35%"}} data-tooltip-id={tooltip_id_reminder_delay} data-tooltip-place="bottom">
                          <FormattedMessage id="popup.reminder.time_margin" defaultMessage="+/-"/>
                    </Col>
                    :
                        <Col style={{textAlign:"left", paddingLeft:"10px", paddingRight:"0px", maxWidth:"35%"}}>
                          <button onClick={() => deleteHours(index, alertName)} style={{ padding:0, border:"0px", backgroundColor:"white"}}>
                        <Icon name='minus' size='small' color='red' style={{margin:"0px"}}/>
                      </button>
                    </Col>
                  }
                  {index === 0 ?
                        <Col style={{textAlign:"left", paddingLeft:"10px", paddingRight:"10px", maxWidth:"23%"}} data-tooltip-id={tooltip_id_reminder_delay} data-tooltip-place="bottom">
                          <input type="number" id={type+"_frequency"} name={type+"_frequency"} value={input_value} defaultValue={2}  min={1} max={100} step={1} precision={1} style={{border: "1px solid gray", width:"100%"}} onChange={() => handleChangeReminderFrequency(event, alertName)}/>
                    </Col>
                    :
                        <Col style={{textAlign:"left", paddingLeft:"10px", paddingRight:"10px", maxWidth:"23%"}}>
                    </Col>
                  }
                </Row>
                  )
              })
            }
            </Col>
            :
            null
          }
        </Row>
        </Col>
        {isChecked && checkedReminderList.find(function(element){return(element.alert_type===alertName)}) !== undefined ?
          <Row>
            <Col style={{textAlign:"left", paddingLeft:"0px", paddingRight:"0px"}}>
            </Col>
            <Col style={{textAlign:"left", paddingLeft:"0px", paddingRight:"0px"}}>
              {testHoursDisabled(hours_number) ?
                null
                :
                <button onClick={() => addNewHours(getNewReminderHour(alertName), alertName)} style={{ padding:0, border:"0px", backgroundColor:"white"}}>
                  <Icon id="id" name='add' size='small' color='green' style={{margin:"0px"}} class/>
              </button>
              }
            </Col>
          </Row>
          :
          null
        }
      </Row>
    )
  }

  const deleteThreshold = (alert) => {
    let new_alert
    switch (alert.type) {
      case "fever_alert":
        new_alert = feverAlert
        delete new_alert.threshold2
        delete new_alert.sup_or_inf2
        setFeverAlert(new_alert)
        break
      case "PR_alert":
        new_alert = PRAlert
        delete new_alert.threshold2
        delete new_alert.sup_or_inf2
        setPRAlert(new_alert)
        break
      case "SPO2_alert":
        new_alert = SPO2Alert
        delete new_alert.threshold2
        delete new_alert.sup_or_inf2
        setSPO2Alert(new_alert)
        break
      case "bloodpressure_PR_alert":
        new_alert = PRTensionAlert
        delete new_alert.threshold2
        delete new_alert.sup_or_inf2
        setPRTensionAlert(new_alert)
        break
      case "bloodpressure_sys_high_alert":
        new_alert = systolicHighAlert
        delete new_alert.threshold2
        delete new_alert.sup_or_inf2
        setSystolicHighAlert(new_alert)
        break
      case "bloodpressure_dia_alert":
        new_alert = diastolicHighAlert
        delete new_alert.threshold2
        delete new_alert.sup_or_inf2
        setDiastolicHighAlert(new_alert)
        break
      case "weight_alert":
        new_alert = weightAlert
        delete new_alert.threshold2
        delete new_alert.sup_or_inf2
        setWeightAlert(new_alert)
        break
      case "pain_alert":
        new_alert = painAlert
        delete new_alert.threshold2
        delete new_alert.sup_or_inf2
        setPainAlert(new_alert)
        break
      case "breathing_rate_alert":
        new_alert = breathingAlert
        delete new_alert.threshold2
        delete new_alert.sup_or_inf2
        setBreathingAlert(new_alert)
        break
      case "breathing_oxygen_rate_alert":
        new_alert = breathingOxygenRateAlert
        delete new_alert.threshold2
        delete new_alert.sup_or_inf2
        setBreathingOxygenRateAlert(new_alert)
        break
      case "breathing_leakage_alert":
        new_alert = breathingLeakageAlert
        delete new_alert.threshold2
        delete new_alert.sup_or_inf2
        setBreathingLeakageAlert(new_alert)
        break
      case "breathing_leakage95_alert":
        new_alert = breathingLeakage95Alert
        delete new_alert.threshold2
        delete new_alert.sup_or_inf2
        setBreathingLeakage95Alert(new_alert)
        break
      case "breathing_ahi_alert":
        new_alert = breathingAhiAlert
        delete new_alert.threshold2
        delete new_alert.sup_or_inf2
        setBreathingAhiAlert(new_alert)
        break
    }
    props.setChangeOngoing(true)
    setRerender(!rerender)
  }

  const addThreshold = (alert) => {
    let new_alert
    switch (alert.type) {
      case "fever_alert":
        new_alert = feverAlert
        new_alert.sup_or_inf2 = "inf"
        new_alert.threshold2 = 34
        setFeverAlert(new_alert)
        break
      case "PR_alert":
        new_alert = PRAlert
        new_alert.sup_or_inf2 = "inf"
        new_alert.threshold2 = 50
        setPRAlert(new_alert)
        break
      case "SPO2_alert":
        new_alert = SPO2Alert
        new_alert.sup_or_inf2 = "sup"
        new_alert.threshold2 = 90
        setSPO2Alert(new_alert)
        break
      case "bloodpressure_PR_alert":
        new_alert = PRTensionAlert
        new_alert.sup_or_inf2 = "inf"
        new_alert.threshold2 = 50
        setPRTensionAlert(new_alert)
        break
      case "bloodpressure_sys_high_alert":
        new_alert = systolicHighAlert
        new_alert.sup_or_inf2 = "inf"
        new_alert.threshold2 = 70
        setSystolicHighAlert(new_alert)
        break
      case "bloodpressure_dia_alert":
        new_alert = diastolicHighAlert
        new_alert.sup_or_inf2 = "inf"
        new_alert.threshold2 = 70
        setDiastolicHighAlert(new_alert)
        break
      case "weight_alert":
        new_alert = weightAlert
        new_alert.sup_or_inf2 = "inf"
        new_alert.threshold2 = 40
        setWeightAlert(new_alert)
        break
      case "pain_alert":
        new_alert = painAlert
        new_alert.sup_or_inf2 = "inf"
        new_alert.threshold2 = 4
        setPainAlert(new_alert)
        break
      case "breathing_rate_alert":
        new_alert = breathingAlert
        new_alert.sup_or_inf2 = "inf"
        new_alert.threshold2 = 20
        setBreathingAlert(new_alert)
        break
      case "breathing_oxygen_rate_alert":
        new_alert = breathingOxygenRateAlert
        new_alert.sup_or_inf2 = "inf"
        new_alert.threshold2 = 1
        setBreathingOxygenRateAlert(new_alert)
        break
      case "breathing_leakage_alert":
        new_alert = breathingLeakageAlert
        new_alert.sup_or_inf2 = "inf"
        new_alert.threshold2 = 1
        setBreathingLeakageAlert(new_alert)
        break
      case "breathing_leakage95_alert":
        new_alert = breathingLeakage95Alert
        new_alert.sup_or_inf2 = "inf"
        new_alert.threshold2 = 1
        setBreathingLeakage95Alert(new_alert)
        break
      case "breathing_ahi_alert":
        new_alert = breathingAhiAlert
        new_alert.sup_or_inf2 = "inf"
        new_alert.threshold2 = 1
        setBreathingAhiAlert(new_alert)
        break
    }
    props.setChangeOngoing(true)
    setRerender(!rerender)
  }

  const getNoThreshold2AlertList = (alertName) => {
    let ret = true
    switch (alertName) {
      case "spo2":
      case "healthformAlert":
      case "healthformScaleAlert":
      case "breathingLeakageAlert":
      case "breathingObservanceAlert":
        ret = false
    }
    return ret
  }

  //Function to generate threshold2 row
  const renderThreshold2Row = (alertParams, isChecked, alertName, addThreshold, handleThresholdChange2, deleteThreshold, unit) => {
    const threshold2RowStyle = { display: "grid", gridTemplateColumns: "16px 58px max-content 20px", columnGap: "4px", alignItems: "center", width: "max-content", maxWidth: "100%", margin: 0 }
    const threshold2IconStyle = { display: "flex", alignItems: "center", justifyContent: "center", minWidth: 0 }
    const threshold2InputStyle = { minWidth: 0 }
    const threshold2UnitStyle = { whiteSpace: "nowrap", minWidth: "max-content" }
    const threshold2DeleteStyle = { width: "20px", height: "20px", padding: 0, border: 0, background: "transparent", display: "inline-flex", alignItems: "center", justifyContent: "center", cursor: "pointer", lineHeight: 1 }

    return (
      <Row>
        {(alertParams.threshold2 === undefined || alertParams.threshold2.defaut === null || alertParams.sup_or_inf2 === undefined) ?
        <Row>
          <Col>
            <Row>
              <Col style={{maxWidth:"6%"}}>
              </Col>
              <Col>
                {isChecked === true && getNoThreshold2AlertList(alertName) ?
                  <Icon name='plus' size='small' color='green' style={{margin:"0px", padding:0}} onClick={(e) => addThreshold(alertParams)}/>
                    :
                  null
                }
              </Col>
            </Row>
          </Col>
        </Row>
        :
          <Row>
            {isChecked && getNoThreshold2AlertList(alertName) ?
              <Col>
                <div style={threshold2RowStyle}>
                  <div style={threshold2IconStyle}>
                    {alertParams.sup_or_inf2 === "sup" ?
                      <Icon name='chevron right' size='small' style={{margin:"0px"}}/>
                      :
                      <Icon name='chevron left' size='small' style={{margin:"0px"}}/>
                    }
                  </div>
                  <div style={threshold2InputStyle}>
                    {renderInput("number", alertName + "_threshold2", alertParams.threshold2.defaut, alertParams.threshold2.min, alertParams.threshold2.max, alertParams.threshold2.step, alertParams.threshold2.precision, handleThresholdChange2)}
                  </div>
                  <div style={threshold2UnitStyle}>
                    <FormattedMessage id={unit.id} defaultMessage={unit.defaultMessage} />
                  </div>
                  <button type="button" style={threshold2DeleteStyle} onClick={(e) => deleteThreshold(alertParams)}>
                    <Icon name='minus' size='small' color='red' style={{margin:"0px", padding:0}}/>
                  </button>
                </div>
              </Col>
            :
              null
            }
          </Row>
        }
      </Row>
    )
  }


  // Duration-condition popup ("threshold exceeded X times over a period of N hour(s)/day(s)/week(s)").
  // The fields are wired to the per-type alert state and persisted on save; nothing is
  // written until the practitioner actually edits a field (absent keys = legacy immediate alert).
  const renderDurationCondition = (alertName, alertParams) => {
    const alertType = (alertParams && alertParams.type) || alertName
    const [liveParams] = alertStateByType[alertType] || [{}]
    const params = liveParams || {}
    const displayed = getDisplayedDurationCondition(params)
    const displayCount = displayed.count
    const displayWindow = displayed.window
    const displayPeriod = displayed.period
    const displayRest = getRestDurationValue(alertType, params)

    // Feasibility checks (minute-based windows only, count >= 2): counting X exceedances spaced
    // >= rest apart needs a window of at least X*rest + 2 min, and the engine evaluates every 90 s
    // so very short windows are unreliable. The gap info is hidden entirely for a window of 1.
    const countNum = parseInt(displayCount) || 1
    const windowMinutes = getWindowMinutes(displayWindow, displayPeriod)
    const restMinutes = parseFloat(displayRest) || 0
    const minutePeriod = isMinuteWindow(displayPeriod)
    // A single required occurrence has no "gap between two readings" to configure -> hide it.
    const hideGapInfo = countNum === 1
    const showGapChecks = minutePeriod && !hideGapInfo
    const minRestMinutes = getMinRestDuration(countNum, displayPeriod)
    const minWindowMinutes = (countNum * restMinutes) + WINDOW_SAFETY_MINUTES
    const restTooSmall = showGapChecks && restMinutes < minRestMinutes
    const restConflict = showGapChecks && countNum >= 2 && windowMinutes > 0 && (countNum * restMinutes) > (windowMinutes - WINDOW_SAFETY_MINUTES)
    const minEngineWindowMinutes = Math.ceil(countNum * ENGINE_EVALUATION_MINUTES)
    const engineTooSmall = showGapChecks && !restConflict && countNum >= 1 && windowMinutes > 0 && (windowMinutes / countNum) < ENGINE_EVALUATION_MINUTES
    const hasDurationWarning = restTooSmall || restConflict || engineTooSmall

    const inputStyle = { width: "36px", border: "1px solid #7aade0", borderRadius: "3px", textAlign: "center", padding: "1px 2px", fontSize: "inherit" }
    const errorBorder = "1px solid #d9534f"
    const errorInputStyle = { ...inputStyle, border: errorBorder, backgroundColor: "#fff4f4", color: "#9f1d1d" }
    const windowInputStyle = hasDurationWarning ? errorInputStyle : inputStyle
    const restInputStyle = (restTooSmall || restConflict) ? { ...errorInputStyle, width: "48px" } : { ...inputStyle, width: "48px" }
    const selectStyle = { border: "1px solid #7aade0", borderRadius: "3px", padding: "1px 2px", fontSize: "inherit" }
    const warningStyle = { flexBasis: "100%", color: "#c0392b", fontSize: "0.9em", fontWeight: 600, textAlign: "right", lineHeight: 1.25 }
    const isOpen = openDurationCondition && openDurationCondition.alertName === alertName
    const buttonStyle = { cursor: "pointer", userSelect: "none", fontSize: "0.9em", color: "#5b8fc9", background: "transparent", border: 0, padding: 0, textAlign: "right" }
    const popup = isOpen && typeof document !== "undefined" ? createPortal(
      <div
        data-duration-condition-popup="true"
        role="dialog"
        aria-label={intl.formatMessage({ id: "param.alertCondition" })}
        style={{ position: "fixed", top: openDurationCondition.top, left: openDurationCondition.left, width: openDurationCondition.width, zIndex: 2200, display: "flex", alignItems: "center", justifyContent: "flex-end", flexWrap: "wrap", gap: "4px", maxWidth: "calc(100vw - 24px)", fontSize: "0.94em", color: hasDurationWarning ? "#8a1f1f" : "#2c4f7c", padding: "6px 8px", backgroundColor: hasDurationWarning ? "#fff5f5" : "#ddeeff", borderRadius: "4px", border: hasDurationWarning ? errorBorder : "1px solid #9bbfe0", boxShadow: "0 6px 18px rgba(0,0,0,0.18)" }}
      >
        <span>{intl.formatMessage({ id: "param.alertCondition.prefix" })}</span>
        <input
          type="number"
          id={alertName + "_threshold_exceeded_count"}
          name="threshold_exceeded_count"
          value={displayCount}
          min={1}
          onChange={(event) => handleDurationConditionChange(alertType, "threshold_exceeded_count", event.target.value)}
          style={inputStyle}
        />
        <span>{intl.formatMessage({ id: "param.alertCondition.times" })}</span>
        <input
          type="number"
          id={alertName + "_threshold_exceedance_window"}
          name="threshold_exceedance_window"
          value={displayWindow}
          min={1}
          onChange={(event) => handleDurationConditionChange(alertType, "threshold_exceedance_window", event.target.value)}
          style={windowInputStyle}
        />
        <select
          id={alertName + "_threshold_exceedance_period"}
          name="threshold_exceedance_period"
          value={displayPeriod}
          onChange={(event) => handleDurationConditionChange(alertType, "threshold_exceedance_period", event.target.value)}
          style={selectStyle}
        >
          <option value="minute">{intl.formatMessage({ id: "param.alertCondition.minute" })}</option>
          <option value="hour">{intl.formatMessage({ id: "param.alertCondition.hour" })}</option>
          <option value="day">{intl.formatMessage({ id: "param.alertCondition.day" })}</option>
          <option value="week">{intl.formatMessage({ id: "param.alertCondition.week" })}</option>
        </select>
        {!hideGapInfo &&
          <>
            <span>{intl.formatMessage({ id: "param.alertCondition.rest" })}</span>
            <input
              type="number"
              id={alertName + "_rest_duration"}
              name="rest_duration"
              value={displayRest}
              min={minRestMinutes}
              step={REST_DURATION_STEP_MINUTES}
              onChange={(event) => handleDurationConditionChange(alertType, "rest_duration", event.target.value)}
              style={restInputStyle}
            />
            {restTooSmall &&
              <div style={warningStyle}>
                {intl.formatMessage({ id: "param.alertCondition.warning.restMin" }, { count: countNum, min: minRestMinutes })}
              </div>
            }
            {restConflict &&
              <div style={warningStyle}>
                {intl.formatMessage({ id: "param.alertCondition.warning.rest" }, { count: countNum, rest: restMinutes, min: minWindowMinutes })}
              </div>
            }
            {engineTooSmall &&
              <div style={warningStyle}>
                {intl.formatMessage({ id: "param.alertCondition.warning.engine" }, { count: countNum, min: minEngineWindowMinutes })}
              </div>
            }
          </>
        }
      </div>,
      document.body
    ) : null

    return (
      <div data-duration-condition-popup="true" style={{ display: "flex", justifyContent: "flex-end", marginTop: "2px", marginBottom: "2px" }}>
        <button
          type="button"
          aria-expanded={Boolean(isOpen)}
          aria-haspopup="dialog"
          onClick={(event) => toggleDurationConditionPopup(alertName, event)}
          style={buttonStyle}
        >
          ⚙ {intl.formatMessage({ id: "param.alertCondition" })}
        </button>
        {popup}
      </div>
    )
  }

  //Function to return row with threshold and delay params
  const renderAlertThreshold = (titleID, defaultTitle, alertName, handleSwitchChange, handleThresholdChange, isChecked, alertParams, handleThresholdChange2, tooltip) => {
    let unit = Utils.convertTextToFormattedMessageIdUnits(alertParams.type)
    let threshold2_activated = Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("threshold2"))
    let tooltip_delay_id = "tooltip-delay-" + props.profileData.Patient_Data.id_patient + "-" + alertName
    return(
      <div>
      <Row>
        <Col style={{maxWidth:"30%", paddingRight:"0px"}}>
          <FormattedMessage id={titleID} defaultMessage={defaultTitle}/>
          {tooltip && (
            <span
              title={intl.formatMessage({id: tooltip.id, defaultMessage: tooltip.defaultMessage})}
              style={{marginLeft: 4, color: '#1976d2', cursor: 'help', fontSize: '0.8em', verticalAlign: 'middle'}}
            >ℹ</span>
          )}
        </Col>

        <Col style={{maxWidth:"17%"}}>
          {renderSwitch(alertName, handleSwitchChange, isChecked)}
        </Col>
        {isChecked ?
          <Col>
            <Row>
              <Col style={{maxWidth:"6%"}}>
                {alertParams.sup_or_inf === "sup" ?
                  <Icon name='chevron right' size='small' style={{margin:"0px"}}/>
                  :
                  <Icon name='chevron left' size='small' style={{margin:"0px"}}/>
                }
              </Col>

              <Col style={{maxWidth:"30%", paddingRight:"0px", paddingLeft:"1%"}}>
                {renderInput("number", alertName + "_threshold", alertParams.threshold.defaut, alertParams.threshold.min, alertParams.threshold.max, alertParams.threshold.step, alertParams.threshold.precision, handleThresholdChange)}
              </Col>

              <Col style={{maxWidth:"26%", paddingLeft:"1%"}}>
                <FormattedMessage id={unit.id} defaultMessage={unit.defaultMessage} />
              </Col>
            </Row>
            <Row>
              {threshold2_activated ?
                <div>
                  {renderThreshold2Row(alertParams, isChecked, alertName, addThreshold, handleThresholdChange2, deleteThreshold, unit)}
                </div>
                :
                null
              }
            </Row>
            {renderDurationCondition(alertName, alertParams)}
          </Col>
          :
          null
        }
      </Row>
      </div>
    );
  }

  //Function to return row with threshold and delay params
  const renderAlertThresholdAndDelayRow = (titleID, defaultTitle, alertName, handleSwitchChange, handleThresholdChange, handleDelayChange, isChecked, alertParams, handleThresholdChange2) => {
    let unit = Utils.convertTextToFormattedMessageIdUnits(alertParams.type)
    let threshold2_activated = Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("threshold2"))
    let tooltip_delay_id = "tooltip-delay-" + props.profileData.Patient_Data.id_patient + "-" + alertName
    return(
          <div>
          <Row>
        <Col style={{maxWidth:"20%", paddingRight:"0px"}}>
            <FormattedMessage id={titleID} defaultMessage={defaultTitle}/>
            </Col>

        <Col style={{maxWidth:"17%"}}>
            {renderSwitch(alertName, handleSwitchChange, isChecked)}
            </Col>
          {isChecked ?
              <Col>
                <Row>
                  <Col style={{maxWidth:"6%"}}>
                  {alertParams.sup_or_inf === "sup" ?
                    <Icon name='chevron right' size='small' style={{margin:"0px"}}/>
                    :
                    <Icon name='chevron left' size='small' style={{margin:"0px"}}/>
                  }
                  </Col>

              <Col style={{maxWidth:"30%", paddingRight:"0px", paddingLeft:"1%"}}>
                  {renderInput("number", alertName + "_threshold", alertParams.threshold.defaut, alertParams.threshold.min, alertParams.threshold.max, alertParams.threshold.step, alertParams.threshold.precision, handleThresholdChange)}
                  </Col>
              
              <Col style={{maxWidth:"26%", paddingLeft:"1%"}}>
                    <FormattedMessage id={unit.id} defaultMessage={unit.defaultMessage} />
                  </Col>
            </Row>
              <Row>
          {threshold2_activated ?
            <div>
              {renderThreshold2Row(alertParams, isChecked, alertName, addThreshold, handleThresholdChange2, deleteThreshold, unit)}
            </div>
            :
            null
        }
              </Row>
            {renderDurationCondition(alertName, alertParams)}
            </Col>
            :
            null
          }
      </Row>
      </div>
    );
  }

  //Function to return row with threshold and delay params
  const renderAlertThresholdAndDelayRowNoCheck = (titleID, defaultTitle, alertName, handleSwitchChange, handleThresholdChange, handleDelayChange, alertParams) => {
    let unit = Utils.convertTextToFormattedMessageIdUnits(alertParams.type)
    let tooltip_delay_id = "tooltip-delay-" + props.profileData.Patient_Data.id_patient + "-" + alertName
    return(
      <Row style={{paddingBottom:"1%"}}>
        <Row>
          <Col style={{maxWidth:"20%"}}>
            <FormattedMessage id={titleID} defaultMessage={defaultTitle}/>
          </Col>
          <Col>
            <Row>
              <Col style={{maxWidth:"6%"}}>
                {alertParams.sup_or_inf === "sup" ?
                  <Icon name='chevron right' size='small' style={{margin:"0px"}}/>
                  :
                  <Icon name='chevron left' size='small' style={{margin:"0px"}}/>
                }
              </Col>
              <Col style={{maxWidth:"28%", paddingRight:"0px"}}>
                {renderInput("number", alertName + "_threshold", alertParams.threshold.defaut, alertParams.threshold.min, alertParams.threshold.max, alertParams.threshold.step, alertParams.threshold.precision, handleThresholdChange)}
              </Col>
              <Col style={{maxWidth:"18%"}}>
                <FormattedMessage id={unit.id} defaultMessage={unit.defaultMessage} />
              </Col>
            </Row>
            {renderDurationCondition(alertName, alertParams)}
          </Col>
        </Row>
      </Row>     
    );
  }

  //Function to return row with only select element
  const renderAlertSelectRow = (titleID, defaultTitle) => {
    return(
      <Row>
        <Col style={{maxWidth:"30%"}}>
          <FormattedMessage id={titleID} defaultMessage={defaultTitle}/>
        </Col>
        <Col style={{maxWidth:"60%"}}>
          {renderSelect("position", [], props.profileData.Patient_Data.alerts.pos_alert.threshold, "", "")}
        </Col>
      </Row>
    );
  }

  //Function to return row with only switch element
  const renderAlertSwitchRow = (titleID, defaultTitle, alertType, handleChange, checked) => {
    return(
      <Row>
        <Col style={{maxWidth:"30%"}}>
          <FormattedMessage id={titleID} defaultMessage={defaultTitle}/>
        </Col>
        <Col style={{maxWidth:"70%"}}>
          {renderSwitch(alertType, handleChange, checked)}
        </Col>
      </Row>
    );
  }


  // ###### COMPONENTS ELEMENTS ######

  //Function to render patient identification elements
  const renderPatientIdentificationAndLocation = () => {

    if (!props.accountInformation.anonymised_patient) {
      return(
        <div>
          {userIsSuperAdmin(props.accountInformation) && !props.hidePatientIds && props.profileData.Patient_Data.id_patient && (
            <div style={{ marginBottom: 8 }}>
              <CopyableId value={props.profileData.Patient_Data.id_patient} label="id_patient" />
            </div>
          )}
          {((props.userRole === "admin")||(props.userRole === "staff")) ?
            <div>
              <Row>
                <Col>
                  <FormattedMessage id="param.group" defaultMessage="Group"/>
                </Col>
                <Col>
                  {renderSelect("group", props.group_list, props.profileData.Patient_Data.group, "", "")}
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormattedMessage id="patient.service" defaultMessage="Room" />
                </Col>
                <Col>
                  <input type="text" id="location" name={props.profileData.Patient_Data.location} value={location ?? ''} style={{width: "100%", border: "1px solid gray"}} onChange={handleChangeLocation}/>
                </Col>
              </Row>

            </div>
            :
            null
          }
        </div>
      )
    }
    else {
      return(
        <div>
        </div>
      )
    }
  }

  //Function to render patient monitoring type
  const medicalSpecialties = [
    { value: '', label: 'Sélectionner une spécialité' },
    { value: 'Bariatrique', label: 'Bariatrique' },
    { value: 'Néphrologie', label: 'Néphrologie' },
    { value: 'Pneumologie', label: 'Pneumologie' },
    { value: 'Urologie', label: 'Urologie' },
    { value: 'Vasculaire', label: 'Vasculaire' },
    { value: 'Autres', label: 'Autres' }
  ];

  const initialConcernedSpeciality = props.profileData.Patient_Data.concerned_speciality || '';
  const [selectedSpecialty, setSelectedSpecialty] = useState(initialConcernedSpeciality);
  const [isEditingSpecialty, setIsEditingSpecialty] = useState(initialConcernedSpeciality === '');
  const [displayAddPractitionerPopup, setDisplayAddPractitionerPopup] = useState(false);
  const [selectedPractitioner, setSelectedPractitioner] = useState(null);
  const [editingPractitioner, setEditingPractitioner] = useState(false);
  const [editPractitionerFamily, setEditPractitionerFamily] = useState("");
  const [editPractitionerGiven, setEditPractitionerGiven] = useState("");
  const [editPractitionerPhone, setEditPractitionerPhone] = useState("");
  const [editPractitionerMssante, setEditPractitionerMssante] = useState("");
  const [editPractitionerSaving, setEditPractitionerSaving] = useState(false);
  // Specialty (concerned_speciality) invite state
  const [specialtyEmail, setSpecialtyEmail] = useState('');
  const [specialtyEmailLocked, setSpecialtyEmailLocked] = useState(false);
  const [specialtySendWelcome, setSpecialtySendWelcome] = useState(false);
  const [specialtyInviteSent, setSpecialtyInviteSent] = useState(false);
  const [specialtyInviteError, setSpecialtyInviteError] = useState(''); // '' | 'already_exists' | 'already_invited' | 'send_failed'
  const [specialtyPreviouslyAssigned, setSpecialtyPreviouslyAssigned] = useState(false);
  const [practitionerCredSending, setPractitionerCredSending] = useState(false);
  const [practitionerCredSent, setPractitionerCredSent] = useState(false);
  const [practitionerResetLinkSending, setPractitionerResetLinkSending] = useState(false);
  const [practitionerResetLinkSent, setPractitionerResetLinkSent] = useState(false);

  // Ordonnance & Consentement upload state
  const [ordonnanceFilename, setOrdonnanceFilename] = useState(props.profileData.Patient_Data.ordonnance_filename || null);
  const [consentementFilename, setConsentementFilename] = useState(props.profileData.Patient_Data.consentement_filename || null);
  const ordonnanceInputRef = useRef(null);
  const consentementInputRef = useRef(null);
  const delegateMedicalJustSelectedRef = useRef(false);

  // PSAD state
  const [psadDelegateAlerts, setPsadDelegateAlerts] = useState(Boolean(props.profileData.Patient_Data.psad_delegate_alerts));
  const [psadDelegate, setPsadDelegate] = useState(props.profileData.Patient_Data.psad_delegate || null);

  // Delegate medical alert state — 'no' | 'na' | 'yes'
  const computeDelegateMedicalState = (val) => {
    if (!val || val === 'na') return 'na';
    if (val === 'no') return 'no';
    return 'yes'; // RPPS value stored
  };
  const hasLppCode = Boolean(props.profileData.Patient_Data.lpp_code);
  const isPsadStaffUser = userIsPsadStaff(props.accountInformation);
  const isPsadStructureUser = userIsInPsadStructure(props.accountInformation);
  const isCurrentUserPractitioner = userIsPractitioner(props.accountInformation);
  const currentUserRpps = userRpps(props.accountInformation);
  const [delegateMedicalAlerts, setDelegateMedicalAlerts] = useState(
    hasLppCode ? computeDelegateMedicalState(props.profileData.Patient_Data.delegate_medical_alert) : 'na'
  );
  const [delegateMedicalPractitioner, setDelegateMedicalPractitioner] = useState(null);
  const [displayAddPractitionerPopupMedical, setDisplayAddPractitionerPopupMedical] = useState(false);
  const [delegateMedicalEmail, setDelegateMedicalEmail] = useState('');
  const [delegateMedicalEmailLocked, setDelegateMedicalEmailLocked] = useState(false);
  const [delegateMedicalSendWelcome, setDelegateMedicalSendWelcome] = useState(false);
  const [delegateMedicalInviteSent, setDelegateMedicalInviteSent] = useState(false);
  const [delegateMedicalEmailError, setDelegateMedicalEmailError] = useState('');
  const [delegateMedicalInviteError, setDelegateMedicalInviteError] = useState(''); // '' | 'already_exists' | 'send_failed'
  const [delegateMedicalPractitionerNew, setDelegateMedicalPractitionerNew] = useState(false);
  const [delegateMedicalAlreadyAccepted, setDelegateMedicalAlreadyAccepted] = useState(false);

  // Delegate non-medical alert switch.
  // null = never configured (ON by default); '1' = explicitly ON; '0' = explicitly OFF.
  const rawDelegateNonMedical = props.profileData.Patient_Data.delegate_non_medical_alert;
  const [delegateNonMedicalAlerts, setDelegateNonMedicalAlerts] = useState(
    rawDelegateNonMedical !== 'no'
  );
  // Confirmation popup shown when turning the switch OFF while a PSAD is already linked.
  const [showNonMedicalOffConfirm, setShowNonMedicalOffConfirm] = useState(false);
  // Local only — not persisted, just used to send the invitation
  const [delegateNameInput, setDelegateNameInput] = useState('');
  const [delegatePhoneInput, setDelegatePhoneInput] = useState('');
  const [delegateEmailInput, setDelegateEmailInput] = useState('');
  const [delegateInviteSent, setDelegateInviteSent] = useState(false);
  const [delegateInviteSending, setDelegateInviteSending] = useState(false);
  const [delegateInviteError, setDelegateInviteError] = useState('');
  const [pendingInvites, setPendingInvites] = useState([]);
  const [inviteToCancel, setInviteToCancel] = useState(null);
  // PSAD structures state
  const [psadStructures, setPsadStructures] = useState([]);
  const [psadStructureShares, setPsadStructureShares] = useState([]);
  const [selectedPsadStructure, setSelectedPsadStructure] = useState('');
  // Scope of the structure share created when the PSAD accepts: 'all' (every care
  // user of the structure) or 'admin' (admins only). Default 'all'.
  const [psadShareScope, setPsadShareScope] = useState('all');
  const [showAddStructureForm, setShowAddStructureForm] = useState(false);
  const [newStructureName, setNewStructureName] = useState('');
  const [newStructureEmail, setNewStructureEmail] = useState('');
  const [newStructurePhone, setNewStructurePhone] = useState('');
  const [psadRevokeLoading, setPsadRevokeLoading] = useState(false);

  useEffect(() => {
    const speciality = props.profileData.Patient_Data.concerned_speciality || '';

    setSelectedSpecialty(speciality);
    setIsEditingSpecialty(speciality === '');
  }, [props.profileData.Patient_Data.id_patient, props.profileData.Patient_Data.concerned_speciality]);

  useEffect(() => {
    if ((psadDelegateAlerts || delegateNonMedicalAlerts) && psadStructureShares.length === 0) {
      fetchPendingInvites();
    }
  }, [psadDelegateAlerts, delegateNonMedicalAlerts, psadStructureShares.length, props.profileData.Patient_Data.id_patient]);

  const fetchPendingInvites = async () => {
    const invites = await PatientFunctionsGetter.get_patient_pending_invites(props.profileData.Patient_Data.id_patient);
    setPendingInvites(invites);
  };

  const fetchPsadStructures = async () => {
    // Only the PSAD structures made available to the caller's structure (falls back
    // to all PSAD structures server-side when none are explicitly assigned).
    const structures = await PatientFunctionsGetter.get_available_psad_structures();
    setPsadStructures(structures);
  };

  const fetchPsadStructureShares = async () => {
    const shares = await PatientFunctionsGetter.get_patient_structure_shares(props.profileData.Patient_Data.id_patient);
    setPsadStructureShares((shares || []).filter(s => s.structure_type && s.structure_type.toLowerCase() === 'psad'));
  };

  useEffect(() => {
    fetchPsadStructures();
    fetchPsadStructureShares();
  }, [props.profileData.Patient_Data.id_patient]);

  useEffect(() => {
    if (psadStructures.length === 0) return;
    const adminFkStructure = props.accountInformation?.FK_structure;
    if (isPsadStructureUser && userIsAdmin(props.accountInformation) && adminFkStructure) {
      const isInternal = !psadStructureShares.some(s => s.id_structure === adminFkStructure);
      if (isInternal) {
        setSelectedPsadStructure(adminFkStructure);
        const struct = psadStructures.find(s => s.id_structure === adminFkStructure);
        if (struct) {
          setDelegateNameInput(struct.structure_name);
          setDelegateEmailInput(struct.email || '');
          setDelegatePhoneInput(struct.phone_number || '');
        }
      }
    }
  }, [psadStructures, psadStructureShares, props.profileData.Patient_Data.id_patient]);

  // If a PSAD is configured/assigned on the patient, ensure the switch is ON.
  // Also: if the PSAD admin opens the form and delegate_non_medical_alert is not yet set,
  // auto-enable it and store their FK_structure.
  useEffect(() => {
    if (psadStructureShares.length > 0) {
      setDelegateNonMedicalAlerts(true);
    }
    // Auto-set for PSAD admin when the field is still empty
    if (
      isPsadStructureUser &&
      userIsAdmin(props.accountInformation) &&
      props.accountInformation?.FK_structure &&
      !props.profileData.Patient_Data.delegate_non_medical_alert
    ) {
      const fkStruct = props.accountInformation.FK_structure;
      setDelegateNonMedicalAlerts(true);
      savedPatient.Patient_Data.delegate_non_medical_alert = fkStruct;
      PatientFunctionsGetter.update_patient_delegate_non_medical(
        props.profileData.Patient_Data.id_patient, fkStruct
      );
      // Note: psad_delegate is intentionally NOT set here. It is filled only when
      // a concerned_speciality practitioner is selected (see handleSendSpecialtyInvitation).
    }
  }, [psadStructureShares]);

  const handleCreateStructure = async () => {
    if (!newStructureName.trim() || !newStructureEmail.trim()) return;
    const result = await PatientFunctionsGetter.create_structure({
      structure_name: newStructureName.trim(),
      type: 'psad',
      email: newStructureEmail.trim(),
      phone_number: newStructurePhone.trim() || null
    });
    if (result) {
      await fetchPsadStructures();
      setSelectedPsadStructure(result.id_structure);
      setDelegateNameInput(newStructureName.trim());
      setDelegateEmailInput(newStructureEmail.trim());
      setDelegatePhoneInput(newStructurePhone.trim());
      setShowAddStructureForm(false);
      setNewStructureName('');
      setNewStructureEmail('');
      setNewStructurePhone('');
    }
  };

  const handleSelectPsadStructure = (e) => {
    const structId = e.target.value;
    setSelectedPsadStructure(structId);
    const struct = psadStructures.find(s => s.id_structure === structId);
    if (struct) {
      setDelegateNameInput(struct.structure_name);
      setDelegateEmailInput(struct.email || '');
      setDelegatePhoneInput(struct.phone_number || '');
    } else {
      setDelegateNameInput('');
      setDelegateEmailInput('');
      setDelegatePhoneInput('');
    }
    setDelegateInviteSent(false);
    setDelegateInviteError('');
  };

  useEffect(() => {
    const rpps = props.profileData.Patient_Data.rpps_id_practioner_speciality;
    if (rpps) {
      // First check if practitioner actually exists in table_practitioner (local DB)
      DataServiceSQL.getLocalPractitioner(rpps).then(res => {
        const local = res?.data;
        if (local && local.rpps) {
          // Practitioner confirmed in table_practitioner → show green box
          setSelectedPractitioner(local);
          setSpecialtyPreviouslyAssigned(true);
        } else {
          // RPPS set on patient but practitioner not in table_practitioner (incomplete attribution)
          // Try to prefill from search (external annuaire) so user can complete attribution
          PatientFunctionsGetter.search_practitioners({ rpps }).then(results => {
            if (results && results.length > 0) {
              setSelectedPractitioner(results[0]);
            } else {
              setSelectedPractitioner(null);
            }
            setSpecialtyPreviouslyAssigned(false);
          });
        }
      }).catch(() => {
        // On error fall back to search without green box
        PatientFunctionsGetter.search_practitioners({ rpps }).then(results => {
          if (results && results.length > 0) {
            setSelectedPractitioner(results[0]);
          }
          setSpecialtyPreviouslyAssigned(false);
        });
      });
    } else {
      setSelectedPractitioner(null);
      setSpecialtyPreviouslyAssigned(false);
    }
  }, [props.profileData.Patient_Data.id_patient, props.profileData.Patient_Data.rpps_id_practioner_speciality]);

  // Pre-fill specialty invite email from practitioner data when practitioner changes
  useEffect(() => {
    if (selectedPractitioner) {
      const email = selectedPractitioner.mssante_email || selectedPractitioner.msmail || selectedPractitioner.email || '';
      setSpecialtyEmail(email);
      setSpecialtyEmailLocked(!!email);
    } else {
      setSpecialtyEmail('');
      setSpecialtyEmailLocked(false);
    }
    setSpecialtyInviteSent(false);
    setSpecialtyInviteError('');
    setSpecialtySendWelcome(false);
  }, [selectedPractitioner]);

  useEffect(() => {
    let cancelled = false;
    const val = props.profileData.Patient_Data.delegate_medical_alert;
    if (val && val !== 'no' && val !== 'na' && val !== 'yes') {
      PatientFunctionsGetter.search_practitioners({ rpps: val }).then(async results => {
        if (cancelled) return;
        if (results && results.length > 0) {
          const p = results[0];
          setDelegateMedicalPractitioner(p);
          setDelegateMedicalPractitionerNew(false);
          const email = p.msmail || p.mssante_email || p.email || '';
          setDelegateMedicalEmail(email);
          setDelegateMedicalEmailLocked(!!(p.msmail || p.mssante_email || p.email));
          // If a delegate share already exists for this practitioner (FK_target_user set),
          // the invite was accepted — no need to show the email/invitation form.
          const shares = await PatientFunctionsGetter.get_patient_structure_shares(
            props.profileData.Patient_Data.id_patient
          );
          if (cancelled) return;
          const alreadyAccepted = (shares || []).some(
            s => s.sharing_type === 'delegate_medical_alert' && s.target_user_rpps === p.rpps
          );
          if (alreadyAccepted) {
            setDelegateMedicalAlreadyAccepted(true);
            setDelegateMedicalInviteSent(false);
          } else {
            setDelegateMedicalAlreadyAccepted(false);
            if (delegateMedicalJustSelectedRef.current) {
              delegateMedicalJustSelectedRef.current = false;
            } else {
              checkDelegateMedicalInvite(email);
            }
          }
        }
      });
    } else {
      setDelegateMedicalPractitioner(null);
    }
    return () => { cancelled = true; };
  }, [props.profileData.Patient_Data.id_patient, props.profileData.Patient_Data.delegate_medical_alert]);

  const handleDelegateMedicalAlertsChange = async (val) => {
    setDelegateMedicalAlerts(val);
    if (val === 'yes') {
      savedPatient.Patient_Data.delegate_medical_alert = 'yes';
      await PatientFunctionsGetter.update_patient_delegate_medical(
        props.profileData.Patient_Data.id_patient, 'yes'
      );
    } else {
      setDelegateMedicalPractitioner(null);
      const dbVal = val === 'no' ? 'no' : null;
      savedPatient.Patient_Data.delegate_medical_alert = dbVal;
      await PatientFunctionsGetter.update_patient_delegate_medical(
        props.profileData.Patient_Data.id_patient, dbVal
      );
    }
  };

  const checkDelegateMedicalInvite = async (email) => {
    if (!email) return;
    try {
      const invites = await PatientFunctionsGetter.get_patient_pending_invites(
        props.profileData.Patient_Data.id_patient
      );
      const hasPending = (invites || []).some(inv => {
        if (inv.invite_type && inv.invite_type !== 'delegate_medical_alert') return false;
        if (inv.recipient_structure_id) return false;
        return inv.recipient_mail_address === email;
      });
      if (hasPending) {
        setDelegateMedicalInviteSent(true);
        setDelegateMedicalInviteError('already_invited');
      }
    } catch(e) { /* ignore */ }
  };

  const handleSelectDelegateMedicalPractitioner = async (practitioner) => {
    delegateMedicalJustSelectedRef.current = true;
    setDelegateMedicalPractitioner(practitioner);
    setDisplayAddPractitionerPopupMedical(false);
    setDelegateMedicalEmail(practitioner.msmail || practitioner.mssante_email || practitioner.email || '');
    setDelegateMedicalEmailLocked(!!(practitioner.msmail || practitioner.mssante_email || practitioner.email));
    setDelegateMedicalInviteSent(false);
    setDelegateMedicalInviteError('');
    setDelegateMedicalPractitionerNew(true);
    setDelegateMedicalAlreadyAccepted(false);
    if (practitioner && practitioner.rpps) {
      savedPatient.Patient_Data.delegate_medical_alert = practitioner.rpps;
      await PatientFunctionsGetter.update_patient_delegate_medical(
        props.profileData.Patient_Data.id_patient, practitioner.rpps
      );
    }
  };

  const handleRemoveDelegateMedicalPractitioner = async () => {
    setDelegateMedicalPractitioner(null);
    setDelegateMedicalEmail('');
    setDelegateMedicalEmailLocked(false);
    setDelegateMedicalSendWelcome(false);
    setDelegateMedicalInviteSent(false);
    setDelegateMedicalInviteError('');
    setDelegateMedicalPractitionerNew(false);
    setDelegateMedicalAlreadyAccepted(false);
    savedPatient.Patient_Data.delegate_medical_alert = null;
    await PatientFunctionsGetter.update_patient_delegate_medical(
      props.profileData.Patient_Data.id_patient, null
    );
  };

  const handleSendDelegateMedicalInvitation = async () => {
    setDelegateMedicalEmailError('');
    setDelegateMedicalInviteError('');
    if (delegateMedicalSendWelcome && (!delegateMedicalEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(delegateMedicalEmail.trim()))) {
      setDelegateMedicalEmailError(intl.formatMessage({ id: 'practitioner.manual.invalidEmail', defaultMessage: "L'adresse email n'est pas valide" }));
      return;
    }
    try {
      // RPPS already saved via handleSelectDelegateMedicalPractitioner when practitioner was chosen
      if (delegateMedicalSendWelcome && delegateMedicalEmail.trim()) {
        const delegateFullName = [
          delegateMedicalPractitioner?.family || '',
          Array.isArray(delegateMedicalPractitioner?.given) ? delegateMedicalPractitioner.given.join(' ') : (delegateMedicalPractitioner?.given || '')
        ].filter(Boolean).join(' ');
        const data_create = {
          resourceType: 'Practitioner',
          identifier: { value: delegateMedicalEmail },
          name: [{ use: 'official', family: delegateMedicalPractitioner?.family || 'Practitioner', given: Array.isArray(delegateMedicalPractitioner?.given) ? delegateMedicalPractitioner.given : [delegateMedicalPractitioner?.given || 'New'] }],
          telecom: { system: 'email', value: delegateMedicalEmail },
          send_invitation: true,
          language: intl.locale,
        };
        const data_update = {
          resourceType: 'Practitioner',
          role: 'staff',
          profession: 'practitioner',
          FK_structure: props.accountInformation.FK_structure || undefined,
          rpps_data: delegateMedicalPractitioner ? {
            rpps:              delegateMedicalPractitioner.rpps || null,
            family:            delegateMedicalPractitioner.family || null,
            given:             delegateMedicalPractitioner.given || null,
            profession:        delegateMedicalPractitioner.profession || 'practitioner',
            category:          delegateMedicalPractitioner.category || null,
            msmail:            delegateMedicalPractitioner.msmail || null,
            mssante_email:     delegateMedicalPractitioner.mssante_email || delegateMedicalPractitioner.msmail || null,
            phone:             delegateMedicalPractitioner.phone || null,
            email:             delegateMedicalEmail
          } : undefined
        };
        let alreadyExists = false;
        try {
          await DataServiceSQL.createUserReq_fhir(data_create);
        } catch (createErr) {
          const errBody = createErr?.response?.data;
          const errMsg = typeof errBody === 'string' ? errBody : (errBody ? JSON.stringify(errBody) : (createErr?.message || ''));
          if (errMsg.includes('User already exist') || createErr?.response?.status === 409) {
            alreadyExists = true;
          } else {
            throw createErr;
          }
        }
        await DataServiceSQL.updatePractitionnerReq_fhir(delegateMedicalEmail, data_update);
        if (alreadyExists) setDelegateMedicalInviteError('already_exists');
      }
      setDelegateMedicalInviteSent(true);
    } catch (e) {
      console.error('delegate medical invite error', e);
      setDelegateMedicalInviteError('send_failed');
    }
  };

  const handleSendSpecialtyInvitation = async (practitionerOverride) => {
    const pract = practitionerOverride || selectedPractitioner;
    setSpecialtyInviteError('');
    if (specialtySendWelcome && (!specialtyEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(specialtyEmail.trim()))) {
      setSpecialtyInviteError('invalid_email');
      return;
    }
    try {
      // 1. Always create/update practitioner in table_practitioner first so
      //    the backend can resolve the practitioner's FK_user when creating
      //    the table_patient_structure_share entry below.
      await PatientFunctionsGetter.create_or_update_local_practitioner({
        rpps:          pract?.rpps || null,
        family:        pract?.family || null,
        given:         pract?.given || null,
        profession:    pract?.profession || 'practitioner',
        category:      pract?.category || null,
        phone:         pract?.phone || null,
        mssante_email: pract?.mssante_email || pract?.msmail || specialtyEmail || null,
      });

      // 2. Save RPPS on patient (also creates the concerned_speciality share)
      await PatientFunctionsGetter.update_patient_practitioner_speciality(
        props.profileData?.Patient_Data?.id_patient,
        pract?.rpps
      );
      savedPatient.Patient_Data.rpps_id_practioner_speciality = pract?.rpps;

      // 2b. When a PSAD user is the one assigning the practitioner, attribute the
      // non-medical alert delegation to their structure: store their FK_structure
      // in psad_delegate (and delegate_non_medical_alert if not already set), so
      // "Non-medical alert delegation assigned to your structure" is fully set.
      if (isPsadStructureUser && props.accountInformation?.FK_structure) {
        const fkStruct = props.accountInformation.FK_structure;
        if (!savedPatient.Patient_Data.delegate_non_medical_alert) {
          setDelegateNonMedicalAlerts(true);
          savedPatient.Patient_Data.delegate_non_medical_alert = fkStruct;
          await PatientFunctionsGetter.update_patient_delegate_non_medical(
            props.profileData.Patient_Data.id_patient, fkStruct
          );
        }
        setPsadDelegate(fkStruct);
        savedPatient.Patient_Data.psad_delegate = fkStruct;
        await PatientFunctionsGetter.update_patient_psad(
          props.profileData.Patient_Data.id_patient, psadDelegateAlerts, fkStruct
        );
      }

      // 3. Optionally send invitation email
      let alreadyExists = false;
      if (specialtySendWelcome && specialtyEmail.trim()) {
        const data_create = {
          resourceType: 'Practitioner',
          identifier: { value: specialtyEmail },
          name: [{ use: 'official', family: selectedPractitioner?.family || 'Practitioner', given: Array.isArray(selectedPractitioner?.given) ? selectedPractitioner.given : [selectedPractitioner?.given || 'New'] }],
          telecom: { system: 'email', value: specialtyEmail },
          send_invitation: true,
          language: intl.locale,
        };
        const data_update = {
          resourceType: 'Practitioner',
          role: 'staff',
          profession: 'practitioner',
          FK_structure: props.accountInformation.FK_structure || undefined,
          rpps_data: selectedPractitioner ? {
            rpps:          selectedPractitioner.rpps || null,
            family:        selectedPractitioner.family || null,
            given:         selectedPractitioner.given || null,
            profession:    selectedPractitioner.profession || 'practitioner',
            category:      selectedPractitioner.category || null,
            msmail:        selectedPractitioner.msmail || null,
            mssante_email: selectedPractitioner.mssante_email || selectedPractitioner.msmail || null,
            phone:         selectedPractitioner.phone || null,
            email:         specialtyEmail
          } : undefined
        };
        try {
          await DataServiceSQL.createUserReq_fhir(data_create);
        } catch (createErr) {
          const errBody = createErr?.response?.data;
          const errMsg = typeof errBody === 'string' ? errBody : (errBody ? JSON.stringify(errBody) : (createErr?.message || ''));
          if (errMsg.includes('User already exist') || createErr?.response?.status === 409) {
            alreadyExists = true;
          } else {
            throw createErr;
          }
        }
        await DataServiceSQL.updatePractitionnerReq_fhir(specialtyEmail, data_update);
      }

      if (alreadyExists) setSpecialtyInviteError('already_exists');
      setSpecialtyInviteSent(true);
      // Notify the parent so the Shares tab shows the new concerned_speciality
      // share without requiring a full reload.
      if (props.onSharesChanged) props.onSharesChanged();
    } catch (e) {
      console.error('specialty invite error', e);
      setSpecialtyInviteError('send_failed');
    }
  };

  const handleSpecialtyChange = (event) => {
    const speciality = event.target.value;

    setSelectedSpecialty(speciality)
    setIsEditingSpecialty(speciality === '')
    savedPatient.Patient_Data.concerned_speciality = speciality || null;
    PatientFunctionsGetter.update_patient_speciality(props.profileData.Patient_Data.id_patient, speciality)
    if (speciality === 'Pneumologie') {
      savedPatient.Patient_Data.lpp_code = ' ';
      PatientFunctionsGetter.update_patient_lpp_code(props.profileData.Patient_Data.id_patient, '6656434')
    } else {
      savedPatient.Patient_Data.lpp_code = null;
      PatientFunctionsGetter.update_patient_lpp_code(props.profileData.Patient_Data.id_patient, null)
    }
  }

  const handleSelectPractitioner = async (practitioner) => {
    setSelectedPractitioner(practitioner);
    setSpecialtyPreviouslyAssigned(false);
    setDisplayAddPractitionerPopup(false);
    setPractitionerCredSent(false);
    // Auto-assign immediately on selection
    await handleSendSpecialtyInvitation(practitioner);
  }

  const handleRemovePractitioner = async () => {
    setSelectedPractitioner(null);
    setEditingPractitioner(false);
    setSpecialtyPreviouslyAssigned(false);
    setSpecialtyInviteSent(false);
    setSpecialtyInviteError('');
    setPractitionerCredSent(false);
    setPractitionerResetLinkSent(false);
    savedPatient.Patient_Data.rpps_id_practioner_speciality = null;
    await PatientFunctionsGetter.update_patient_practitioner_speciality(
      props.profileData.Patient_Data.id_patient,
      null
    );
    // Notify the parent so the Shares tab drops the removed share without a reload.
    if (props.onSharesChanged) props.onSharesChanged();
  }

  const handleAssignSelfAsPractitioner = async () => {
    if (!currentUserRpps) return;
    const results = await PatientFunctionsGetter.search_practitioners({ rpps: currentUserRpps });
    if (results && results.length > 0) {
      await handleSelectPractitioner(results[0]);
    }
  }

  const handleStartEditPractitioner = () => {
    if (!selectedPractitioner) return;
    setEditPractitionerFamily(selectedPractitioner.family || "");
    setEditPractitionerGiven(
      Array.isArray(selectedPractitioner.given)
        ? selectedPractitioner.given.join(" ")
        : (selectedPractitioner.given || "")
    );
    setEditPractitionerPhone(selectedPractitioner.phone || "");
    setEditPractitionerMssante(selectedPractitioner.mssante_email || selectedPractitioner.msmail || "");
    setEditingPractitioner(true);
  }

  const handleSaveEditPractitioner = async () => {
    if (!selectedPractitioner || !selectedPractitioner.rpps) return;
    if (editPractitionerMssante.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editPractitionerMssante.trim())) return;
    setEditPractitionerSaving(true);
    const updated = await PatientFunctionsGetter.create_or_update_local_practitioner({
      rpps: selectedPractitioner.rpps,
      family: editPractitionerFamily.trim(),
      given: editPractitionerGiven.trim(),
      phone: editPractitionerPhone.trim() || null,
      mssante_email: editPractitionerMssante.trim() || null
    });
    if (updated) {
      setSelectedPractitioner(updated);
    }
    setEditingPractitioner(false);
    setEditPractitionerSaving(false);
  }

  const handleSendPractitionerCredentials = async () => {
    if (!selectedPractitioner) return;
    const FK_structure = props.accountInformation?.FK_structure;
    if (!FK_structure) return;
    const email = (specialtyEmail || '').trim()
      || (selectedPractitioner.mssante_email || selectedPractitioner.msmail || '').trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
    setPractitionerCredSending(true);
    try {
      await PatientFunctionsGetter.send_practitioner_credentials({
        id_user:       selectedPractitioner.id_user || undefined,
        rpps:          selectedPractitioner.rpps,
        family:        selectedPractitioner.family,
        given:         Array.isArray(selectedPractitioner.given) ? selectedPractitioner.given.join(" ") : selectedPractitioner.given,
        profession:    selectedPractitioner.profession,
        mssante_email: email,
        FK_structure,
        language:      intl.locale || 'fr-FR',
      });
      setPractitionerCredSent(true);
    } catch(e) {
      console.log(e);
    }
    setPractitionerCredSending(false);
  }

  const handleSendPractitionerResetLink = async () => {
    if (!selectedPractitioner?.id_user) return;
    setPractitionerResetLinkSending(true);
    try {
      await PatientFunctionsGetter.send_practitioner_reset_link({ id_user: selectedPractitioner.id_user });
      setPractitionerResetLinkSent(true);
    } catch(e) {
      console.log(e);
    }
    setPractitionerResetLinkSending(false);
  }

  const isPractitionerRequired = selectedSpecialty === "Pneumologie";
  const isPneumologie = selectedSpecialty === "Pneumologie";
  const isPatientInternalToPsadAdmin = isPsadStructureUser && !psadStructureShares.some(s => s.id_structure === props.accountInformation.FK_structure);
  const canChangeDelegateMedicalPractitioner =
    (userIsAdmin(props.accountInformation) && !isPsadStructureUser) ||
    (currentUserRpps && selectedPractitioner && currentUserRpps === selectedPractitioner.rpps) ||
    (isPsadStructureUser && userIsAdmin(props.accountInformation) && isPatientInternalToPsadAdmin);
  const canRemoveDelegateMedicalPractitioner =
    (currentUserRpps && currentUserRpps === props.profileData.Patient_Data.delegate_medical_alert) ||
    (!isPsadStructureUser) ||
    (isPsadStructureUser && userIsAdmin(props.accountInformation) && isPatientInternalToPsadAdmin);
  const hasPractitionerAssigned = Boolean(
    (selectedPractitioner && selectedPractitioner.rpps)
    || savedPatient.Patient_Data.rpps_id_practioner_speciality
    || props.profileData.Patient_Data.rpps_id_practioner_speciality
  );

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleOrdonnanceUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const base64 = await fileToBase64(file);
    setOrdonnanceFilename(file.name);
    savedPatient.Patient_Data.ordonnance_filename = file.name;
    await PatientFunctionsGetter.update_patient_ordonnance(
      props.profileData.Patient_Data.id_patient, base64, file.name
    );
  };

  const handleRemoveOrdonnance = async () => {
    setOrdonnanceFilename(null);
    savedPatient.Patient_Data.ordonnance_filename = null;
    if (ordonnanceInputRef.current) ordonnanceInputRef.current.value = "";
    await PatientFunctionsGetter.update_patient_ordonnance(
      props.profileData.Patient_Data.id_patient, null, null
    );
  };

  const handleConsentementUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const base64 = await fileToBase64(file);
    setConsentementFilename(file.name);
    savedPatient.Patient_Data.consentement_filename = file.name;
    await PatientFunctionsGetter.update_patient_consentement(
      props.profileData.Patient_Data.id_patient, base64, file.name
    );
  };

  const handleRemoveConsentement = async () => {
    setConsentementFilename(null);
    savedPatient.Patient_Data.consentement_filename = null;
    if (consentementInputRef.current) consentementInputRef.current.value = "";
    await PatientFunctionsGetter.update_patient_consentement(
      props.profileData.Patient_Data.id_patient, null, null
    );
  };

  const handleDelegateAlertsChange = async (checked) => {
    setPsadDelegateAlerts(checked);
    if (!checked) {
      setPsadDelegate(null);
      setDelegateNameInput('');
      setDelegatePhoneInput('');
      setDelegateEmailInput('');
      setDelegateInviteSent(false);
      setDelegateInviteError('');
    }
    savedPatient.Patient_Data.psad_delegate_alerts = checked;
    savedPatient.Patient_Data.psad_delegate = checked ? psadDelegate : null;
    await PatientFunctionsGetter.update_patient_psad(
      props.profileData.Patient_Data.id_patient, checked, checked ? psadDelegate : null
    );
  };

  const handleRemoveDelegate = async () => {
    const id_patient = props.profileData.Patient_Data.id_patient;
    // Cancel any pending delegate_non_medical_alert invitations for this patient
    const invitesToCancel = pendingInvites.filter(
      inv => !inv.invite_type || inv.invite_type === 'delegate_non_medical_alert'
    );
    for (const inv of invitesToCancel) {
      await PatientFunctionsGetter.delete_patient_pending_invite(id_patient, inv.request_id);
    }
    // Remove from table_patient_structure_share for all PSAD shares
    for (const share of psadStructureShares) {
      await PatientFunctionsGetter.delete_patient_structure_share(id_patient, share.id_structure);
    }
    setPsadStructureShares([]);
    // Also clear psad_delegate column if set
    if (psadDelegate) {
      setPsadDelegate(null);
      savedPatient.Patient_Data.psad_delegate = null;
      await PatientFunctionsGetter.update_patient_psad(id_patient, psadDelegateAlerts, null);
    }
    setDelegateInviteSent(false);
    setDelegateInviteError('');
    savedPatient.Patient_Data.delegate_non_medical_alert = 'no';
    await PatientFunctionsGetter.update_patient_delegate_non_medical(id_patient, false);
    setDelegateNonMedicalAlerts(false);
    fetchPendingInvites();
  };

  // Confirm turning the non-medical delegation OFF: remove PSAD links and persist 'no'.
  const confirmDisableNonMedicalDelegate = async () => {
    await handleRemoveDelegate();
    setShowNonMedicalOffConfirm(false);
  };

  const handleRevokePsadOwnShare = async () => {
    setPsadRevokeLoading(true);
    const myShare = psadStructureShares.find(s => s.id_structure === props.accountInformation.FK_structure);
    if (myShare) {
      await PatientFunctionsGetter.revoke_my_delegate_share(
        props.profileData.Patient_Data.id_patient,
        myShare.id_structure
      );
      setPsadStructureShares(prev => prev.filter(s => s.id_structure !== myShare.id_structure));
    }
    // The "assigned to your structure" badge is driven by psad_delegate, so clear
    // it here even when no structure-share row exists.
    if (psadDelegate) {
      setPsadDelegate(null);
      savedPatient.Patient_Data.psad_delegate = null;
      await PatientFunctionsGetter.update_patient_psad(
        props.profileData.Patient_Data.id_patient, psadDelegateAlerts, null
      );
    }
    setPsadRevokeLoading(false);
  };

  const handleDelegateEmailChange = (event) => {
    setDelegateEmailInput(event.target.value);
    setDelegateInviteSent(false);
    setDelegateInviteError('');
  };

  const handleSendDelegateInvitation = async () => {
    if (delegateInviteSending || delegateInviteSent) return;
    setDelegateInviteSending(true);
    setDelegateInviteError('');
    setDelegateInviteSent(false);
    if (!selectedPsadStructure) {
      setDelegateInviteError('name_required');
      setDelegateInviteSending(false);
      return;
    }
    const struct = psadStructures.find(s => s.id_structure === selectedPsadStructure);
    const email = struct ? struct.email : '';
    const name = struct ? struct.structure_name : '';
    const rawPhone = struct ? (struct.phone_number || '') : '';
    // Normalize phone to E.164 (PhoneInput / isValidPhoneNumber require this format).
    // Default country FR — falls back to raw value if it cannot be parsed.
    let phone = '';
    if (rawPhone) {
      try {
        const parsed = parsePhoneNumber(rawPhone, 'FR');
        if (parsed && parsed.isValid()) {
          phone = parsed.number; // E.164, e.g. +33612345678
        } else {
          phone = rawPhone;
        }
      } catch (e) {
        phone = rawPhone;
      }
    }
    if (!email || !email.includes('@')) {
      // No contact email on the structure — the invite still goes to admin users; proceed.
    }
    try {
      await PatientFunctionsGetter.send_patient_share_invite_structures(
        props.profileData.Patient_Data.id_patient, [selectedPsadStructure], name.trim(), phone.trim(), 'delegate_non_medical_alert', psadShareScope
      );
      setPsadDelegate(selectedPsadStructure);
      savedPatient.Patient_Data.psad_delegate = selectedPsadStructure;
      await PatientFunctionsGetter.update_patient_psad(
        props.profileData.Patient_Data.id_patient, psadDelegateAlerts, selectedPsadStructure
      );
      // Keep delegate_non_medical_alert in sync: assigning a PSAD always activates it.
      if (!savedPatient.Patient_Data.delegate_non_medical_alert) {
        savedPatient.Patient_Data.delegate_non_medical_alert = '1';
        setDelegateNonMedicalAlerts(true);
      }
      setDelegateInviteSent(true);
      setDelegateInviteSending(false);
      fetchPendingInvites();

      // Auto-fill notification fields with the structure's email and phone
      let isMultiRecipient = Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("multi_recipient"));
      if (isMultiRecipient) {
        if (email) {
          let newMailList = mailalertMultirecipient.slice();
          if (newMailList.length === 0 || (newMailList.length === 1 && newMailList[0].value === '')) {
            newMailList = [{ index: 0, value: email, threshold: true, reminder: false, day_time: "day" }];
          } else if (newMailList.length < 4 && !newMailList.some(m => m.value === email)) {
            newMailList.push({ index: newMailList.length, value: email, threshold: true, reminder: false, day_time: "day" });
          }
          setMailalertMultirecipient(newMailList);
          resetMailAlert(newMailList);
        }
        if (phone) {
          let newSmsList = smsalertMultirecipient.slice();
          if (newSmsList.length === 0 || (newSmsList.length === 1 && newSmsList[0].value === '')) {
            newSmsList = [{ index: 0, value: phone, threshold: true, reminder: false, day_time: "day" }];
          } else if (newSmsList.length < 4 && !newSmsList.some(s => s.value === phone)) {
            newSmsList.push({ index: newSmsList.length, value: phone, threshold: true, reminder: false, day_time: "day" });
          }
          setSmsalertMultirecipient(newSmsList);
          resetSMSAlert(newSmsList);
        }
      } else {
        if (email) {
          setMailalert(email);
        }
        if (phone) {
          setSmsalert([phone]);
        }
      }
      props.setChangeOngoing(true);
    } catch (err) {
      console.log(err);
      setDelegateInviteSending(false);
      setDelegateInviteError('send_failed');
    }
  };

  const renderPatientMonitoringTypeEdit = () => {
    return(
      <div>
        <hr />
        <Row className="justify-content-md-end" style={{ paddingTop: "0px", paddingBottom: "10px" }}>
          <Col style={{ fontWeight: "bold", fontSize: "1.1em", textAlign: "center" }}>
            <FormattedMessage id="param.monitoringParamTitle" defaultMessage="Monitoring parameters"/>
            {createSwitchMonitoring()}
            {(userIsSuperAdmin(props.accountInformation) || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("concerned_speciality_and_delegation"))) && props.displayDevicesParams !== "no" && (
              selectedSpecialty !== '' && !isEditingSpecialty ? (
                <div style={{ marginTop: 15, display: "flex", alignItems: "center", justifyContent: "center", gap: 10, flexWrap: "wrap" }}>
                  <span style={{ fontWeight: "bold" }}>{selectedSpecialty}</span>
                  <div>
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      style={{ padding: '2px 8px', fontSize: '0.8em', whiteSpace: 'nowrap' }}
                      onClick={() => setIsEditingSpecialty(true)}
                    >
                      <FormattedMessage id="patient.concernedSpeciality.change" defaultMessage="Change speciality" />
                    </button>
                  </div>
                </div>
              ) : (
                <div style={{ marginTop: 15, display: "flex", alignItems: "center", justifyContent: "center", gap: 10, flexWrap: "wrap" }}>
                  <select
                    name="concerned_speciality"
                    value={selectedSpecialty}
                    onChange={handleSpecialtyChange}
                    style={{ padding: '5px 10px', borderRadius: 4, border: '1px solid #ccc' }}
                  >
                    {medicalSpecialties.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>
              )
            )}
            {(userIsSuperAdmin(props.accountInformation) || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("concerned_speciality_and_delegation"))) && props.displayDevicesParams !== "no" && selectedSpecialty !== '' && (
              <Card
                bordered={true}
                style={{
                  marginTop: 10,
                  marginBottom: 15,
                  borderRadius: '20px',
                  borderColor: isPractitionerRequired && !hasPractitionerAssigned ? '#dc3545' : 'black',
                  width: '100%'
                }}
                bodyStyle={{ padding: 15 }}
              >
                <div style={{ fontWeight: "bold", fontSize: "1em", textAlign: "center", marginBottom: 10 }}>
                  <FormattedMessage id="patient.practitionerSpeciality" defaultMessage="Practitioner" />
                </div>

                {selectedPractitioner && !editingPractitioner && (
                  <div style={{ marginBottom: 10, fontSize: "0.9em" }}>
                    <b><FormattedMessage id="account.lastname" defaultMessage="Lastname" />: </b>{selectedPractitioner.family}<br/>
                    <b><FormattedMessage id="account.firstname" defaultMessage="First name" />: </b>
                    {Array.isArray(selectedPractitioner.given) ? selectedPractitioner.given.join(" ") : (selectedPractitioner.given || "")}<br/>
                    <b><FormattedMessage id="account.phone" defaultMessage="Phone" />: </b>{selectedPractitioner.phone || "-"}<br/>
                    <b><FormattedMessage id="account.mssantemail" defaultMessage="MSSanté address" />: </b>
                    {selectedPractitioner.mssante_email || selectedPractitioner.msmail || "-"}<br/>
                    <b><FormattedMessage id="account.RPPS_num" defaultMessage="RPPS number" />: </b>{selectedPractitioner.rpps}<br/>
                    {selectedPractitioner.current_structure_name && <><b><FormattedMessage id="account.structure" defaultMessage="Structure" />: </b>{selectedPractitioner.current_structure_name}<br/></>}
                  </div>
                )}

                {selectedPractitioner && editingPractitioner && (
                  <div style={{ marginBottom: 10 }}>
                    <div style={{ marginBottom: 6 }}>
                      <label style={{ fontWeight: 600, fontSize: "0.85em", display: "block" }}>
                        <FormattedMessage id="account.RPPS_num" defaultMessage="RPPS number" />
                      </label>
                      <input
                        type="text"
                        value={selectedPractitioner.rpps}
                        disabled
                        style={{ width: "100%", border: "1px solid #ccc", padding: "4px 6px", borderRadius: 3, background: "#f5f5f5", color: "#666" }}
                      />
                    </div>
                    <div style={{ marginBottom: 6 }}>
                      <label style={{ fontWeight: 600, fontSize: "0.85em", display: "block" }}>
                        <FormattedMessage id="account.lastname" defaultMessage="Lastname" /><span style={{ color: "#dc3545", marginLeft: 3 }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={editPractitionerFamily}
                        onChange={(e) => setEditPractitionerFamily(e.target.value)}
                        style={{ width: "100%", border: "1px solid gray", padding: "4px 6px", borderRadius: 3 }}
                      />
                    </div>
                    <div style={{ marginBottom: 6 }}>
                      <label style={{ fontWeight: 600, fontSize: "0.85em", display: "block" }}>
                        <FormattedMessage id="account.firstname" defaultMessage="First name" /><span style={{ color: "#dc3545", marginLeft: 3 }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={editPractitionerGiven}
                        onChange={(e) => setEditPractitionerGiven(e.target.value)}
                        style={{ width: "100%", border: "1px solid gray", padding: "4px 6px", borderRadius: 3 }}
                      />
                    </div>
                    <div style={{ marginBottom: 6 }}>
                      <label style={{ fontWeight: 600, fontSize: "0.85em", display: "block" }}>
                        <FormattedMessage id="account.phone" defaultMessage="Phone" />
                      </label>
                      <input
                        type="tel"
                        value={editPractitionerPhone}
                        onChange={(e) => setEditPractitionerPhone(e.target.value)}
                        style={{ width: "100%", border: "1px solid gray", padding: "4px 6px", borderRadius: 3 }}
                      />
                    </div>
                    <div style={{ marginBottom: 8 }}>
                      <label style={{ fontWeight: 600, fontSize: "0.85em", display: "block" }}>
                        <FormattedMessage id="practitioner.manual.mssanteOrEmail" defaultMessage="Adresse MSSanté ou email" />
                      </label>
                      <input
                        type="email"
                        value={editPractitionerMssante}
                        onChange={(e) => setEditPractitionerMssante(e.target.value)}
                        style={{ width: "100%", border: `1px solid ${editPractitionerMssante.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editPractitionerMssante.trim()) ? '#dc3545' : 'gray'}`, padding: "4px 6px", borderRadius: 3 }}
                      />
                      {editPractitionerMssante.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editPractitionerMssante.trim()) && (
                        <div style={{ color: '#dc3545', fontSize: '0.8em', marginTop: 2 }}>
                          <FormattedMessage id="practitioner.manual.invalidEmail" defaultMessage="L'adresse email n'est pas valide" />
                        </div>
                      )}
                    </div>
                    <div style={{ display: "flex", gap: 6, justifyContent: "center" }}>
                      <button
                        type="button"
                        className="btn btn-success btn-sm"
                        onClick={handleSaveEditPractitioner}
                        disabled={editPractitionerSaving || !editPractitionerFamily.trim() || !editPractitionerGiven.trim() || (editPractitionerMssante.trim() !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editPractitionerMssante.trim()))}
                      >
                        {editPractitionerSaving
                          ? <FormattedMessage id="button.saving" defaultMessage="Saving..." />
                          : <FormattedMessage id="button.save" defaultMessage="Save" />
                        }
                      </button>
                      <button type="button" className="btn btn-secondary btn-sm" onClick={() => setEditingPractitioner(false)}>
                        <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
                      </button>
                    </div>
                  </div>
                )}

                {!selectedPractitioner && (
                  <div style={{ marginBottom: 10, textAlign: "center", color: "#888" }}>
                    {isPractitionerRequired ? (
                      <span style={{ color: "#000" }}>
                        <FormattedMessage id="patient.assignPractitioner" defaultMessage="Assign a physician" />
                        <span style={{ color: "#dc3545", marginLeft: 4 }}>*</span>
                      </span>
                    ) : (
                      <FormattedMessage id="patient.noPractitioner" defaultMessage="No practitioner assigned" />
                    )}
                  </div>
                )}

                <div style={{ textAlign: "center" }}>
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                    {!editingPractitioner && (
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => setDisplayAddPractitionerPopup(true)}
                      >
                        {selectedPractitioner ? (
                          <FormattedMessage id="patient.changePractitioner" defaultMessage="Change practitioner" />
                        ) : (
                          <FormattedMessage id="patient.searchPractitioner" defaultMessage="Search practitioner" />
                        )}
                      </button>
                    )}
                    {!editingPractitioner && isCurrentUserPractitioner && currentUserRpps
                      && (!selectedPractitioner || selectedPractitioner.rpps !== currentUserRpps) && (
                      <button
                        type="button"
                        className="btn btn-outline-success btn-sm"
                        onClick={handleAssignSelfAsPractitioner}
                      >
                        <FormattedMessage id="patient.assignSelfAsPractitioner" defaultMessage="Assign me as practitioner" />
                      </button>
                    )}
                    {selectedPractitioner && !editingPractitioner && (
                      <button
                        type="button"
                        className="btn btn-outline-info btn-sm"
                        onClick={handleStartEditPractitioner}
                      >
                        <FormattedMessage id="button.edit" defaultMessage="Edit" />
                      </button>
                    )}
                    {selectedPractitioner && !isPractitionerRequired && !editingPractitioner ? (
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={handleRemovePractitioner}
                      >
                        <FormattedMessage id="patient.removePractitioner" defaultMessage="Remove physician" />
                      </button>
                    ) : null}
                  </div>
                </div>
                {/* Welcome email invitation — only when a practitioner is selected and not in edit mode */}
                {selectedPractitioner && !editingPractitioner && (
                  <div style={{ marginTop: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
                    {(specialtyInviteSent || specialtyPreviouslyAssigned) ? (
                      <div style={{
                        background: (specialtyInviteError === 'already_exists' || (!specialtyInviteError && !specialtySendWelcome)) ? '#e8f5e9' : '#fff3cd',
                        border: `1px solid ${(specialtyInviteError === 'already_exists' || (!specialtyInviteError && !specialtySendWelcome)) ? '#4CAF50' : '#f0ad4e'}`,
                        borderRadius: 6, padding: '8px 14px', textAlign: 'center', fontSize: '0.88em', width: '100%'
                      }}>
                        {specialtyInviteError === 'already_exists' ? (
                          <div style={{ color: '#2e7d32', fontWeight: 'bold' }}>
                            <FormattedMessage id="staff.userAlreadyRegistered" defaultMessage="Médecin déjà enregistré sur la plateforme" />
                          </div>
                        ) : specialtyInviteError === 'already_invited' ? (
                          <div style={{ color: '#856404', fontWeight: 'bold' }}>
                            <FormattedMessage id="staff.invitationAlreadySent" defaultMessage="Invitation déjà envoyée — en attente d'acceptation" />
                          </div>
                        ) : specialtySendWelcome ? (
                          <div style={{ color: '#856404', fontWeight: 'bold' }}>
                            <FormattedMessage id="staff.assignedAndInvited" defaultMessage="Identifiants envoyés et Médecin attribué à ce patient avec succès" />
                          </div>
                        ) : (
                          <div style={{ color: '#2e7d32', fontWeight: 'bold' }}>
                            <FormattedMessage id="staff.assignedToPatient" defaultMessage="Médecin attribué à ce patient avec succès" />
                          </div>
                        )}
                        {currentUserRpps && selectedPractitioner?.rpps && currentUserRpps === selectedPractitioner.rpps && (
                          <div style={{ color: '#1565c0', fontSize: '0.85em', marginTop: 4, fontWeight: 'bold' }}>
                            ★ <FormattedMessage id="staff.youAreAssignedPractitioner" defaultMessage="Vous êtes le médecin en charge de ce patient" />
                          </div>
                        )}
                        <div style={{ marginTop: 4, color: '#444' }}>
                          <b>{selectedPractitioner.family} {Array.isArray(selectedPractitioner.given) ? selectedPractitioner.given.join(' ') : (selectedPractitioner.given || '')}</b>
                          {specialtyEmail && <div style={{ fontSize: '0.9em', color: '#666' }}>{specialtyEmail}</div>}
                        </div>
                        <div style={{ marginTop: 8, display: 'flex', justifyContent: 'center', gap: 8, flexWrap: 'wrap' }}>
                          {userIsSuperAdmin(props.accountInformation) && props.accountInformation?.FK_structure && (
                            selectedPractitioner?.user_role === "admin" ? (
                              practitionerResetLinkSent ? (
                                <span style={{ color: '#2e7d32', fontWeight: 700, fontSize: '0.88em', alignSelf: 'center' }}>
                                  &#x2713; <FormattedMessage id="practitioner.platform.resetLinkSent" defaultMessage="Lien envoyé" />
                                </span>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-outline-info btn-sm"
                                  disabled={practitionerResetLinkSending || !selectedPractitioner?.id_user}
                                  onClick={handleSendPractitionerResetLink}
                                >
                                  {practitionerResetLinkSending
                                    ? <FormattedMessage id="home.loading" defaultMessage="Loading..." />
                                    : <FormattedMessage id="practitioner.platform.sendResetLink" defaultMessage="Envoyer un lien de réinitialisation" />}
                                </button>
                              )
                            ) : (
                              practitionerCredSent ? (
                                <span style={{ color: '#2e7d32', fontWeight: 700, fontSize: '0.88em', alignSelf: 'center' }}>
                                  &#x2713; <FormattedMessage id="practitioner.platform.emailSent" defaultMessage="Email envoyé" />
                                </span>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-outline-info btn-sm"
                                  disabled={practitionerCredSending || !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(((specialtyEmail || '').trim() || (selectedPractitioner?.mssante_email || selectedPractitioner?.msmail || '').trim())))}
                                  onClick={handleSendPractitionerCredentials}
                                >
                                  {practitionerCredSending
                                    ? <FormattedMessage id="home.loading" defaultMessage="Loading..." />
                                    : <FormattedMessage id="practitioner.platform.resendCredentials" defaultMessage="Renvoyer les identifiants" />}
                                </button>
                              )
                            )
                          )}
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm"
                            onClick={handleRemovePractitioner}
                          >
                            <FormattedMessage id="patient.removeAssignment" defaultMessage="Retirer l'attribution" />
                          </button>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, width: '100%', marginTop: 8 }}>
                          <label style={{ fontWeight: 'bold', fontSize: '0.85em', marginBottom: 2, textAlign: 'center' }}>
                            <FormattedMessage id="practitioner.manual.mssanteOrEmail" defaultMessage="Adresse MSSanté ou email de ce médecin" />
                          </label>
                          {specialtyEmailLocked && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(specialtyEmail.trim()) ? (
                            <>
                              <span
                                data-tooltip-id={`specialty-email-full-${props.profileData.Patient_Data.id_patient}`}
                                style={{ fontSize: '0.9em', color: '#333', background: '#f5f5f5', border: '1px solid #ddd', borderRadius: 4, padding: '5px 10px', width: '60%', boxSizing: 'border-box', textAlign: 'center', cursor: 'default', display: 'inline-block' }}
                              >
                                {specialtyEmail.length > 25 ? specialtyEmail.slice(0, 25) + '…' : specialtyEmail}
                              </span>
                              {specialtyEmail.length > 25 && <Tooltip id={`specialty-email-full-${props.profileData.Patient_Data.id_patient}`} content={specialtyEmail} />}
                            </>
                          ) : (
                            <input
                              type="email"
                              value={specialtyEmail}
                              onChange={(e) => { setSpecialtyEmail(e.target.value); setSpecialtyEmailLocked(false); setSpecialtyInviteSent(false); setSpecialtyInviteError(''); if (!e.target.value.trim()) setSpecialtySendWelcome(false); }}
                              placeholder="email@exemple.com"
                              style={{ padding: '6px 10px', borderRadius: 4, border: `1px solid ${!specialtyEmail.trim() ? '#ccc' : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(specialtyEmail.trim()) ? '#4CAF50' : '#dc3545'}`, width: '60%', fontSize: '0.9em', boxSizing: 'border-box', textAlign: 'center' }}
                            />
                          )}
                          {specialtyEmail.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(specialtyEmail.trim()) && (
                            <div style={{ color: '#dc3545', fontSize: '0.8em' }}>
                              <FormattedMessage id="practitioner.manual.invalidEmail" defaultMessage="L'adresse email n'est pas valide" />
                            </div>
                          )}
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
                          {userIsSuperAdmin(props.accountInformation) && props.accountInformation?.FK_structure && (
                            selectedPractitioner?.user_role === "admin" ? (
                              practitionerResetLinkSent ? (
                                <span style={{ color: '#2e7d32', fontWeight: 700, fontSize: '0.88em', alignSelf: 'center' }}>
                                  &#x2713; <FormattedMessage id="practitioner.platform.resetLinkSent" defaultMessage="Lien envoyé" />
                                </span>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-outline-info btn-sm"
                                  disabled={practitionerResetLinkSending || !selectedPractitioner?.id_user}
                                  onClick={handleSendPractitionerResetLink}
                                >
                                  {practitionerResetLinkSending
                                    ? <FormattedMessage id="home.loading" defaultMessage="Loading..." />
                                    : <FormattedMessage id="practitioner.platform.sendResetLink" defaultMessage="Envoyer un lien de réinitialisation" />}
                                </button>
                              )
                            ) : (
                              practitionerCredSent ? (
                                <span style={{ color: '#2e7d32', fontWeight: 700, fontSize: '0.88em', alignSelf: 'center' }}>
                                  &#x2713; <FormattedMessage id="practitioner.platform.emailSent" defaultMessage="Email envoyé" />
                                </span>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-outline-info btn-sm"
                                  disabled={practitionerCredSending || !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(((specialtyEmail || '').trim() || (selectedPractitioner?.mssante_email || selectedPractitioner?.msmail || '').trim())))}
                                  onClick={handleSendPractitionerCredentials}
                                >
                                  {practitionerCredSending
                                    ? <FormattedMessage id="home.loading" defaultMessage="Loading..." />
                                    : <FormattedMessage id="practitioner.platform.resendCredentials" defaultMessage="Renvoyer les identifiants" />}
                                </button>
                              )
                            )
                          )}
                        </div>
                        {specialtyInviteError === 'send_failed' && (
                          <div style={{ color: '#dc3545', fontSize: '0.8em', textAlign: 'center', marginTop: 4 }}>
                            <FormattedMessage id="staff.inviteError" defaultMessage="Erreur lors de l'envoi de l'invitation" />
                          </div>
                        )}
                      </>
                    )}
                  </div>
                )}
              </Card>
            )}
            {(userIsSuperAdmin(props.accountInformation) || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("concerned_speciality_and_delegation"))) && props.displayDevicesParams !== "no" && selectedSpecialty !== '' && (
              <Card
                bordered={true}
                style={{
                  marginTop: 10,
                  marginBottom: 15,
                  borderRadius: '20px',
                  borderColor: 'black',
                  width: '100%'
                }}
                bodyStyle={{ padding: 15 }}
              >
                <div style={{ fontWeight: "bold", fontSize: "1em", textAlign: "center", marginBottom: 10 }}>
                  <FormattedMessage id="patient.ordonnance" defaultMessage="Ordonnance (prescription)" />
                </div>
                {ordonnanceFilename ? (
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, flexWrap: "wrap" }}>
                    <Icon name='file' size='large' />
                    <span>{ordonnanceFilename}</span>
                    <button type="button" className="btn btn-outline-danger btn-sm" onClick={handleRemoveOrdonnance}>
                      <FormattedMessage id="patient.removeDocument" defaultMessage="Remove" />
                    </button>
                  </div>
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <input
                      ref={ordonnanceInputRef}
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={handleOrdonnanceUpload}
                      style={{ display: "none" }}
                    />
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => ordonnanceInputRef.current && ordonnanceInputRef.current.click()}
                    >
                      <FormattedMessage id="patient.uploadOrdonnance" defaultMessage="Upload ordonnance" />
                    </button>
                  </div>
                )}
              </Card>
            )}
            {(userIsSuperAdmin(props.accountInformation) || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("concerned_speciality_and_delegation"))) && props.displayDevicesParams !== "no" && selectedSpecialty !== '' && (
              <Card
                bordered={true}
                style={{
                  marginTop: 10,
                  marginBottom: 15,
                  borderRadius: '20px',
                  borderColor: 'black',
                  width: '100%'
                }}
                bodyStyle={{ padding: 15 }}
              >
                <div style={{ fontWeight: "bold", fontSize: "1em", textAlign: "center", marginBottom: 10 }}>
                  <FormattedMessage id="patient.consentement" defaultMessage="Consentement" />
                </div>
                <div style={{ textAlign: "center" }}>
                    {consentementFilename ? (
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6, flexWrap: "wrap" }}>
                        <Icon name='file' size='large' />
                        <span style={{ fontSize: "0.9em" }}>{consentementFilename}</span>
                        <button type="button" className="btn btn-outline-danger btn-sm" onClick={handleRemoveConsentement}>
                          <FormattedMessage id="patient.removeDocument" defaultMessage="Remove" />
                        </button>
                      </div>
                    ) : (
                      <>
                        <input
                          ref={consentementInputRef}
                          type="file"
                          accept=".pdf,.jpg,.jpeg,.png"
                          onChange={handleConsentementUpload}
                          style={{ display: "none" }}
                        />
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-sm"
                          onClick={() => consentementInputRef.current && consentementInputRef.current.click()}
                        >
                          <FormattedMessage id="patient.uploadConsentement" defaultMessage="Upload consentement" />
                        </button>
                      </>
                    )}
                </div>
              </Card>
            )}
            {(userIsSuperAdmin(props.accountInformation) || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("concerned_speciality_and_delegation"))) && props.displayDevicesParams !== "no" && selectedSpecialty !== '' && hasLppCode && (!isPsadStructureUser || psadStructureShares.some(s => s.id_structure === props.accountInformation.FK_structure) || (isPsadStructureUser && userIsAdmin(props.accountInformation))) && (
              <Card
                bordered={true}
                style={{
                  marginTop: 10,
                  marginBottom: 15,
                  borderRadius: '20px',
                  borderColor: 'black',
                  width: '100%'
                }}
                bodyStyle={{ padding: 15 }}
              >
                <div style={{ marginTop: 15 }}>
                    {/* === DELEGATE MEDICAL ALERTS === */}
                    <div style={{ fontWeight: "bold", fontSize: "0.95em", textAlign: "center", marginBottom: 8 }}>
                      <FormattedMessage id="patient.delegateMedicalAlerts" defaultMessage="Delegate Medical alerts?" />
                      {isPneumologie && <span style={{ color: "#dc3545", marginLeft: 4 }}>*</span>}
                    </div>
                    <div style={{ display: "flex", justifyContent: "center", marginBottom: 4 }}>
                      <Switch3>
                        {[{ id: 'no', label: intl.formatMessage({ id: 'patient.no', defaultMessage: 'No' }) },
                          { id: 'na', label: 'N/A' },
                          { id: 'yes', label: intl.formatMessage({ id: 'patient.yes', defaultMessage: 'Yes' }) }]
                          .map((item) => (
                            <span
                              key={item.id}
                              data-tooltip-id={item.id === 'yes' ? `delegate-medical-yes-tooltip-${props.profileData.Patient_Data.id_patient}` : undefined}
                              data-tooltip-place="top"
                            >
                              <SwitchRadio
                                type="radio"
                                id={`delegate-medical-${props.profileData.Patient_Data.id_patient}-${item.id}`}
                                name={`delegate-medical-${props.profileData.Patient_Data.id_patient}`}
                                value={item.id}
                                checked={delegateMedicalAlerts === item.id}
                                onChange={() => item.id !== 'yes' && handleDelegateMedicalAlertsChange(item.id)}
                                disabled={item.id === 'yes'}
                              />
                              <SwitchLabel
                                htmlFor={`delegate-medical-${props.profileData.Patient_Data.id_patient}-${item.id}`}
                                onClick={() => item.id !== 'yes' && handleDelegateMedicalAlertsChange(item.id)}
                                style={item.id === 'yes' ? { cursor: 'not-allowed', opacity: 0.6 } : {}}
                              >
                                {item.label}
                              </SwitchLabel>
                            </span>
                          ))
                        }
                        <SwitchSelection style={{ left: `${{ no: 0, na: 60, yes: 120 }[delegateMedicalAlerts]}px`, background: delegateMedicalAlerts === 'no' ? '#dc3545' : delegateMedicalAlerts === 'yes' ? '#4CAF50' : '#888' }} />
                      </Switch3>
                      <Tooltip id={`delegate-medical-yes-tooltip-${props.profileData.Patient_Data.id_patient}`} content={intl.formatMessage({ id: 'patient.delegateMedicalAlertsDisabledTooltip', defaultMessage: 'Merci de contacter E-takescare pour cette fonctionnalité' })} />
                    </div>
                    {delegateMedicalAlerts === 'yes' && (
                      <div style={{ marginTop: 12, textAlign: "center" }}>
                        {delegateMedicalPractitioner ? (
                          <div>
                            {delegateMedicalAlreadyAccepted && (
                              <div style={{ fontSize: '0.82em', color: '#555', marginBottom: 6 }}>
                                <FormattedMessage id="patient.delegateMedicalAssignedTo" defaultMessage="Alertes médicales déléguées à :" />
                              </div>
                            )}
                            <div style={{ display: "inline-block", background: "#e8f5e9", border: "1px solid #4CAF50", borderRadius: 6, padding: "6px 14px", marginBottom: 8 }}>
                              <span style={{ color: "#2e7d32", fontWeight: "bold", fontSize: "0.9em" }}>
                                ✓ {delegateMedicalPractitioner.family} {delegateMedicalPractitioner.given ? delegateMedicalPractitioner.given.join(" ") : ""}
                              </span>
                              {(() => {
                                const emailPart = delegateMedicalEmail || delegateMedicalPractitioner.msmail || delegateMedicalPractitioner.mssante_email || delegateMedicalPractitioner.email || '';
                                const rppsPart = delegateMedicalPractitioner.rpps ? `RPPS: ${delegateMedicalPractitioner.rpps}` : '';
                                const detail = [emailPart, rppsPart].filter(Boolean).join(' \u2014 ');
                                return detail ? <span style={{ color: "#555", fontSize: "0.85em", display: "block" }}>({detail})</span> : null;
                              })()}
                            </div>
                            <div>
                              {canChangeDelegateMedicalPractitioner && (
                              <button
                                type="button"
                                className="btn btn-outline-primary btn-sm"
                                style={{ marginRight: 6 }}
                                onClick={() => setDisplayAddPractitionerPopupMedical(true)}
                              >
                                <FormattedMessage id="patient.changePractitioner" defaultMessage="Change practitioner" />
                              </button>
                              )}
                              {canRemoveDelegateMedicalPractitioner && (
                              <button
                                type="button"
                                className="btn btn-outline-danger btn-sm"
                                onClick={handleRemoveDelegateMedicalPractitioner}
                              >
                                {currentUserRpps && currentUserRpps === props.profileData.Patient_Data.delegate_medical_alert
                                  ? <FormattedMessage id="patient.removeYou" defaultMessage="Remove you" />
                                  : <FormattedMessage id="patient.removePractitioner" defaultMessage="Remove physician" />}
                              </button>
                              )}
                            </div>
                          </div>
                        ) : canChangeDelegateMedicalPractitioner ? (
                          <button
                            type="button"
                            className="btn btn-outline-primary btn-sm"
                            onClick={() => setDisplayAddPractitionerPopupMedical(true)}
                          >
                            <FormattedMessage id="patient.searchPractitioner" defaultMessage="Search practitioner" />
                          </button>
                        ) : null}
                        {/* Email + welcome invitation — only when a practitioner is selected and invite not yet accepted */}
                        {delegateMedicalPractitioner && !delegateMedicalAlreadyAccepted && <div style={{ marginTop: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
                          {delegateMedicalInviteSent ? (
                            <div style={{
                              background: (delegateMedicalInviteError === 'already_exists' || (!delegateMedicalInviteError && !delegateMedicalSendWelcome)) ? '#e8f5e9' : '#fff3cd',
                              border: `1px solid ${(delegateMedicalInviteError === 'already_exists' || (!delegateMedicalInviteError && !delegateMedicalSendWelcome)) ? '#4CAF50' : '#f0ad4e'}`,
                              borderRadius: 6, padding: '8px 14px', textAlign: 'center', fontSize: '0.88em', width: '100%'
                            }}>
                              {delegateMedicalInviteError === 'already_exists' ? (
                                <div style={{ color: '#2e7d32', fontWeight: 'bold' }}>
                                  <FormattedMessage id="staff.userAlreadyRegistered" defaultMessage="Médecin déjà enregistré sur la plateforme" />
                                </div>
                              ) : delegateMedicalInviteError === 'already_invited' ? (
                                <div style={{ color: '#856404', fontWeight: 'bold' }}>
                                  <FormattedMessage id="staff.invitationAlreadySent" defaultMessage="Invitation déjà envoyée — en attente d'acceptation" />
                                </div>
                              ) : delegateMedicalSendWelcome ? (
                                <div style={{ color: '#856404', fontWeight: 'bold' }}>
                                  <FormattedMessage id="staff.assignedAndInvited" defaultMessage="Identifiants envoyés et Médecin attribué à ce patient avec succès" />
                                </div>
                              ) : (
                                <div style={{ color: '#2e7d32', fontWeight: 'bold' }}>
                                  <FormattedMessage id="staff.assignedToPatient" defaultMessage="Médecin attribué à ce patient avec succès" />
                                </div>
                              )}
                              {currentUserRpps && delegateMedicalPractitioner?.rpps && currentUserRpps === delegateMedicalPractitioner.rpps && (
                                <div style={{ color: '#1565c0', fontSize: '0.85em', marginTop: 4, fontWeight: 'bold' }}>
                                  ★ <FormattedMessage id="staff.youAreAssignedPractitioner" defaultMessage="Vous êtes le médecin en charge de ce patient" />
                                </div>
                              )}
                              <div style={{ marginTop: 4, color: '#444' }}>
                                <b>{delegateMedicalPractitioner.family} {Array.isArray(delegateMedicalPractitioner.given) ? delegateMedicalPractitioner.given.join(' ') : (delegateMedicalPractitioner.given || '')}</b>
                                {delegateMedicalEmail && <div style={{ fontSize: '0.9em', color: '#666' }}>{delegateMedicalEmail}</div>}
                              </div>
                              <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm"
                                style={{ marginTop: 8 }}
                                onClick={() => { setDelegateMedicalInviteSent(false); setDelegateMedicalInviteError(''); }}
                              >
                                <FormattedMessage id="button.edit" defaultMessage="Modifier" />
                              </button>
                            </div>
                          ) : (
                            <>
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, width: '100%', marginTop: 8 }}>
                                <label style={{ fontWeight: 'bold', fontSize: '0.85em', marginBottom: 2, textAlign: 'center' }}>
                                  <FormattedMessage id="practitioner.manual.mssanteOrEmail" defaultMessage="Adresse MSSanté ou email de ce médecin" />
                                </label>
                                {delegateMedicalEmailLocked && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(delegateMedicalEmail.trim()) ? (
                                  <span style={{ fontSize: '0.9em', color: '#333', background: '#f5f5f5', border: '1px solid #ddd', borderRadius: 4, padding: '5px 10px', width: '60%', boxSizing: 'border-box', textAlign: 'center' }}>
                                    {delegateMedicalEmail}
                                  </span>
                                ) : (
                                  <input
                                    type="email"
                                    value={delegateMedicalEmail}
                                    onChange={(e) => { setDelegateMedicalEmail(e.target.value); setDelegateMedicalEmailLocked(false); setDelegateMedicalInviteSent(false); setDelegateMedicalEmailError(''); if (!e.target.value.trim()) setDelegateMedicalSendWelcome(false); }}
                                    placeholder="email@exemple.com"
                                    style={{ padding: '6px 10px', borderRadius: 4, border: `1px solid ${!delegateMedicalEmail.trim() ? '#ccc' : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(delegateMedicalEmail.trim()) ? '#4CAF50' : '#dc3545'}`, width: '60%', fontSize: '0.9em', boxSizing: 'border-box', textAlign: 'center' }}
                                  />
                                )}
                                {delegateMedicalEmail.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(delegateMedicalEmail.trim()) && (
                                  <div style={{ color: '#dc3545', fontSize: '0.8em' }}>
                                    <FormattedMessage id="practitioner.manual.invalidEmail" defaultMessage="L'adresse email n'est pas valide" />
                                  </div>
                                )}
                              </div>

                              <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                                <span
                                  data-tooltip-id={!delegateMedicalEmail.trim() ? `delegate-welcome-tooltip-${props.profileData.Patient_Data.id_patient}` : undefined}
                                  data-tooltip-place="top"
                                >
                                  <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: !delegateMedicalEmail.trim() ? 'not-allowed' : 'pointer', fontSize: '0.85em', marginBottom: 0, opacity: !delegateMedicalEmail.trim() ? 0.45 : 1 }}>
                                    <input
                                      type="checkbox"
                                      checked={delegateMedicalSendWelcome}
                                      disabled={!delegateMedicalEmail.trim()}
                                      onChange={(e) => setDelegateMedicalSendWelcome(e.target.checked)}
                                    />
                                    <FormattedMessage id="staff.sendWelcomeEmail" defaultMessage="Envoyer un email de bienvenue/inscription" />
                                  </label>
                                </span>
                                {!delegateMedicalEmail.trim() && <Tooltip id={`delegate-welcome-tooltip-${props.profileData.Patient_Data.id_patient}`} content={intl.formatMessage({ id: 'staff.emailRequiredToInvite', defaultMessage: "Veuillez renseigner l'adresse email pour inviter ce médecin" })} />}
                              </div>

                              <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                                <span
                                  data-tooltip-id={delegateMedicalSendWelcome && !delegateMedicalEmail.trim() ? `delegate-invite-btn-tooltip-${props.profileData.Patient_Data.id_patient}` : undefined}
                                  data-tooltip-place="top"
                                >
                                  <button
                                    type="button"
                                    className="btn btn-outline-primary btn-sm"
                                    disabled={delegateMedicalSendWelcome && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(delegateMedicalEmail.trim())}
                                    onClick={handleSendDelegateMedicalInvitation}
                                  >
                                    {delegateMedicalSendWelcome
                                      ? <FormattedMessage id="staff.assignAndInvite" defaultMessage="Attribuer et inviter ce médecin par mail" />
                                      : <FormattedMessage id="staff.assignToPatient" defaultMessage="Attribuer au patient" />
                                    }
                                  </button>
                                </span>
                                {delegateMedicalSendWelcome && !delegateMedicalEmail.trim() && <Tooltip id={`delegate-invite-btn-tooltip-${props.profileData.Patient_Data.id_patient}`} content={intl.formatMessage({ id: 'staff.emailRequiredToInvite', defaultMessage: "Veuillez renseigner l'adresse email pour inviter ce médecin" })} />}
                              </div>
                              {delegateMedicalInviteError === 'send_failed' && (
                                <div style={{ color: '#dc3545', fontSize: '0.8em', textAlign: 'center', marginTop: 4 }}>
                                  <FormattedMessage id="staff.inviteError" defaultMessage="Erreur lors de l'envoi de l'invitation" />
                                </div>
                              )}
                            </>
                          )}
                        </div>}
                      </div>
                    )}

                    {(isPsadStructureUser || delegateMedicalAlerts !== 'yes' || (currentUserRpps && currentUserRpps === props.profileData.Patient_Data.delegate_medical_alert) || userIsSuperAdmin(props.accountInformation)) && (<>
                    <hr style={{ margin: "14px 0" }} />

                    {/* === DELEGATE NON-MEDICAL ALERTS === */}
                    <div style={{ fontWeight: "bold", fontSize: "0.95em", textAlign: "center", marginBottom: 8 }}>
                      <FormattedMessage id="patient.delegateNonMedicalAlerts" defaultMessage="Delegate non-medical alerts" />
                    </div>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
                      <span style={{ fontWeight: delegateNonMedicalAlerts ? "normal" : "bold" }}>
                        <FormattedMessage id="patient.no" defaultMessage="No" />
                      </span>
                      <Switch
                        onChange={async (checked) => {
                          if (checked) {
                            // Turning ON is visual only: the field is set in DB only when a
                            // PSAD is actually assigned (handleSendDelegateInvitation).
                            setDelegateNonMedicalAlerts(true);
                            return;
                          }
                          // Turning OFF: if a PSAD is already linked, confirm before removing.
                          const hasLinkedPsad = psadStructureShares.length > 0 || !!psadDelegate
                            || (!!savedPatient.Patient_Data.delegate_non_medical_alert
                                && savedPatient.Patient_Data.delegate_non_medical_alert !== '1');
                          if (hasLinkedPsad) {
                            setShowNonMedicalOffConfirm(true); // keep switch ON until confirmed
                            return;
                          }
                          // Nothing linked: persist '0' (explicit OFF).
                          setDelegateNonMedicalAlerts(false);
                          savedPatient.Patient_Data.delegate_non_medical_alert = 'no';
                          await PatientFunctionsGetter.update_patient_delegate_non_medical(
                            props.profileData.Patient_Data.id_patient, false
                          );
                        }}
                        checked={delegateNonMedicalAlerts}
                        onColor="#4CAF50"
                        offColor="#ccc"
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={22}
                        width={44}
                      />
                      <span style={{ fontWeight: delegateNonMedicalAlerts ? "bold" : "normal" }}>
                        <FormattedMessage id="patient.yes" defaultMessage="Yes" />
                      </span>
                    </div>

                    {/* Confirmation popup when disabling non-medical delegation with a PSAD linked
                        (design mirrors the structure-share removal popup in PatientParamsShareTab). */}
                    {showNonMedicalOffConfirm && (
                      <div className={classes.popup_background}>
                        <div style={{ height: "100%", display: "grid", placeItems: "center" }}>
                          <div style={{ width: "90%", maxWidth: 440, backgroundColor: "white", borderRadius: "10px", overflow: "hidden", boxShadow: "0 8px 32px rgba(0,0,0,0.18)" }}>
                            <div style={{ backgroundColor: "#c0392b", padding: "16px 20px", display: "flex", alignItems: "center", gap: "10px" }}>
                              <span style={{ color: "white", fontSize: "1.4em" }}>⚠</span>
                              <span style={{ color: "white", fontWeight: "bold", fontSize: "1.05em" }}>
                                <FormattedMessage id="patient.disablePsadTitle" defaultMessage="Retirer la délégation PSAD" />
                              </span>
                            </div>
                            <div style={{ padding: "24px 24px 8px 24px", textAlign: "center", color: "#333", fontSize: "1em" }}>
                              <FormattedMessage id="patient.disablePsadConfirm" defaultMessage="Désactiver la délégation des alertes non médicales retirera les PSAD liés à ce patient. Confirmer ?" />
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between", padding: "20px 24px 24px 24px", gap: "12px" }}>
                              <button onClick={() => setShowNonMedicalOffConfirm(false)} className="btn btn-outline-secondary" style={{ flex: 1, borderRadius: "6px", fontWeight: "500" }}>
                                <FormattedMessage id="button.cancel" defaultMessage="Annuler" />
                              </button>
                              <button onClick={confirmDisableNonMedicalDelegate} className="btn btn-danger" style={{ flex: 1, borderRadius: "6px", fontWeight: "500" }}>
                                <FormattedMessage id="button.confirm" defaultMessage="Confirmer" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* === INVITE A PSAD USER - visible only when non-medical alert is Yes === */}
                    {delegateNonMedicalAlerts && <div style={{ marginTop: 15 }}>
                        {isPsadStructureUser && psadDelegate && String(psadDelegate) === String(props.accountInformation.FK_structure) ? (
                          <div style={{ textAlign: "center" }}>
                            <div style={{ display: "inline-block", background: "#e8f5e9", border: "1px solid #4CAF50", borderRadius: 6, padding: "6px 14px", marginBottom: 6 }}>
                              <span style={{ color: "#2e7d32", fontWeight: "bold", fontSize: "0.9em" }}>
                                ✓ <FormattedMessage id="patient.psadDelegateAssignedToYou" defaultMessage="Délégation alertes non médicales assignée à votre structure" />
                              </span>
                            </div>
                            <div style={{ marginTop: 8 }}>
                              {psadRevokeLoading ? (
                                <span style={{ fontSize: "0.85em", color: "#888" }}>
                                  <FormattedMessage id="share.remove" defaultMessage="Suppression du partage, veuillez patienter..." />
                                </span>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-outline-danger btn-sm"
                                  onClick={handleRevokePsadOwnShare}
                                >
                                  <FormattedMessage id="patient.revokePsadShare" defaultMessage="Ne plus prendre en charge" />
                                </button>
                              )}
                            </div>
                          </div>
                        ) : psadDelegate ? (() => {
                          const psadPendingInvites = pendingInvites.filter(inv => !inv.invite_type || inv.invite_type === 'delegate_non_medical_alert');
                          const isPending = psadPendingInvites.length > 0;
                          const struct = psadStructures.find(s => s.id_structure === psadDelegate)
                            || psadStructureShares.find(s => s.id_structure === psadDelegate);
                          return (
                            <div style={{ textAlign: "center" }}>
                              {isPending ? (
                                <div style={{ display: "inline-block", background: "#fff8e1", border: "1px solid #f0ad4e", borderRadius: 6, padding: "6px 14px", marginBottom: 6 }}>
                                  <span style={{ color: "#856404", fontWeight: "bold", fontSize: "0.9em" }}>
                                    ⏳ <FormattedMessage id="patient.delegatePending" defaultMessage="En attente d'acceptation" />
                                  </span>
                                </div>
                              ) : (
                                <div style={{ display: "inline-block", background: "#e8f5e9", border: "1px solid #4CAF50", borderRadius: 6, padding: "6px 14px", marginBottom: 6 }}>
                                  <span style={{ color: "#2e7d32", fontWeight: "bold", fontSize: "0.9em" }}>
                                    ✓ <FormattedMessage id="patient.delegateAssigned" defaultMessage="Delegate assigned" />
                                  </span>
                                </div>
                              )}
                              {struct && (
                                <div style={{ fontSize: "0.88em", color: "#444", marginBottom: 8 }}>
                                  <span
                                    style={{ fontWeight: "bold", cursor: struct.email ? "help" : "default" }}
                                    title={struct.email || undefined}
                                  >{struct.structure_name}</span>
                                </div>
                              )}
                              {isPending && (
                                <table style={{ width: "100%", fontSize: "0.85em", borderCollapse: "collapse", marginBottom: 8 }}>
                                  <tbody>
                                    {psadPendingInvites.map((inv) => {
                                      const structLabel = inv.recipient_structure_name || inv.delegate_name || '-';
                                      const emailLabel  = inv.recipient_structure_email || inv.recipient_mail_address || '-';
                                      return (
                                        <tr key={inv.request_id} style={{ borderBottom: "1px solid #eee" }}>
                                          <td style={{ padding: "4px 8px" }}>
                                            {structLabel.length > 15
                                              ? <span title={structLabel} style={{ cursor: 'default' }}>{structLabel.substring(0, 15)}…</span>
                                              : structLabel}
                                          </td>
                                          <td style={{ padding: "4px 8px" }}>
                                            {emailLabel.length > 15
                                              ? <span title={emailLabel} style={{ cursor: 'default' }}>{emailLabel.substring(0, 15)}…</span>
                                              : emailLabel}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              )}
                              <div>
                                <button
                                  type="button"
                                  className="btn btn-outline-danger btn-sm"
                                  onClick={handleRemoveDelegate}
                                >
                                  <FormattedMessage id="patient.removeDelegate" defaultMessage="Remove delegate" />
                                </button>
                              </div>
                            </div>
                          );
                        })() : (
                          /* psad_delegate is empty: always offer the PSAD structures
                             selector so a new structure can be assigned, even right
                             after a previous assignment was removed (switch stays on). */
                          <>
                            <div style={{ fontWeight: "bold", fontSize: "0.95em", textAlign: "center", marginBottom: 8 }}>
                              <FormattedMessage id="patient.sendDelegateInviteLabel" defaultMessage="Invite a PSAD user" />
                            </div>
                            {pendingInvites.filter(inv => !inv.invite_type || inv.invite_type === 'delegate_non_medical_alert').length > 0 && (
                              <div style={{ marginBottom: 12 }}>
                                <div style={{ fontWeight: "bold", fontSize: "0.95em", textAlign: "center", marginBottom: 6 }}>
                                  <FormattedMessage id="patient.pendingInvitesTitle" defaultMessage="Pending invitations" />
                                </div>
                                <table style={{ width: "100%", fontSize: "0.85em", borderCollapse: "collapse" }}>
                                  <thead>
                                    <tr style={{ borderBottom: "2px solid #ddd", textAlign: "left" }}>
                                      <th style={{ padding: "4px 8px" }}><FormattedMessage id="patient.delegateStructureLabel" defaultMessage="Nom de structure" /></th>
                                      <th style={{ padding: "4px 8px" }}>Email</th>
                                      <th style={{ padding: "4px 8px" }}><FormattedMessage id="patient.delegatePhoneLabel" defaultMessage="Phone" /></th>
                                      <th style={{ padding: "4px 8px", width: 1 }}></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {pendingInvites.filter(inv => !inv.invite_type || inv.invite_type === 'delegate_non_medical_alert').map((inv) => {
                                      const structLabel = inv.recipient_structure_name || inv.delegate_name || '-';
                                      const emailLabel  = inv.recipient_structure_email || inv.recipient_mail_address || '-';
                                      return (
                                      <tr key={inv.request_id} style={{ borderBottom: "1px solid #eee" }}>
                                        <td style={{ padding: "4px 8px" }}>
                                          {structLabel.length > 15
                                            ? <span title={structLabel} style={{ cursor: 'default' }}>{structLabel.substring(0, 15)}…</span>
                                            : structLabel}
                                        </td>
                                        <td style={{ padding: "4px 8px" }}>
                                          {emailLabel.length > 15
                                            ? <span title={emailLabel} style={{ cursor: 'default' }}>{emailLabel.substring(0, 15)}…</span>
                                            : emailLabel}
                                        </td>
                                        <td style={{ padding: "4px 8px" }}>{inv.delegate_phone || '-'}</td>
                                        <td style={{ padding: "4px 8px", textAlign: "right" }}>
                                          <button
                                            type="button"
                                            className="btn btn-outline-danger btn-sm"
                                            title="Annuler l'invitation"
                                            onClick={() => setInviteToCancel(inv)}
                                          >
                                            &times;
                                          </button>
                                        </td>
                                      </tr>
                                      );})}
                                  </tbody>
                                </table>
                              </div>
                            )}
                            {pendingInvites.filter(inv => !inv.invite_type || inv.invite_type === 'delegate_non_medical_alert').length === 0 && (
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
                              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
                                <label style={{ fontWeight: "bold", fontSize: "0.9em", textAlign: "center" }}>
                                  <FormattedMessage id="patient.delegateStructureLabel" defaultMessage="Nom de structure" /> *
                                </label>
                                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                  <select
                                    value={selectedPsadStructure}
                                    onChange={handleSelectPsadStructure}
                                    style={{ padding: '5px 10px', borderRadius: 4, border: '1px solid #ccc', minWidth: 220 }}
                                  >
                                    <option value="">{intl.formatMessage({ id: "patient.selectStructure", defaultMessage: "-- Sélectionner une structure --" })}</option>
                                    {psadStructures.map(s => (
                                      <option key={s.id_structure} value={s.id_structure}>{s.structure_name}</option>
                                    ))}
                                  </select>
                                  <button
                                    type="button"
                                    className="btn btn-outline-success btn-sm"
                                    onClick={() => setShowAddStructureForm(!showAddStructureForm)}
                                    title={intl.formatMessage({ id: "patient.addStructure", defaultMessage: "Ajouter une structure" })}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                              {showAddStructureForm && (
                                <div style={{ border: '1px solid #ccc', borderRadius: 8, padding: 12, marginTop: 4, marginBottom: 4, background: '#f9f9f9', width: '100%', maxWidth: 400 }}>
                                  <div style={{ fontWeight: "bold", fontSize: "0.9em", textAlign: "center", marginBottom: 8 }}>
                                    <FormattedMessage id="patient.newStructureTitle" defaultMessage="Nouvelle structure PSAD" />
                                  </div>
                                  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                      <label style={{ fontWeight: "bold", fontSize: "0.85em", minWidth: 70, textAlign: "right" }}>
                                        <FormattedMessage id="patient.structureNameLabel" defaultMessage="Nom" /> *
                                      </label>
                                      <input
                                        type="text"
                                        value={newStructureName}
                                        onChange={(e) => setNewStructureName(e.target.value)}
                                        placeholder={intl.formatMessage({ id: "patient.structureNamePlaceholder", defaultMessage: "Nom de la structure..." })}
                                        style={{ padding: '4px 8px', borderRadius: 4, border: '1px solid #ccc', flex: 1 }}
                                      />
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                      <label style={{ fontWeight: "bold", fontSize: "0.85em", minWidth: 70, textAlign: "right" }}>
                                        Email *
                                      </label>
                                      <input
                                        type="email"
                                        value={newStructureEmail}
                                        onChange={(e) => setNewStructureEmail(e.target.value)}
                                        placeholder={intl.formatMessage({ id: "patient.structureEmailPlaceholder", defaultMessage: "Email de la structure..." })}
                                        style={{ padding: '4px 8px', borderRadius: 4, border: '1px solid #ccc', flex: 1 }}
                                      />
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                      <label style={{ fontWeight: "normal", fontSize: "0.85em", minWidth: 70, textAlign: "right" }}>
                                        <FormattedMessage id="patient.structurePhoneLabel" defaultMessage="Téléphone" />
                                      </label>
                                      <input
                                        type="tel"
                                        value={newStructurePhone}
                                        onChange={(e) => setNewStructurePhone(e.target.value)}
                                        placeholder={intl.formatMessage({ id: "patient.structurePhonePlaceholder", defaultMessage: "Numéro de téléphone..." })}
                                        style={{ padding: '4px 8px', borderRadius: 4, border: '1px solid #ccc', flex: 1 }}
                                      />
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 4 }}>
                                      <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm"
                                        onClick={handleCreateStructure}
                                        disabled={!newStructureName.trim() || !newStructureEmail.trim()}
                                      >
                                        <FormattedMessage id="patient.createStructure" defaultMessage="Créer" />
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-outline-secondary btn-sm"
                                        onClick={() => setShowAddStructureForm(false)}
                                      >
                                        <FormattedMessage id="patient.cancel" defaultMessage="Annuler" />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
                                <label style={{ fontWeight: "bold", fontSize: "0.9em", textAlign: "center" }}>
                                  <FormattedMessage id="patient.delegateShareScopeLabel" defaultMessage="Partager avec" />
                                </label>
                                <select
                                  value={psadShareScope}
                                  onChange={(e) => setPsadShareScope(e.target.value)}
                                  style={{ padding: '5px 10px', borderRadius: 4, border: '1px solid #ccc', minWidth: 220 }}
                                >
                                  <option value="all">{intl.formatMessage({ id: "patient.delegateShareScopeAll", defaultMessage: "Tous les utilisateurs de la structure" })}</option>
                                  <option value="admin">{intl.formatMessage({ id: "patient.delegateShareScopeAdmin", defaultMessage: "Administrateurs uniquement" })}</option>
                                </select>
                              </div>
                              <button
                                type="button"
                                className="btn btn-outline-primary btn-sm"
                                onClick={handleSendDelegateInvitation}
                                disabled={!selectedPsadStructure || delegateInviteSent || delegateInviteSending}
                              >
                                {delegateInviteSent ? (
                                  <FormattedMessage id="patient.delegateInviteSent" defaultMessage="Invitation sent" />
                                ) : (
                                  <FormattedMessage id="patient.sendDelegateInvite" defaultMessage="Send invitation" />
                                )}
                              </button>
                            </div>
                            )}
                            {delegateInviteSent && (
                              <div style={{ textAlign: "center", marginTop: 6, color: "#4CAF50", fontWeight: "bold", fontSize: "0.9em" }}>
                                <FormattedMessage id="patient.delegateInviteSuccess" defaultMessage="Invitation sent successfully!" />
                              </div>
                            )}
                            {delegateInviteError === 'name_required' && (
                              <div style={{ textAlign: "center", marginTop: 6, color: "#dc3545", fontSize: "0.9em" }}>
                                <FormattedMessage id="patient.delegateNameRequired" defaultMessage="Name is required." />
                              </div>
                            )}
                            {delegateInviteError === 'invalid_email' && (
                              <div style={{ textAlign: "center", marginTop: 6, color: "#dc3545", fontSize: "0.9em" }}>
                                <FormattedMessage id="patient.delegateInvalidEmail" defaultMessage="Please enter a valid email address." />
                              </div>
                            )}
                            {delegateInviteError === 'send_failed' && (
                              <div style={{ textAlign: "center", marginTop: 6, color: "#dc3545", fontSize: "0.9em" }}>
                                <FormattedMessage id="patient.delegateInviteError" defaultMessage="Error sending invitation." />
                              </div>
                            )}
                          </>
                        )}
                    </div>}
                    </>)}
                  </div>
              </Card>
            )}
          </Col>
        </Row>
        <br/>
        {displayAddPractitionerPopup && (
          <AddPractitionerPopup
            cancelPopup={() => setDisplayAddPractitionerPopup(false)}
            onSelectPractitioner={handleSelectPractitioner}
            restrictToStructure={userIsSuperAdmin(props.accountInformation) ? null : (props.accountInformation?.FK_structure || null)}
            attributeToStructureId={userIsSuperAdmin(props.accountInformation) ? (props.accountInformation?.FK_structure || null) : null}
          />
        )}
        {displayAddPractitionerPopupMedical && (
          <AddPractitionerPopup
            cancelPopup={() => setDisplayAddPractitionerPopupMedical(false)}
            onSelectPractitioner={handleSelectDelegateMedicalPractitioner}
            restrictToStructure={props.accountInformation?.FK_structure || null}
          />
        )}
      </div>
    )
  }

  const testThermometerType = () => {
    let sensor = (props.device_list.find(device => device.id_device === selectedDeviceList.device1.id));
    return (sensor !== undefined && sensor.sn !== undefined && sensor.sn.includes('-'))
  }

  const filterTuckyAOJ20 = (list, filtered_type) => {
    let list_ret = []
    list.forEach(device => {
      if (
          (device.sn.includes('-') === false && filtered_type === "Tucky") ||
          (device.sn.includes('-') === true && filtered_type === "AOJ-20") ||
          (device.id_device === "dissociate")
         )
      {
        list_ret.push(device)
      }
    })
    return list_ret
  }

  const renderDevicesDisplayer = (type, visible, setVisible, title, defaultTitle, validParams) => {
    if (validParams) {
    return (
      <div>
          <button style={{width:"100%", backgroundColor:"white", border:"0px", paddingBottom:10}} onClick={() => setVisible(!visible)}>
        <Row>
              <Col style={{display: 'flex', justifyContent:"left", fontWeight:"bold"}}>
            <FormattedMessage id={title} defaultMessage={defaultTitle}/>
          </Col>
          <Col style={{display: 'flex', justifyContent:"right"}}>
              {visible ? 
                <Icon name="dropdown" flipped='vertically'/>
                :
                <Icon name="dropdown"/>
              }
          </Col>
        </Row>
          </button>
        {type === "device" && devicesVisible && (
          <div>
            {renderGatewayParamsEdit()}
            {renderDevicesCards()}
          </div>
        )}
        {type === "module" && modulesVisible && (
          <div>
            {renderModuleUpdateForm()}
          </div>
        )}
        {type === "healthform" && healthformsVisible && (
          <div>
            {renderHealthformUpdateForm()}
          </div>
        )}
        {type === "smartphone" && smartphoneVisible && (
          <div>
            {renderSmartphoneUpdateForm()}
          </div>
        )}
      </div>
    )
  }
    else {
      return null
    }
  }

  const renderSmartphoneUpdateForm = () => {
    let module_tucky_smartphone = moduleActivation.find((m) => m.name === "tucky_smartphone")
    if (module_tucky_smartphone !== undefined && module_tucky_smartphone.used === true) {
      let this_fever_alert = alert_filling("fever_alert")
    return(
      <div>
          <div style={{fontStyle:"italic"}}>
            {renderDeviceUpdateForm("Tucky_smartphone", {type: "Tucky_smartphone"})}
          </div>
      </div>
    )
  }
  }

  const convertGatewayListNoAssociate = (list) => {
    let converted_list = list;
    converted_list[0].fullname = "--";
    return (converted_list);
  }

  const renderCardCategories = () => {

    return (
      <div>
        {renderDevicesDisplayer("device", devicesVisible, setDevicesVisible, "home.sensors", "Devices", Utils.testIsDevicesAndGatewayAssociate(selectedDeviceList))}
        {renderDevicesDisplayer("module", modulesVisible, setModulesVisible, "devices.modules", "Modules", Utils.testModuleInListUsed(moduleActivation, ["niv", "oxigen_therapy"]))}
        {renderDevicesDisplayer("healthform", healthformsVisible, setHealthformsVisible, "devices.healthforms", "Healthforms", Utils.testModuleInListUsed(moduleActivation, ["pain", "EQ5D", "SF36", "MDASI", "alimentation"]))}
        {renderDevicesDisplayer("smartphone", smartphoneVisible, setSmartphoneVisible, "param.SwitchMonitoringSmartphone", "Smartphone", Utils.testModuleInListUsed(moduleActivation, ["tucky_smartphone"]))}
      </div>
      )
    }

  //Function to render Gateway section
  const renderGatewayParamsEdit = () => {
      return(
        <div>
          {renderDeviceSelectRow("gateway", convertGatewayListNoAssociate(effectiveGwList), selectedGw.id_gw, "", "", "param.empty", " ")}
        </div>
      )
  }

  //Function to get device type
  const get_device_name = (device) => {
    switch (device.type) {
      case 'Tucky':
      case 'Tucky_smartphone':
        if (device.sn !== undefined && device.sn.includes('-')) {
          return(<FormattedMessage id="device.thermometer.name" defaultMessage="AOJ-20" />)
        }
        else {
          return(<FormattedMessage id="device.tucky.name" defaultMessage="Tucky" />)
        }
        break
      case 'FS20F':
        return(<FormattedMessage id="device.oximeter.name" defaultMessage="Oximeter" />)
        break
      case 'BP2A':
      case 'BPB6':
        return(<FormattedMessage id="device.tensiometer.name" defaultMessage="Tensiometer" />)
        break
      case 'LESCALE':
      case 'S5':
        return(<FormattedMessage id="device.scale.name" defaultMessage="Scale" />)        
        break
      case 'pain':
        return(<FormattedMessage id="device.pain.name" defaultMessage="Pain scale" />)        
        break
      case 'niv':
        return(<FormattedMessage id="device.niv.name" defaultMessage="Breathing" />)        
        break
      case 'oxigen_therapy':
        return(<FormattedMessage id="device.oxigentherapy.name" defaultMessage="Breathing" />)        
        break
      case 'healthform_eq5d':
      case 'healthform_sf36':
      case 'healthform_mdasi':
      case 'healthform_alimentation':
        return(<FormattedMessage id="device.healthform.name" defaultMessage="Healthform" />)        
        break
    }
  }


  //Function to render patient monitoring type and devices
  const renderMonitoringParametersEdit = () => {
    let tooltip_addmodule_id = "tooltip-addmodule-" + props.profileData.Patient_Data.id_patient
    const hasExistingConfig =
      Utils.testIsDevicesAndGatewayAssociate(selectedDeviceList) ||
      Utils.testAnyModuleUsed(moduleActivation)
    const showModules = props.displayDevicesParams !== "no" && (hasExistingConfig || selectedSpecialty !== '' || !userIsSuperAdmin(props.accountInformation))
    return(
      <div style={{width: "100%"}}>
        {renderPatientMonitoringTypeEdit()}
        {showModules ?
          <div>
            {renderCardCategories()}
          </div>
          :
          null
        }
        {showModules ?
          <div style={{ display: "flex", justifyContent: "center", paddingTop: "10px" }}>
            <Tooltip style={{ zIndex: 99 }} id={tooltip_addmodule_id}>
              {props.select_tooltip("param.addmodulebutton.tooltip")}
            </Tooltip>
            <button data-tooltip-id={tooltip_addmodule_id} data-tooltip-place="bottom" style={{ backgroundColor: "grey", border: 0, borderRadius: 100, height: "40px", width: "40px" }} onClick={handleClickButton}>{addSign}</button>
          </div>
          :
          null
        }
        {hasExistingConfig && props.displayDevicesParams !== "no" ?
          renderNotificationParamsEdit()
          :
          null
        }
      </div>
    )
  }

  const checkReminderListContains = (alert_type) => {
    if (checkedReminderList !== undefined && checkedReminderList.length > 0) {
      let i = 0;
      while (checkedReminderList[i]) {
        if (checkedReminderList[i].alert_type === alert_type) {
          return true
    }
        i++;
      }
    }
    return false
  }

  const getMonitoredDataTypes = () => {
    let list = []

    //Getting monitored data
    if (!checkReminderListContains("fever_reminder")) {
      let translated_alert = intl.formatMessage({id:"popup.reminder.alerttype.fever_reminder"})
      list.push({value:"fever_reminder", text:translated_alert})
    }
    if (!checkReminderListContains("pulse_rate_reminder")) {
      let translated_alert = intl.formatMessage({id:"popup.reminder.alerttype.pulse_rate_reminder"})
      list.push({value:"pulse_rate_reminder", text:translated_alert})
    }
    if (!checkReminderListContains("SPO2_reminder")) {
      let translated_alert = intl.formatMessage({id:"popup.reminder.alerttype.SPO2_reminder"})
      list.push({value:"SPO2_reminder", text:translated_alert})
    }
    if (!checkReminderListContains("bloodpressure_systolic_high_reminder")) {
      let translated_alert = intl.formatMessage({id:"popup.reminder.alerttype.bloodpressure_systolic_high_reminder"})
      list.push({value:"bloodpressure_systolic_high_reminder", text:translated_alert})
    }
    if (!checkReminderListContains("weight_reminder")) {
      let translated_alert = intl.formatMessage({id:"popup.reminder.alerttype.weight_reminder"})
      list.push({value:"weight_reminder", text:translated_alert})
    }

    //When no data are monitored
    if (list.length === 0) {
      let translated_alert = intl.formatMessage({id:"popup.reminder.alerttype.please_monitor"})
      list.push({value:"please_monitor", text:translated_alert})
    }
    else {
      let translated_alert = intl.formatMessage({id:"popup.reminder.alerttype.please_monitor"})
      list.unshift({value:"please_monitor", text:translated_alert})
  }

    return (list)
  }


  const renderSmsAlertList = (category) => {

    let title_id
    let title_default
    let phone_number_list
    let input_on_change
    let add_on_click
    let list_member_id
    let delete_on_click
    let max_phone_number
    let countries = ["FR", "ES", "IN", "DE"]
    if (category === "notification") {
      title_id = "param.reminderPhone"
      title_default = "SMS"
      phone_number_list = smsalert;
      input_on_change = handleChangeNumberNotif;
      add_on_click = handleNewPhoneNumberNotif;
      list_member_id = "sms_alert";
      delete_on_click = handleClickButtonDeletePhoneNumber;
      max_phone_number = 3;
    }
    else if (category === "reminder_first_phone") {
      title_id = "param.reminderPhone"
      title_default = "SMS"
      phone_number_list = reminderFirstPhone;
      input_on_change = handleChangeNumberReminderFirst;
      add_on_click = handleNewPhoneNumberReminderFirst;
      list_member_id = "sms_reminder_first";
      delete_on_click = handleClickButtonDeleteReminderFirstPhone;
      max_phone_number = 3;
    }

      return (
        <Row style={{width:"100%", padding:0, paddingTop:"1%", paddingBottom:"2%", margin:0}}>
        {phone_number_list.map((phone_number, index) => {
          let id = list_member_id + index
          return (
        <Row key={id} style={{width:"100%", padding:0, margin:0}}>
              {index === 0 ?
            <Col style={{padding:0}}>
              <FormattedMessage id={title_id} defaultMessage={title_default}/>
          </Col>
                :
                <Col style={{padding:0}}>
            </Col>
              }
              <Col style={{margin:0, paddingLeft:0, paddingRight:25, maxWidth:"100%"}}>
                <PhoneInput defaultCountry="FR" countries={countries} countrySelectProps={{ unicodeFlags: true }} value={phone_number} style={{color:testValidPhoneNumber(phone_number) || phone_number === '' ? "black" : "red"}} onChange={(e) => input_on_change(e, index)} />
              </Col>
              {index === 0 ?
                <Col style={{padding:0}}>
              </Col>
                :
                      <Col style={{padding:0}}>
                  <button id={id} style={{ padding:0, border:"0px", backgroundColor:"white"}} onClick={(e) => delete_on_click(e, index)}>
                    <Icon name='minus' size='small' color='red' style={{margin:"0px", padding:0}}/>
                </button>
              </Col>
              }
              {testValidPhoneNumber(phone_number) || phone_number === '' ?
                null
                :
                <Row>
                  <Col style={{position: 'relative', left: '30%'}}>
                    <FormattedMessage id="message.error.wrongPhoneNumber" defaultMessage="Incorrect phone number(s)."/>
                  </Col>
            </Row>
          }
            </Row>
          )
        })}
        <Row>
          <Col style={{padding:0}}>
          </Col>
          <Col style={{padding:0}}>
            {phone_number_list.length >= max_phone_number ?
              null
            :
              <Icon id="id" name='add' color='green' style={{margin:"0px", paddingLeft:10}} disabled={phone_number_list.length >= max_phone_number} onClick={add_on_click} class/>
            }
          </Col>
          <Col style={{padding:0}}>
          </Col>
          <Col style={{padding:0}}>
          </Col>
        </Row>
        </Row>
      );
    }

  const renderNotificationParamsSimple = (reminder_activated) => {
    return(
      <div>
        <hr />
        <Row className="justify-content-md-end" style = {{ paddingTop:"10px", paddingBottom: "10px"}}>
          <Col style={{ fontWeight: "bold", fontSize:"1.1em", textAlign: "center" }}>
            <FormattedMessage id="param.notificationModeThreshold" defaultMessage="Notifications threshold"/>
          </Col>
        </Row>
        <Row style={{width:"100%", margin:0}}>
          <Col style={{margin:0, padding:0}}>
            <FormattedMessage id="param.mailAlert" defaultMessage="Mail"/>
          </Col>
          <Col style={{margin:0, padding:0}}>
            <input type="text" id="mail_alert" name="{props.profileData.Patient_Data.alerts.mail_alert}" value={mailalert ?? ''} style={{border: "1px solid gray"}} onChange={handleChangeMailalert}/>
          </Col>
          <Col style={{margin:0, padding:0}}>
          </Col>
        </Row>
        <Row style={{width:"100%", margin:0}}>
            {renderSmsAlertList("notification")}
        </Row>
        <br/>
        <Row>
          <Col style={{maxWidth:"27%"}}>
            <FormattedMessage id="param.sound" defaultMessage="Sound"/>
          </Col>
          <Col style={{}}>
            {renderSwitch("sound", handleChangeSoundCheck, checkedSound)}
          </Col>
          <Col>
          </Col>
        </Row>
        {reminder_activated === true ?
          <div>
        <hr />
        <Row className="justify-content-md-end" style = {{ paddingTop:"10px", paddingBottom: "10px"}}>
          <Col style={{ fontWeight: "bold", fontSize:"1.1em", textAlign: "center" }}>
            <FormattedMessage id="param.notificationModeReminder" defaultMessage="Reminder notifications"/>
          </Col>
        </Row>
        <Row style={{width:"100%", margin:0}}>
            {renderSmsAlertList("reminder_first_phone")}
        </Row>
      </div>
          :
          null
        }
      </div>
    );
  }

  const renderThreeSwitch = (day_time) => {
    return (
      <div>
      </div>
    )
  }

  const renderMultiRecipientContact = (type) => {
    let contact_list;
    let input_id;
    let input_name;
    let handleChangeValue;
    let handleDelete;
    let switchThresholdId;
    let switchThresholdChange;
    let handleChangeThreshold;
    let switchReminderId;
    let handleChangeReminderCheck;
    let switchDayNightId;
    let handleChangeDayNightCheck;
    let addContact;
    let iconName;
    switch (type) {
      case "sms":
        contact_list = smsalertMultirecipient
        input_id = "sms_alert"
        input_name = props.profileData.Patient_Data.alerts.sms_alert
        handleChangeValue = handleChangeSmsalertMulti
        handleDelete = deleteSmsMulti
        switchThresholdId = "multi_sms_threshold"
        handleChangeThreshold = handleChangeSmsalertCheckThreshold
        switchReminderId = "multi_sms_reminder"
        handleChangeReminderCheck = handleChangeSmsalertCheckReminder
        switchDayNightId = "multi_sms_daynight"
        handleChangeDayNightCheck = handleChangeSmsalertCheckDayNight
        addContact = addSmsMulti
        iconName = "phone"
        break
      case "mail":
        contact_list = mailalertMultirecipient
        input_id = "mail_alert"
        input_name = props.profileData.Patient_Data.alerts.mail_alert
        handleChangeValue = handleChangeMailalertMulti
        handleDelete = deleteMailMulti
        switchThresholdId = "multi_mail_threshold"
        handleChangeThreshold = handleChangeMailalertCheckThreshold
        switchReminderId = "multi_mail_reminder"
        handleChangeReminderCheck = handleChangeMailalertCheckReminder
        switchDayNightId = "multi_mail_daynight"
        handleChangeDayNightCheck = handleChangeMailalertCheckDayNight
        addContact = addMailMulti
        iconName = "mail"
        break
    }
    return (
      <Row style={{width:"100%", margin:0}}>
        {contact_list.map((contact, index) => {
          let daytime = contact.day_time === "day"
          return (
            <Row key={index} style={{width:"100%", margin:0, padding:0}}>
              <Col style={{margin:0, padding:0}}>
                <Row style={{width:"100%", margin:0, padding:0}}>
                  <Col style={{margin:0, padding:0}}>
                    <Icon name={iconName} size='small' style={{marginRight:"3%", padding:0}}/>
                    <input type="text" id={input_id + '_' + index} name={input_name} value={contact.value} style={{width:"87%", color:(type === "sms" && (!testValidPhoneNumber(contact.value) && contact.value !== '')) ? "red" : "black"}}  onChange={(e) => handleChangeValue(e, index)}/>
                  </Col>
                  <Col style={{margin:0, padding:0, display: 'flex', justifyContent:'center', alignItems:'center', maxWidth:"10%"}}>
                    {index !== 0 ?
                      <Icon name='minus' size='small' color='red' style={{margin:"0px", padding:0}} onClick={(e) => handleDelete(index)}/>
                      :
                      null
                    }
                  </Col>
                </Row>
                {(type === "sms" && (!testValidPhoneNumber(contact.value) && contact.value !== '')) ?
                  <Row>
                    <Col style={{display: 'flex', justifyContent:'center', alignItems:'center'}}>
                      <FormattedMessage id="message.error.wrongPhoneNumber" defaultMessage="Incorrect phone number(s)."/>
                    </Col>
                  </Row>
                  :
                  null
                }
              </Col>
              <Col style={{margin:0, padding:0}}>
                <Row style={{width:"100%", margin:0}}>
                  <Col style={{margin:0, padding:0, display: 'flex', justifyContent:'center'}}>
                    {renderSwitch({switchThresholdId} + index, (e) => handleChangeThreshold(e, index), contact.threshold)}
                  </Col>
                  <Col style={{margin:0, padding:0, display: 'flex', justifyContent:'center'}}>
                    {renderSwitch({switchReminderId} + index, (e) => handleChangeReminderCheck(e, index), contact.reminder)}
                  </Col>
                  <Col style={{margin:0, padding:0, display: 'flex', justifyContent:'center'}}>
                    {renderSwitch({switchDayNightId} + index, (e) => handleChangeDayNightCheck(e, index), contact.day_time === "day", "daynight")}
                  </Col>
                </Row>
              </Col>
            </Row>
          )
        })}
        {(contact_list.length < 4) ?
        <Row style={{width:"100%", margin:0, padding:0}}>
          <Col style={{margin:0, padding:0}}>
            <Row style={{width:"100%", margin:0, padding:0}}>
              <Col style={{margin:0, padding:0}}>
                <Icon name='plus' size='small' color='green' style={{margin:"0px", padding:0}} onClick={(e) => addContact()}/>
              </Col>
              <Col style={{margin:0, padding:0, display: 'flex', justifyContent:'center', alignItems:'center'}}>
              </Col>
            </Row>
          </Col>
          <Col style={{margin:0, padding:0}}>
          </Col>
        </Row>
          :
          null
        }
      </Row>
    )
  }

  const recallChange = (e, type) => {
    let new_recall = {...recall}
    new_recall[type] = !new_recall[type]
    setRecall(new_recall)
    props.setChangeOngoing(true)
  }

  const renderNotificationParamsMultiRecipient = (reminder_activated) => {
    let tooltip_threshold_id = "tooltip-threshold-" + props.profileData.Patient_Data.id_patient
    let tooltip_reminder_id = "tooltip-reminder-" + props.profileData.Patient_Data.id_patient
    let tooltip_daynight_id = "tooltip-daynight-" + props.profileData.Patient_Data.id_patient
    let tooltip_recall_id = "tooltip-recall-" + props.profileData.Patient_Data.id_patient

    return(
      <div>
        <hr />
        <Row className="justify-content-md-end" style = {{ paddingTop:"10px", paddingBottom: "10px"}}>
          <Col style={{ fontWeight: "bold", fontSize:"1.1em", textAlign: "center" }}>
            <FormattedMessage id="param.notifications" defaultMessage="Notifications"/>
          </Col>
        </Row>
        <Row style={{width:"100%", margin:0}}>
          <Col style={{margin:0, padding:0}}>
          </Col>
          <Col style={{margin:0, padding:0}}>
            <Row style={{width:"100%", margin:0}}>
              <Tooltip style={{ zIndex: 99 }} id={tooltip_threshold_id}>
                {props.select_tooltip("param.threshold.tooltip")}
              </Tooltip>             
              <Col data-tooltip-id={tooltip_threshold_id} data-tooltip-place="bottom" style={{margin:0, padding:0, display: 'flex', justifyContent:'center'}}>
                <FormattedMessage id="param.threshold" defaultMessage="Threshold"/>
              </Col>

              <Tooltip style={{ zIndex: 99 }} id={tooltip_reminder_id}>
                {props.select_tooltip("param.reminder.tooltip")}
              </Tooltip> 
              <Col data-tooltip-id={tooltip_reminder_id} data-tooltip-place="bottom" style={{margin:0, padding:0, display: 'flex', justifyContent:'center'}}>
                <FormattedMessage id="param.reminder" defaultMessage="Reminder"/>
              </Col>

              <Tooltip style={{ zIndex: 99 }} id={tooltip_daynight_id}>
                {props.select_tooltip("param.daynight.tooltip")}
              </Tooltip> 
              <Col data-tooltip-id={tooltip_daynight_id} data-tooltip-place="bottom" style={{margin:0, padding:0, display: 'flex', justifyContent:'center'}}>
                <FormattedMessage id="param.daynight" defaultMessage="Schedules"/>
              </Col>
            </Row>
          </Col>
        </Row>
        {renderMultiRecipientContact("mail")}
        {renderMultiRecipientContact("sms")}

        {Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("recall_alert")) ?
          <Row>
            <Col style={{}}>
              <Row>
                <Tooltip style={{ zIndex: 99 }} id={tooltip_recall_id}>
                  {props.select_tooltip("param.recall.tooltip")}
                </Tooltip>              
                <Col data-tooltip-id={tooltip_recall_id} data-tooltip-place="bottom" style={{}}>
                <FormattedMessage id="param.recall" defaultMessage="Alert recall"/>
                </Col>
                <Col>
                </Col>
              </Row>
              </Col>
            <Col style={{}}>
              <Row>
                <Col style={{}}>
                  <Row>
                    <Col style={{textAlign: 'center'}}>
                      <input type="checkbox" onChange={(e) => recallChange(e, "threshold")} checked={recall.threshold === true}/><br/>
              </Col>
                  </Row>
              </Col>
                <Col style={{}}>
                  <Row>
                    <Col style={{textAlign: 'center'}}>
                      <input type="checkbox" onChange={(e) => recallChange(e, "reminder")} checked={recall.reminder === true}/><br/>
                    </Col>
            </Row>
          </Col>
                <Col style={{}}>
                </Col>
        </Row>
            </Col>
          </Row>
          :
          null
        }
        <br/>
        <Row>
          <Col style={{maxWidth:"27%"}}>
            <FormattedMessage id="param.sound" defaultMessage="Sound"/>
          </Col>
          <Col style={{}}>
            {renderSwitch("sound", handleChangeSoundCheck, checkedSound)}
          </Col>
          <Col>
          </Col>
        </Row>
      </div>
    );
  }

  const renderNotificationParamsEdit = () => {
    let reminder_activated = Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("reminder"))
    let multi_recipient_activated = Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("multi_recipient"))
    if (multi_recipient_activated) {
      return(renderNotificationParamsMultiRecipient(reminder_activated));
    }
    else {
      return(renderNotificationParamsSimple(reminder_activated));
    }
  }



  // ###### HANDLE CHECK FUNCTION ######

  const handleChangeOngoing = nextChecked => {
    props.setChangeOngoing(true)
  };

  const handleChangeFeverCheck = nextChecked => {
    setCheckedFever(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangeFeverThreshold = nextThreshold => {
    setFeverAlert({...feverAlert, threshold:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeFeverThreshold2 = nextThreshold => {
    setFeverAlert({...feverAlert, threshold2:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeFeverDelay = nextDelay => {
    setFeverAlert({...feverAlert, delay:nextDelay.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeSPO2Check = nextChecked => {
    setCheckedSPO2(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangeSPO2Threshold = nextThreshold => {
    setSPO2Alert({...SPO2Alert, threshold:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeSPO2Delay = nextDelay => {
    setSPO2Alert({...SPO2Alert, delay:nextDelay.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangePRCheck = nextChecked => {
    setCheckedPR(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangePRThreshold = nextThreshold => {
    setPRAlert({...PRAlert, threshold:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangePRThreshold2 = nextThreshold => {
    setPRAlert({...PRAlert, threshold2:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangePRDelay = nextDelay => {
    setPRAlert({...PRAlert, delay:nextDelay.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangePRTensionCheck = nextChecked => {
    setCheckedPRTension(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangePRTensionThreshold = nextThreshold => {
    setPRTensionAlert({...PRTensionAlert, threshold:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangePRTensionThreshold2 = nextThreshold => {
    setPRTensionAlert({...PRTensionAlert, threshold2:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangePRTensionDelay = nextDelay => {
    setPRTensionAlert({...PRTensionAlert, delay:nextDelay.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeSystolicHighChecked = nextChecked => {
    setCheckedSystolicHigh(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangeSystolicHighThreshold = nextThreshold => {
    setSystolicHighAlert({...systolicHighAlert, threshold:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeSystolicHighThreshold2 = nextThreshold => {
    setSystolicHighAlert({...systolicHighAlert, threshold2:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeSystolicHighDelay = nextDelay => {
    setSystolicHighAlert({...systolicHighAlert, delay:nextDelay.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeDiastolicHighChecked = nextChecked => {
    setCheckedDiastolicHigh(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangeDiastolicHighThreshold = nextThreshold => {
    setDiastolicHighAlert({...diastolicHighAlert, threshold:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeDiastolicHighThreshold2 = nextThreshold => {
    setDiastolicHighAlert({...diastolicHighAlert, threshold2:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeDiastolicHighDelay = nextDelay => {
    setDiastolicHighAlert({...diastolicHighAlert, delay:nextDelay.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeWeightChecked = nextChecked => {
    setCheckedWeight(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangeWeightThreshold = nextThreshold => {
    setWeightAlert({...weightAlert, threshold:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeWeightThreshold2 = nextThreshold => {
    setWeightAlert({...weightAlert, threshold2:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeWeightDelay = nextDelay => {
    setWeightAlert({...weightAlert, delay:nextDelay.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeEq5dChecked = nextChecked => {
    setCheckedEQ5D(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangeEq5dThreshold = nextThreshold => {
    setEq5dAlert({...eq5dAlert, threshold:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeEq5dDelay = nextDelay => {
    setEq5dAlert({...eq5dAlert, delay:nextDelay.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeEq5dScaleChecked = nextChecked => {
    setCheckedEQ5DScale(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangeEq5dScaleThreshold = nextThreshold => {
    setEq5dScaleAlert({...eq5dScaleAlert, threshold:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeEq5dScaleDelay = nextDelay => {
    setEq5dScaleAlert({...eq5dScaleAlert, delay:nextDelay.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeSf36Checked = nextChecked => {
    setCheckedSF36(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangeSf36Threshold = nextThreshold => {
    setSf36Alert({...sf36Alert, threshold:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeSf36Delay = nextDelay => {
    setSf36Alert({...sf36Alert, delay:nextDelay.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeMDASIChecked = nextChecked => {
    setCheckedMDASI(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangeMDASIThreshold = nextThreshold => {
    setMDASIAlert({...mdasiAlert, threshold:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeMDASIDelay = nextDelay => {
    setMDASIAlert({...mdasiAlert, delay:nextDelay.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangePainChecked = nextChecked => {
    setCheckedPain(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangePainThreshold = nextThreshold => {
    setPainAlert({...painAlert, threshold:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangePainThreshold2 = nextThreshold => {
    setPainAlert({...painAlert, threshold2:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangePainDelay = nextDelay => {
    setPainAlert({...painAlert, delay:nextDelay.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeBreathingChecked = nextChecked => {
    setCheckedBreathing(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangeBreathingThreshold = nextThreshold => {
    setBreathingAlert({...breathingAlert, threshold:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeBreathingThreshold2 = nextThreshold => {
    setBreathingAlert({...breathingAlert, threshold2:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeBreathingObservanceChecked = nextChecked => {
    setCheckedBreathingObservance(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangeBreathingObservanceThreshold = nextThreshold => {
    setBreathingObservanceAlert({...breathingObservanceAlert, threshold:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeBreathingOxygenRateChecked = nextChecked => {
    setCheckedBreathingOxygenRate(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangeBreathingOxygenRateThreshold = nextThreshold => {
    setBreathingOxygenRateAlert({...breathingOxygenRateAlert, threshold:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeBreathingOxygenRateThreshold2 = nextThreshold => {
    setBreathingOxygenRateAlert({...breathingOxygenRateAlert, threshold2:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeBreathingOxygenRateDelay = nextDelay => {
    setBreathingOxygenRateAlert({...breathingOxygenRateAlert, delay:nextDelay.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeBreathingLeakageChecked = nextChecked => {
    setCheckedBreathingLeakage(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangeBreathingLeakageThreshold = nextThreshold => {
    setBreathingLeakageAlert({...breathingLeakageAlert, threshold:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeBreathingLeakageThreshold2 = nextThreshold => {
    setBreathingLeakageAlert({...breathingLeakageAlert, threshold2:nextThreshold.target.value})
    props.setChangeOngoing(true)
  };

  const handleChangeBreathingLeakage95Checked = nextChecked => {
    setCheckedBreathingLeakage95(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangeBreathingLeakage95Threshold = nextThreshold => {
    setBreathingLeakage95Alert({...breathingLeakage95Alert, threshold: nextThreshold.target.value});
    props.setChangeOngoing(true)
  };

  const handleChangeBreathingLeakage95Threshold2 = nextThreshold => {
    setBreathingLeakage95Alert({...breathingLeakage95Alert, threshold2: nextThreshold.target.value});
    props.setChangeOngoing(true)
  };

  const handleChangeBreathingAhiChecked = nextChecked => {
    setCheckedBreathingAhi(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangeBreathingAhiThreshold = nextThreshold => {
    setBreathingAhiAlert({...breathingAhiAlert, threshold: nextThreshold.target.value});
    props.setChangeOngoing(true)
  };

  const handleChangeBreathingAhiThreshold2 = nextThreshold => {
    setBreathingAhiAlert({...breathingAhiAlert, threshold2: nextThreshold.target.value});
    props.setChangeOngoing(true)
  };

  const handleChangeDetachCheck = nextChecked => {
    setCheckedDetach(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangeBatteryCheck = nextChecked => {
    setCheckedBattery(nextChecked);
    props.setChangeOngoing(true)
  };

  const handleChangeReminderTuckyCheck = nextChecked => {
    let new_reminder_list = checkedReminderList
    let found_reminder = (new_reminder_list.findIndex(reminder => reminder.alert_type === "tucky_reminder"));
    if (nextChecked === true) {      
      if (found_reminder === -1) {
        new_reminder_list.push({alert_type: "tucky_reminder", alert_hours: "--:--", time_margin: 2, last_search: "none"})
      }
    }
    else {
      new_reminder_list.splice(found_reminder, 1)
    }
    setCheckedReminderList(new_reminder_list)
    setCheckedReminderTucky(nextChecked);
    props.setChangeOngoing(true);
  };

  const handleChangeReminderOximeterCheck = nextChecked => {
    let new_reminder_list = checkedReminderList
    let found_reminder = (new_reminder_list.findIndex(reminder => reminder.alert_type === "oximeter_reminder"));
    if (nextChecked === true) {      
      if (found_reminder === -1) {
        new_reminder_list.push({alert_type: "oximeter_reminder", alert_hours: "--:--", time_margin: 2, last_search: "none"})
      }
    }
    else {
      new_reminder_list.splice(found_reminder, 1)
    }
    setCheckedReminderList(new_reminder_list)
    setCheckedReminderOximeter(nextChecked);
    props.setChangeOngoing(true);
  };

  const handleChangeReminderTensiometerCheck = nextChecked => {
    let new_reminder_list = checkedReminderList
    let found_reminder = (new_reminder_list.findIndex(reminder => reminder.alert_type === "tensiometer_reminder"));
    if (nextChecked === true) {      
      if (found_reminder === -1) {
        new_reminder_list.push({alert_type: "tensiometer_reminder", alert_hours: "--:--", time_margin: 2, last_search: "none"})
      }
    }
    else {
      new_reminder_list.splice(found_reminder, 1)
    }
    setCheckedReminderList(new_reminder_list)
    setCheckedReminderTensiometer(nextChecked);
    props.setChangeOngoing(true);
  };

  const handleChangeReminderScaleCheck = nextChecked => {
    let new_reminder_list = checkedReminderList
    let found_reminder = (new_reminder_list.findIndex(reminder => reminder.alert_type === "scale_reminder"));
    if (nextChecked === true) {      
      if (found_reminder === -1) {
        new_reminder_list.push({alert_type: "scale_reminder", alert_hours: "--:--", time_margin: 2, last_search: "none"})
      }
    }
    else {
      new_reminder_list.splice(found_reminder, 1)
    }
    setCheckedReminderList(new_reminder_list)
    setCheckedReminderScale(nextChecked);
    props.setChangeOngoing(true);
  };

  const handleChangeReminderHealthformEQ5DCheck = nextChecked => {
    let new_reminder_list = checkedReminderList
    let found_reminder = (new_reminder_list.findIndex(reminder => reminder.alert_type === "healthform_reminder_eq5d"));
    if (nextChecked === true) {
      if (found_reminder === -1) {
        new_reminder_list.push({alert_type: "healthform_reminder_eq5d", alert_hours: "--:--", time_margin: 2, last_search: "none"})
      }
    }
    else {
      new_reminder_list.splice(found_reminder, 1)
    }
    setCheckedReminderList(new_reminder_list)
    setCheckedReminderEQ5D(nextChecked);
    props.setChangeOngoing(true);
  };

  const handleChangeReminderHealthformSF36Check = nextChecked => {
    let new_reminder_list = checkedReminderList
    let found_reminder = (new_reminder_list.findIndex(reminder => reminder.alert_type === "healthform_reminder_sf36"));
    if (nextChecked === true) {
      if (found_reminder === -1) {
        new_reminder_list.push({alert_type: "healthform_reminder_sf36", alert_hours: "--:--", time_margin: 2, last_search: "none"})
      }
    }
    else {
      new_reminder_list.splice(found_reminder, 1)
    }
    setCheckedReminderList(new_reminder_list)
    setCheckedReminderSF36(nextChecked);
    props.setChangeOngoing(true);
  };

  const handleChangeReminderHealthformMDASICheck = nextChecked => {
    let new_reminder_list = checkedReminderList
    let found_reminder = (new_reminder_list.findIndex(reminder => reminder.alert_type === "healthform_reminder_mdasi"));
    if (nextChecked === true) {
      if (found_reminder === -1) {
        new_reminder_list.push({alert_type: "healthform_reminder_mdasi", alert_hours: "--:--", time_margin: 2, last_search: "none"})
      }
    }
    else {
      new_reminder_list.splice(found_reminder, 1)
    }
    setCheckedReminderList(new_reminder_list)
    setCheckedReminderMDASI(nextChecked);
    props.setChangeOngoing(true);
  };

  const handleChangeReminderHealthformAlimentationCheck = nextChecked => {
    let new_reminder_list = checkedReminderList
    let found_reminder = (new_reminder_list.findIndex(reminder => reminder.alert_type === "healthform_reminder_alimentation"));
    if (nextChecked === true) {
      if (found_reminder === -1) {
        new_reminder_list.push({alert_type: "healthform_reminder_alimentation", alert_hours: "--:--", time_margin: 2, last_search: "none"})
      }
    }
    else {
      new_reminder_list.splice(found_reminder, 1)
    }
    setCheckedReminderList(new_reminder_list)
    setCheckedReminderAlimentation(nextChecked);
    props.setChangeOngoing(true);
  };

  const handleChangeReminderPainCheck = nextChecked => {
    let new_reminder_list = checkedReminderList
    let found_reminder = (new_reminder_list.findIndex(reminder => reminder.alert_type === "pain_reminder"));
    if (nextChecked === true) {
      if (found_reminder === -1) {
        new_reminder_list.push({alert_type: "pain_reminder", alert_hours: "--:--", time_margin: 2, last_search: "none"})
      }
    }
    else {
      new_reminder_list.splice(found_reminder, 1)
    }
    setCheckedReminderList(new_reminder_list)
    setCheckedReminderPain(nextChecked);
    props.setChangeOngoing(true);
  };

  const handleChangeReminderNivCheck = nextChecked => {
    let new_reminder_list = checkedReminderList
    let found_reminder = (new_reminder_list.findIndex(reminder => reminder.alert_type === "niv_reminder"));
    if (nextChecked === true) {
      if (found_reminder === -1) {
        new_reminder_list.push({alert_type: "niv_reminder", alert_hours: "--:--", time_margin: 2, last_search: "none"})
      }
    }
    else {
      new_reminder_list.splice(found_reminder, 1)
    }
    setCheckedReminderList(new_reminder_list)
    setCheckedReminderNiv(nextChecked);
    props.setChangeOngoing(true);
  };

  const handleChangeReminderOxiCheck = nextChecked => {
    let new_reminder_list = checkedReminderList
    let found_reminder = (new_reminder_list.findIndex(reminder => reminder.alert_type === "oxi_reminder"));
    if (nextChecked === true) {
      if (found_reminder === -1) {
        new_reminder_list.push({alert_type: "oxi_reminder", alert_hours: "--:--", time_margin: 2, last_search: "none"})
      }
    }
    else {
      new_reminder_list.splice(found_reminder, 1)
    }
    setCheckedReminderList(new_reminder_list)
    setCheckedReminderOxi(nextChecked);
    props.setChangeOngoing(true);
  };

  const handleChangeSoundCheck = nextChecked => {
    setCheckedSound(nextChecked);
    props.setChangeOngoing(true)
  };


  // ###### HANDLE VALUE CHANGE FUNCTIONS ######

  //Function to handle firstname value
  const handleChangeFirstname = (event) => {
    setFirstname(event.target.value);
    props.setChangeOngoing(true)
  }

  //Function to handle lastname value
  const handleChangeLastname = (event) => {
    setLastname(event.target.value);
    props.setChangeOngoing(true)
  }

  //Function to handle birthdate value
  const handleChangeBirthdate = (birthdate) => {
    setBirthdate(new Date(birthdate));
    props.setChangeOngoing(true)
  }

  //Function to handle location value
  const handleChangeLocation = (event) => {
    setLocation(event.target.value);
      props.setChangeOngoing(true)
    }

  //Function to handle group value
  const handleChangeGroup = (event) => {
    var result = props.group_list.filter(obj => {
      return obj.id_group === event.target.value
    })
    setGroup(result[0].id_group);
    props.setChangeOngoing(true)
  }

  //Function to handle group value
  const handleChangeGateway = (event) => {
    // No device management right on a shared patient: ignore changes (backend also enforces).
    if (props.profileData.Patient_Data.can_manage_devices === false) return;
    var result = effectiveGwList.filter(obj => {
      return obj.id_gw === event.target.value
    })
    result[0].id_old = props.profileData.Patient_Data.devices.gateway.id
    if (event.target.value === "dissociate") {
      let freeDevices = selectedDeviceList;
      freeDevices.device1.id = "dissociate"
      freeDevices.device2.id = "dissociate"
      freeDevices.device3.id = "dissociate"
      freeDevices.device4.id = "dissociate"      
      freeDevices.gateway.id = "dissociate"
      setSelectedDeviceList(freeDevices)
      props.changeDisplayDevices("no_device")
    }
    else {
      props.changeDisplayDevices("gateway")
    }
    let new_selected_device_list = selectedDeviceList
    new_selected_device_list.gateway = result[0]
    setSelectedGw(result[0])
    setSelectedDeviceList(new_selected_device_list)
    props.setChangeOngoing(true)
  }

  //Function to handle device id
  const handleChangeDeviceId = (event) => {
    var result = props.device_list.filter(obj => {    // ???
      return obj.id_device === event.target.value
    })
    let new_list = selectedDeviceList
    if (event.target.id === "device1") {
      new_list.device1.id_old = new_list.device1.id_old
      new_list.device1.id = event.target.value
    }
    else if (event.target.id === "device2") {
      new_list.device2.id_old = new_list.device2.id.id_old
      new_list.device2.id = event.target.value
    }
    else if (event.target.id === "device3") {
      new_list.device3.id_old = new_list.device3.id.id_old
      new_list.device3.id = event.target.value
    }
    else if (event.target.id === "device4") {
      new_list.device4.id_old = new_list.device4.id.id_old
      new_list.device4.id = event.target.value
    }    
    else if (event.target.id === "device5") {
      new_list.device5.id_old = new_list.device5.id.id_old
      new_list.device5.id = event.target.value
    }
    setSelectedDeviceList(new_list)
    props.setChangeOngoing(true)
  }

  const handleChangePosition = nextChecked => {
    setPosition(nextChecked.target.value);
    props.setChangeOngoing(true)
  };


  //Function to handle mail_alert value
  const handleChangeMailalert = (event) => {
    setMailalert(event.target.value);
    props.setChangeOngoing(true)
  }

  const resetMailAlert = (mail_list) => {
    let ret = ''
    mail_list.forEach(mail => {
      ret += mail.value + ','
    })
    if (ret !== '') {
      ret = ret.slice(0, -1)
    }
    setMailalert(ret)
  }

  const resetSMSAlert = (sms_list) => {
    let ret = ''
    sms_list.forEach(sms => {
      ret += sms.value + ','
    })
    if (ret !== '') {
      ret = ret.slice(0, -1)
    }
    setSmsalert(ret.split(','))
  }

  const addMailMulti = () => {
    if (mailalertMultirecipient.length < 4) {    
    let newList = mailalertMultirecipient.slice()
    newList.push({index: mailalertMultirecipient.length, value: "", threshold: true, reminder: false, day_time: "day"})
    setMailalertMultirecipient(newList)
    resetMailAlert(newList)
    props.setChangeOngoing(true)
  }
  }

  const deleteMailMulti = (index) => {
    let newList = mailalertMultirecipient.slice()
    newList.splice(index, 1)
    setMailalertMultirecipient(newList)
    resetMailAlert(newList)
    props.setChangeOngoing(true)
  }

  const handleChangeMailalertMulti = (event, index) => {
    let newList = mailalertMultirecipient.slice()
    newList[index].value = event.target.value
    setMailalertMultirecipient(newList)
    resetMailAlert(newList)
    props.setChangeOngoing(true)
  }

  const handleChangeMailalertCheckThreshold = (e, index) => {
    let newList = mailalertMultirecipient.slice()
    newList[index].threshold = !newList[index].threshold
    setMailalertMultirecipient(newList)
    props.setChangeOngoing(true)
  }

  const handleChangeMailalertCheckReminder = (e, index) => {
    let newList = mailalertMultirecipient.slice()
    newList[index].reminder = !newList[index].reminder
    setMailalertMultirecipient(newList)
    props.setChangeOngoing(true)
  }

  const handleChangeMailalertCheckDayNight = (e, index) => {
    let newList = mailalertMultirecipient.slice()
    newList[index].day_time = newList[index].day_time === "day" ? "night" : "day"
    setMailalertMultirecipient(newList)
    props.setChangeOngoing(true)
  }

  const addSmsMulti = () => {
    if (smsalertMultirecipient.length < 4) {    
    let newList = smsalertMultirecipient.slice()
    newList.push({index: smsalertMultirecipient.length, value: "", threshold: true, reminder: false, day_time: "day"})
    setSmsalertMultirecipient(newList)
    resetSMSAlert(newList)
    props.setChangeOngoing(true)
  }
  }

  const deleteSmsMulti = (index) => {
    let newList = smsalertMultirecipient.slice()
    newList.splice(index, 1)
    setSmsalertMultirecipient(newList)
    resetSMSAlert(newList)
    props.setChangeOngoing(true)
  }

  const handleChangeSmsalertMulti = (event, index) => {
    let newList = smsalertMultirecipient.slice()
    newList[index].value = event.target.value
    setSmsalertMultirecipient(newList)
    resetSMSAlert(newList)
    props.setChangeOngoing(true)
  }

  const handleChangeSmsalertCheckThreshold = (e, index) => {
    let newList = smsalertMultirecipient.slice()
    newList[index].threshold = !newList[index].threshold
    setSmsalertMultirecipient(newList)
    props.setChangeOngoing(true)
  }

  const handleChangeSmsalertCheckReminder = (e, index) => {
    let newList = smsalertMultirecipient.slice()
    newList[index].reminder = !newList[index].reminder
    setSmsalertMultirecipient(newList)
    props.setChangeOngoing(true)
  }

  const handleChangeSmsalertCheckDayNight = (e, index) => {
    let newList = smsalertMultirecipient.slice()
    newList[index].day_time = newList[index].day_time === "day" ? "night" : "day"
    setSmsalertMultirecipient(newList)
    props.setChangeOngoing(true)
  }

  //Function to handle reminder phone first alert
  const handleChangeReminderFirstPhone = (event) => {
    setReminderFirstPhone(event.target.value);
    props.setChangeOngoing(true)
  }

  //Function to handle reminder phone first alert
  const handleChangeReminderSecondPhone = (event) => {
    setReminderSecondPhone(event.target.value);
    props.setChangeOngoing(true)
  }


  //Function to close invalid popup
  const handleInvalidValuePopupDisplay = () => {
    setDisplayInvalidValuePopup(!displayInvalidValuePopup);
  }

  const handleValidationPopupDisplay = () => {
    setDisplayValidationPopup(!displayValidationPopup)
  }

  const handleDisplayTuckyParams = (event) => {
    setDisplayTuckyParams(!displayTuckyParams)
  }

  const handleFeverParams = () => {
    setDisplayFeverParams(!displayFeverParams)
  }

  const handleDisplayOximeterParams = () => {
    if(event.target.value === "dissociate"){
      setDisplayOximeterParams(false)
    }
    else{
      setDisplayOximeterParams(true)
    }
    props.setChangeOngoing(true)
  }

  const handleDisplayTensiometerParams = () => {
    if(event.target.value === "dissociate"){
      setDisplayTensiometerParams(false)
    }
    else{
      setDisplayTensiometerParams(true)
    }
    props.setChangeOngoing(true)
  }

  const handleDisplayScaleParams = () => {
    if(event.target.value === "dissociate"){
      setDisplayScaleParams(false);
    }
    else{
      setDisplayScaleParams(true);
    }
    props.setChangeOngoing(true)    
  }

  const handleSPO2Params = () => {
    setDisplaySPO2Params(!displaySPO2Params)
  }

  const handlePRParams = () => {
    setDisplayPRParams(!displayPRParams)
  }

  const handleChangeNumberNotif = (event, index) => {
    let new_list = smsalert.slice() //the slice is needed to make react understand that smsalert is updated
    if (event !== undefined) {
      new_list[index] = event
    }
    else {
      new_list[index] = ""
    }
    setSmsalert(new_list)
    props.setChangeOngoing(true)
  }

  const handleChangeNumberReminderFirst = (event, index) => {
    let new_list = reminderFirstPhone.slice() //the slice is needed to make react understand that reminderFirstPhone is updated
    if (event !== undefined) {
      new_list[index] = event
    }
    else {
      new_list[index] = ""
    }
    setReminderFirstPhone(new_list)
    props.setChangeOngoing(true)
  }

  const handleChangeReminderFrequency = (event, type) => {
    let new_frequency = event.target.value
    let new_reminder = checkedReminderList.slice() //the slice is needed to make react understand that checkedReminderList is updated
    new_reminder.forEach(reminder => {
      if (reminder.alert_type === type) {
        reminder.time_margin = Number(new_frequency);
      }
    })
    setCheckedReminderList(new_reminder)
    props.setChangeOngoing(true)
  }


  const restorePatient = () => {
    if (savedPatient.Patient_Data.location === undefined || savedPatient.Patient_Data.location === null) {
      savedPatient.Patient_Data.location = ""
    }
    setLocation(savedPatient.Patient_Data.location);
    setGroup(savedPatient.Patient_Data.group)
    setSelectedSpecialty(savedPatient.Patient_Data.concerned_speciality || '')
    setIsEditingSpecialty(!(savedPatient.Patient_Data.concerned_speciality))
    setOrdonnanceFilename(savedPatient.Patient_Data.ordonnance_filename || null)
    setConsentementFilename(savedPatient.Patient_Data.consentement_filename || null)
    setPsadDelegateAlerts(Boolean(savedPatient.Patient_Data.psad_delegate_alerts))
    setPsadDelegate(savedPatient.Patient_Data.psad_delegate || null)
    setDelegateNameInput('')
    setDelegatePhoneInput('')
    setDelegateEmailInput('')
    setDelegateInviteSent(false)
    setDelegateInviteError('')

    props.changeDisplayDevices(savedPatient.Patient_Data.monitoring_activation)

    setSelectedGw(savedPatient.Patient_Data.devices.gateway)
    setSelectedDeviceList(savedPatient.Patient_Data.devices)

    setCheckedFever(savedPatient.Patient_Data.alerts.fever_alert.activated)
    setFeverAlert(savedPatient.Patient_Data.alerts.fever_alert)

    setCheckedDetach(savedPatient.Patient_Data.alerts.detach_alert.activated)
    setCheckedBattery(savedPatient.Patient_Data.alerts.battery_alert.activated)
    setCheckedPR(savedPatient.Patient_Data.alerts.PR_alert.activated)
    setPRAlert(savedPatient.Patient_Data.alerts.PR_alert)
    setCheckedSPO2(savedPatient.Patient_Data.alerts.SPO2_alert.activated)
    setSPO2Alert(savedPatient.Patient_Data.alerts.SPO2_alert)
    setCheckedPRTension(savedPatient.Patient_Data.alerts.bloodpressure_PR_alert.activated)
    setCheckedSystolicHigh(savedPatient.Patient_Data.alerts.bloodpressure_sys_high_alert.activated)
    setCheckedDiastolicHigh(savedPatient.Patient_Data.alerts.bloodpressure_dia_alert.activated)
    setCheckedWeight(savedPatient.Patient_Data.alerts.weight_alert.activated)

    setMailalert(savedPatient.Patient_Data.alerts.mail_alert);
    setSmsalert(Utils.smsAlertParse(savedPatient.Patient_Data.alerts.sms_alert));
    setCheckedSound(savedPatient.Patient_Data.alerts.sound_alert)
    //props.profileData = savedPatient
    props.setChangeOngoing(false)
  }

  // ###### GETTER FUNCTIONS ######

  //Function to retrieve sensor in list
  const getSensor = (id, device_pos) => {

    let sensor;
    let returnedDevice;
    let oldDevice;

    // set oldDevice
    if(device_pos === "device1"){
      oldDevice = props.profileData.Patient_Data.devices.device1;
    }
    else if (device_pos === "device2"){
      oldDevice = props.profileData.Patient_Data.devices.device2;
    }
    else if (device_pos === "device3"){
      oldDevice = props.profileData.Patient_Data.devices.device3;
    }
    else{
    }

    // set other fields
    sensor = (props.device_list.find(device => device.id_device === id)||{id: "dissociate", id_old: "", type: "", nickname: "--", sn: ""});

    returnedDevice = {
      id_old:   oldDevice.id_old,
      id: oldDevice.id,
      type: oldDevice.type,
      nickname: oldDevice.nickname,
      sn: oldDevice.sn
    }
    return (returnedDevice);
  }

  //Function to retrieve gateway in list
  const getGateway = (id) => {

    let gateway;
    let returnedGateway = {
      id: "dissociate",
      id_old: "dissociate",
      name: "",
      nickname: "--"
    };
    let oldGateway;

    if(id !== undefined){

      gateway = effectiveGwList.find(gw => gw.id_gw === id);
      returnedGateway = {
        id: gateway.id_gw,
        id_old: props.profileData.Patient_Data.devices.gateway.id,
        name: gateway.gw_name,
        nickname: gateway.nickname
      }

    }

    return (returnedGateway);
  }

  //Function to retrieve value of a component
  const getComponentFieldValue = (component_id, propsValue) => {

    let value = propsValue;
    let component = document.getElementById(component_id);

    if((component !== null)&&(component !== undefined)){
      value = component.value;
    }

    return value;
  }

  //Function to retrieve value of a component
  const getDeviceSelectedValue = (component_id, propsValue) => {

    let value = propsValue;
    let component = document.getElementById(component_id);

    if((component !== null)&&(component !== undefined)){
      value = component.value;
    }
    else{
      value = "dissociate";
    }

    return value;
  }

  const setOptionalThreshold2 = (targetAlert, sourceAlert, parseValue = parseInt) => {
    if (sourceAlert.threshold2 !== undefined && sourceAlert.threshold2 !== null && sourceAlert.threshold2 !== "") {
      targetAlert.threshold2 = parseValue(sourceAlert.threshold2);
      targetAlert.sup_or_inf2 = sourceAlert.sup_or_inf2 || "inf";
    }
    else {
      targetAlert.threshold2 = null;
      targetAlert.sup_or_inf2 = targetAlert.sup_or_inf === "inf" ? "sup" : "inf";
    }
  }

  //Function to get patient object to send for update
  const getUpdatedPatient = () => {

    let updated_patient = props.profileData;
    if (props.displayDevicesParams === "no") {
      let new_selected_device_list = selectedDeviceList
      new_selected_device_list.device1.id = "dissociate"
      new_selected_device_list.device2.id = "dissociate"
      new_selected_device_list.device3.id = "dissociate"
      new_selected_device_list.device4.id = "dissociate"
      new_selected_device_list.gateway.id = "dissociate"
      setSelectedDeviceList(new_selected_device_list)
    }
    if ((selectedDeviceList.device1.id === "dissociate"
      && selectedDeviceList.device2.id === "dissociate"
      && selectedDeviceList.device3.id === "dissociate"
      && selectedDeviceList.device4.id === "dissociate"
        ) || selectedDeviceList.gateway.id === "dissociate"
        ) {
        selectedDeviceList.device1.id = "dissociate"
      selectedDeviceList.device2.id = "dissociate"
      selectedDeviceList.device3.id = "dissociate"
      selectedDeviceList.device4.id = "dissociate"      
      selectedDeviceList.gateway.id = "dissociate"

      if (props.displayDevicesParams === "no") {
        updated_patient.Patient_Data.monitoring_activation = "no"
      }
      else if (Utils.testAnyModuleUsedExcept(moduleActivation, ["tucky_smartphone"]) === true) {
        updated_patient.Patient_Data.monitoring_activation = "no_device"
      }
      else if (Utils.testSmartphoneDisplay(moduleActivation) === true) {
        updated_patient.Patient_Data.monitoring_activation = "smartphone"
      }
      else {
        updated_patient.Patient_Data.monitoring_activation = "no"
      }
    }
    else {
      updated_patient.Patient_Data.monitoring_activation = "gateway"
    }

    updated_patient.Patient_Data.location                       = location;
    updated_patient.Patient_Data.group                          = group;
    updated_patient.Patient_Data.concerned_speciality           = selectedSpecialty || null;


    updated_patient.Patient_Data.devices.device1                = selectedDeviceList.device1;
    updated_patient.Patient_Data.devices.device2                = selectedDeviceList.device2;
    updated_patient.Patient_Data.devices.device3                = selectedDeviceList.device3;
    updated_patient.Patient_Data.devices.device4                = selectedDeviceList.device4;
    updated_patient.Patient_Data.devices.gateway                = selectedDeviceList.gateway;
    if (updated_patient.Patient_Data.devices.gateway.id === undefined) {
      updated_patient.Patient_Data.devices.gateway.id             = updated_patient.Patient_Data.devices.gateway.id_gw
    }
    // Only clear the gateway if we are NOT in gateway mode.
    // (legacy module check: when monitoring_activation was an array of modules,
    //  this loop prevented sending a gateway when no module was active.
    //  With gateway mode already determined above, applying it here would wrongly
    //  clear the gateway for devices like FS20F that have no module flag.)
    if (updated_patient.Patient_Data.monitoring_activation !== "gateway") {
      let x = 0
      let module_used = false
      while (module_used === false && moduleActivation[x]) {
        module_used = moduleActivation[x].used
        x++
      }
      if (module_used === false) {
        updated_patient.Patient_Data.devices.gateway.id           = "dissociate"
        updated_patient.Patient_Data.devices.gateway.id_gw        = "dissociate"
      }
    }

    //If field is defined but "dissociate", then set all alerts to false
    updated_patient.Patient_Data.alerts.fever_alert.activated   = checkedFever;
    updated_patient.Patient_Data.alerts.fever_alert.threshold   = parseFloat(feverAlert.threshold);
    if (feverAlert.threshold2 !== undefined && feverAlert.threshold2 !== null) {
      updated_patient.Patient_Data.alerts.fever_alert.threshold2  = parseFloat(feverAlert.threshold2);
    }
    updated_patient.Patient_Data.alerts.fever_alert.delay       = parseInt(feverAlert.delay);
    applyDurationCondition(updated_patient.Patient_Data.alerts.fever_alert, feverAlert);

    updated_patient.Patient_Data.alerts.detach_alert.activated  = checkedDetach;

    updated_patient.Patient_Data.alerts.battery_alert.activated = checkedBattery;

    updated_patient.Patient_Data.alerts.pos_alert.threshold          = position;

    //Change param values if spo2 alert is activated
    updated_patient.Patient_Data.alerts.SPO2_alert.activated    = checkedSPO2;
    updated_patient.Patient_Data.alerts.SPO2_alert.threshold    = parseInt(SPO2Alert.threshold);
    updated_patient.Patient_Data.alerts.SPO2_alert.delay        = parseInt(SPO2Alert.delay);
    applyDurationCondition(updated_patient.Patient_Data.alerts.SPO2_alert, SPO2Alert);

    //Change param values if pulse rate alert is activated
    updated_patient.Patient_Data.alerts.PR_alert.activated      = checkedPR;
    updated_patient.Patient_Data.alerts.PR_alert.threshold      = parseInt(PRAlert.threshold);
    if (PRAlert.threshold2 !== undefined && PRAlert.threshold2 !== null) {
      updated_patient.Patient_Data.alerts.PR_alert.threshold2     = parseInt(PRAlert.threshold2);
    }
    updated_patient.Patient_Data.alerts.PR_alert.delay          = parseInt(PRAlert.delay);
    applyDurationCondition(updated_patient.Patient_Data.alerts.PR_alert, PRAlert);

    //Change param values if tensiometer pulse rate alert is activated
    updated_patient.Patient_Data.alerts.bloodpressure_PR_alert.activated      = checkedPRTension;
    updated_patient.Patient_Data.alerts.bloodpressure_PR_alert.threshold      = parseInt(PRTensionAlert.threshold);
    if (PRTensionAlert.threshold2 !== undefined && PRTensionAlert.threshold2 !== null) {
      updated_patient.Patient_Data.alerts.bloodpressure_PR_alert.threshold2     = parseInt(PRTensionAlert.threshold2);
    }
    updated_patient.Patient_Data.alerts.bloodpressure_PR_alert.delay          = parseInt(PRTensionAlert.delay);
    applyDurationCondition(updated_patient.Patient_Data.alerts.bloodpressure_PR_alert, PRTensionAlert);

    //Change param values if tensiometer systolic high alert is activated
    updated_patient.Patient_Data.alerts.bloodpressure_sys_high_alert.activated      = checkedSystolicHigh;
    updated_patient.Patient_Data.alerts.bloodpressure_sys_high_alert.threshold      = parseInt(systolicHighAlert.threshold);
    if (systolicHighAlert.threshold2 !== undefined && systolicHighAlert.threshold2 !== null) {
      updated_patient.Patient_Data.alerts.bloodpressure_sys_high_alert.threshold2     = parseInt(systolicHighAlert.threshold2);
    }
    updated_patient.Patient_Data.alerts.bloodpressure_sys_high_alert.delay          = parseInt(systolicHighAlert.delay);
    applyDurationCondition(updated_patient.Patient_Data.alerts.bloodpressure_sys_high_alert, systolicHighAlert);

    //Change param values if tensiometer diastolic high alert is activated
    updated_patient.Patient_Data.alerts.bloodpressure_dia_alert.activated      = checkedDiastolicHigh;
    updated_patient.Patient_Data.alerts.bloodpressure_dia_alert.threshold      = parseInt(diastolicHighAlert.threshold);
    if (diastolicHighAlert.threshold2 !== undefined && diastolicHighAlert.threshold2 !== null) {
      updated_patient.Patient_Data.alerts.bloodpressure_dia_alert.threshold2   = parseInt(diastolicHighAlert.threshold2);
    }
    updated_patient.Patient_Data.alerts.bloodpressure_dia_alert.delay          = parseInt(diastolicHighAlert.delay);
    applyDurationCondition(updated_patient.Patient_Data.alerts.bloodpressure_dia_alert, diastolicHighAlert);

    //Change param values if scale alert is activated
    updated_patient.Patient_Data.alerts.weight_alert.activated      = checkedWeight;
    updated_patient.Patient_Data.alerts.weight_alert.threshold      = parseInt(weightAlert.threshold);
    if (weightAlert.threshold2 !== undefined && weightAlert.threshold2 !== null) {
      updated_patient.Patient_Data.alerts.weight_alert.threshold2     = parseInt(weightAlert.threshold2);
    }
    updated_patient.Patient_Data.alerts.weight_alert.delay          = parseInt(weightAlert.delay);
    applyDurationCondition(updated_patient.Patient_Data.alerts.weight_alert, weightAlert);

    //Change param values if healthform alert is activated
    updated_patient.Patient_Data.alerts.eq5d_alert.activated      = checkedEQ5D;
    updated_patient.Patient_Data.alerts.eq5d_alert.threshold      = parseFloat(eq5dAlert.threshold);
    updated_patient.Patient_Data.alerts.eq5d_alert.delay          = parseInt(eq5dAlert.delay);
    applyDurationCondition(updated_patient.Patient_Data.alerts.eq5d_alert, eq5dAlert);

    //Change param values if healthform second alert is activated
    updated_patient.Patient_Data.alerts.eq5d_scale_alert.activated      = checkedEQ5DScale;
    updated_patient.Patient_Data.alerts.eq5d_scale_alert.threshold      = parseFloat(eq5dScaleAlert.threshold);
    updated_patient.Patient_Data.alerts.eq5d_scale_alert.delay          = parseInt(eq5dScaleAlert.delay);
    applyDurationCondition(updated_patient.Patient_Data.alerts.eq5d_scale_alert, eq5dScaleAlert);

    updated_patient.Patient_Data.alerts.sf36_alert.activated      = checkedSF36;
    updated_patient.Patient_Data.alerts.sf36_alert.threshold      = parseInt(sf36Alert.threshold);
    updated_patient.Patient_Data.alerts.sf36_alert.delay          = parseInt(sf36Alert.delay);
    applyDurationCondition(updated_patient.Patient_Data.alerts.sf36_alert, sf36Alert);

    updated_patient.Patient_Data.alerts.mdasi_alert.activated      = checkedMDASI;
    updated_patient.Patient_Data.alerts.mdasi_alert.threshold      = parseInt(mdasiAlert.threshold);
    updated_patient.Patient_Data.alerts.mdasi_alert.delay          = parseInt(mdasiAlert.delay);
    applyDurationCondition(updated_patient.Patient_Data.alerts.mdasi_alert, mdasiAlert);

    updated_patient.Patient_Data.alerts.pain_alert.activated      = checkedPain;
    updated_patient.Patient_Data.alerts.pain_alert.threshold      = parseInt(painAlert.threshold);
    updated_patient.Patient_Data.alerts.pain_alert.delay          = parseInt(painAlert.delay);
    setOptionalThreshold2(updated_patient.Patient_Data.alerts.pain_alert, painAlert);
    applyDurationCondition(updated_patient.Patient_Data.alerts.pain_alert, painAlert);

    updated_patient.Patient_Data.alerts.breathing_rate_alert.activated      = checkedBreathing;
    updated_patient.Patient_Data.alerts.breathing_rate_alert.threshold      = parseInt(breathingAlert.threshold);
    updated_patient.Patient_Data.alerts.breathing_rate_alert.delay          = parseInt(breathingAlert.delay);
    setOptionalThreshold2(updated_patient.Patient_Data.alerts.breathing_rate_alert, breathingAlert);
    applyDurationCondition(updated_patient.Patient_Data.alerts.breathing_rate_alert, breathingAlert);

    updated_patient.Patient_Data.alerts.breathing_oxygen_rate_alert.activated      = checkedBreathingOxygenRate;
    updated_patient.Patient_Data.alerts.breathing_oxygen_rate_alert.threshold      = parseInt(breathingOxygenRateAlert.threshold);
    updated_patient.Patient_Data.alerts.breathing_oxygen_rate_alert.delay          = parseInt(breathingOxygenRateAlert.delay);
    setOptionalThreshold2(updated_patient.Patient_Data.alerts.breathing_oxygen_rate_alert, breathingOxygenRateAlert);
    applyDurationCondition(updated_patient.Patient_Data.alerts.breathing_oxygen_rate_alert, breathingOxygenRateAlert);

    updated_patient.Patient_Data.alerts.breathing_leakage_alert.activated      = checkedBreathingLeakage;
    updated_patient.Patient_Data.alerts.breathing_leakage_alert.threshold      = parseInt(breathingLeakageAlert.threshold);
    updated_patient.Patient_Data.alerts.breathing_leakage_alert.delay          = parseInt(breathingLeakageAlert.delay);
    setOptionalThreshold2(updated_patient.Patient_Data.alerts.breathing_leakage_alert, breathingLeakageAlert);
    applyDurationCondition(updated_patient.Patient_Data.alerts.breathing_leakage_alert, breathingLeakageAlert);

    if (!updated_patient.Patient_Data.alerts.breathing_leakage95_alert) updated_patient.Patient_Data.alerts.breathing_leakage95_alert = { threshold: 24, sup_or_inf: 'sup', threshold2: null, sup_or_inf2: 'inf', delay: 0, trig_duration: 30, rest_duration: 60, last_alert: 'none', triggered: false };
    updated_patient.Patient_Data.alerts.breathing_leakage95_alert.activated    = checkedBreathingLeakage95;
    updated_patient.Patient_Data.alerts.breathing_leakage95_alert.threshold    = parseInt(breathingLeakage95Alert.threshold);
    updated_patient.Patient_Data.alerts.breathing_leakage95_alert.delay        = parseInt(breathingLeakage95Alert.delay) || 0;
    setOptionalThreshold2(updated_patient.Patient_Data.alerts.breathing_leakage95_alert, breathingLeakage95Alert);
    applyDurationCondition(updated_patient.Patient_Data.alerts.breathing_leakage95_alert, breathingLeakage95Alert);

    if (!updated_patient.Patient_Data.alerts.breathing_ahi_alert) updated_patient.Patient_Data.alerts.breathing_ahi_alert = { threshold: 15, sup_or_inf: 'sup', threshold2: null, sup_or_inf2: 'inf', delay: 0, trig_duration: 30, rest_duration: 60, last_alert: 'none', triggered: false };
    updated_patient.Patient_Data.alerts.breathing_ahi_alert.activated          = checkedBreathingAhi;
    updated_patient.Patient_Data.alerts.breathing_ahi_alert.threshold          = parseInt(breathingAhiAlert.threshold);
    updated_patient.Patient_Data.alerts.breathing_ahi_alert.delay              = parseInt(breathingAhiAlert.delay) || 0;
    setOptionalThreshold2(updated_patient.Patient_Data.alerts.breathing_ahi_alert, breathingAhiAlert);
    applyDurationCondition(updated_patient.Patient_Data.alerts.breathing_ahi_alert, breathingAhiAlert);

    updated_patient.Patient_Data.alerts.breathing_observance_alert.activated      = checkedBreathingObservance;
    updated_patient.Patient_Data.alerts.breathing_observance_alert.threshold      = parseInt(breathingObservanceAlert.threshold);
    updated_patient.Patient_Data.alerts.breathing_observance_alert.delay          = parseInt(breathingObservanceAlert.delay);
    applyDurationCondition(updated_patient.Patient_Data.alerts.breathing_observance_alert, breathingObservanceAlert);

    //Change param values if reminder alert is activated
    let reminder_alert_activated = false;
    if ((checkedReminderList !== undefined && checkedReminderList.length > 0) && props.displayDevicesParams !== "no") {
      reminder_alert_activated = true;
    }
    updated_patient.Patient_Data.alerts.reminder_alert.activated      = reminder_alert_activated
    if (checkedReminderList !== undefined) {
    updated_patient.Patient_Data.alerts.reminder_alert.alerts_params  = JSON.parse(JSON.stringify(checkedReminderList))
    }
    let i = 0;
    while (updated_patient.Patient_Data.alerts.reminder_alert.alerts_params[i]) {
      if (updated_patient.Patient_Data.alerts.reminder_alert.alerts_params[i].alert_hours !== undefined) {
        let cleaned_hours = updated_patient.Patient_Data.alerts.reminder_alert.alerts_params[i].alert_hours.split(',')
        cleaned_hours.sort()
        let j = 0;
        while (cleaned_hours[j]) {
          if (cleaned_hours[j].includes("-")) {
            cleaned_hours.splice(j, 1)
        }
          else {
            j++;
          }
        }
        //set the hours of checking reminder to UTC
        j = 0;
        while (cleaned_hours[j]) {
          let clean_date = new Date()
          clean_date.setUTCHours(cleaned_hours[j].split(':')[0])
          clean_date.setMinutes(cleaned_hours[j].split(':')[1])
          clean_date.setTime(clean_date.getTime() + (clean_date.getTimezoneOffset()*60000))
          let clean_hour = clean_date.getUTCHours()
          if (Number(clean_hour) < 10) {
            clean_hour = "0" + clean_hour
          }
          let clean_minutes = clean_date.getUTCMinutes()
          if (Number(clean_minutes) < 10) {
            clean_minutes = "0" + clean_minutes
          }
          cleaned_hours[j] = clean_date.getUTCHours() + ":" + clean_minutes
          cleaned_hours[j] = clean_hour + ":" + clean_minutes
          j++;
        }
        updated_patient.Patient_Data.alerts.reminder_alert.alerts_params[i].alert_hours = cleaned_hours.join(',');
      }
      i++;
    }
    updated_patient.Patient_Data.alerts.mail_alert              = mailalert;
    updated_patient.Patient_Data.alerts.mail_alert_reminder     = mailalert;
    updated_patient.Patient_Data.alerts.sms_alert               = Utils.cleanSmsList(smsalert);
    updated_patient.Patient_Data.alerts.sms_alert_reminder      = Utils.cleanSmsList(reminderFirstPhone);

    if (Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("multi_recipient"))) {
      let new_mail_alert = ''
      let new_mail_alert_reminder = ''
      let new_sms_alert = []
      let new_sms_alert_reminder = []
      let new_mail_alert_night = ''
      let new_mail_alert_reminder_night = ''
      let new_sms_alert_night = []
      let new_sms_alert_reminder_night = []

      mailalertMultirecipient.forEach(mail => {
        if (mail.threshold && mail.day_time === "day") {
          new_mail_alert += mail.value + ','
        }
        else if (mail.threshold && mail.day_time === "night") {
          new_mail_alert_night += mail.value + ','
        }
        if (mail.reminder && mail.day_time === "day") {
          new_mail_alert_reminder += mail.value + ','
        }
        else if (mail.reminder && mail.day_time === "night") {
          new_mail_alert_reminder_night += mail.value + ','
        }
      })
      if (new_mail_alert[new_mail_alert.length - 1] === ',') {
        new_mail_alert = new_mail_alert.slice(0, -1)
      }
      if (new_mail_alert_reminder[new_mail_alert_reminder.length - 1] === ',') {
        new_mail_alert_reminder = new_mail_alert_reminder.slice(0, -1)
      }
      if (new_mail_alert_night[new_mail_alert_night.length - 1] === ',') {
        new_mail_alert_night = new_mail_alert_night.slice(0, -1)
      }
      if (new_mail_alert_reminder_night[new_mail_alert_reminder_night.length - 1] === ',') {
        new_mail_alert_reminder_night = new_mail_alert_reminder_night.slice(0, -1)
      }
      updated_patient.Patient_Data.alerts.mail_alert                  = new_mail_alert;
      updated_patient.Patient_Data.alerts.mail_alert_reminder         = new_mail_alert_reminder;
      updated_patient.Patient_Data.alerts.mail_alert_night            = new_mail_alert_night;
      updated_patient.Patient_Data.alerts.mail_alert_reminder_night   = new_mail_alert_reminder_night;

      smsalertMultirecipient.forEach(sms => {
        if (sms.threshold && sms.day_time === "day") {
          new_sms_alert.push(sms.value)
        }
        else if (sms.threshold && sms.day_time === "night") {
          new_sms_alert_night.push(sms.value)
        }
        if (sms.reminder && sms.day_time === "day") {
          new_sms_alert_reminder.push(sms.value)
        }
        else if (sms.reminder && sms.day_time === "night") {
          new_sms_alert_reminder_night.push(sms.value)
        }
      })
      updated_patient.Patient_Data.alerts.sms_alert                 = new_sms_alert;
      updated_patient.Patient_Data.alerts.sms_alert_reminder        = new_sms_alert_reminder;
      updated_patient.Patient_Data.alerts.sms_alert_night           = new_sms_alert_night;
      updated_patient.Patient_Data.alerts.sms_alert_reminder_night  = new_sms_alert_reminder_night;
    }

    updated_patient.Patient_Data.alert_recall                     = recall;

    updated_patient.Patient_Data.alerts.sound_alert             = checkedSound;
    updated_patient.Patient_Data.module_activation              = moduleActivation;

    updated_patient = setAlertActivation(updated_patient);

    return (updated_patient);
  }


  // ###### SETTER FUNCTIONS ######

  //Function to set alert activation
  const setAlertActivation = (patient_data) => {

    let smartphone_tucky_module = patient_data.Patient_Data.module_activation.find((m) => m.name === "tucky_smartphone")
    if(((patient_data.Patient_Data.devices.device1.id === "dissociate")
      &&(patient_data.Patient_Data.monitoring_activation !== "smartphone"))
      &&(smartphone_tucky_module === undefined || smartphone_tucky_module.used === false)
      ){
      patient_data.Patient_Data.alerts.fever_alert.activated = false;
      patient_data.Patient_Data.alerts.pos_alert.threshold        = "0";
      patient_data.Patient_Data.alerts.detach_alert.activated= false;
      patient_data.Patient_Data.alerts.battery_alert.activated   = false;
    }

    if(patient_data.Patient_Data.devices.device2.id === "dissociate"){
      patient_data.Patient_Data.alerts.SPO2_alert.activated  = false;
      patient_data.Patient_Data.alerts.PR_alert.activated    = false;
    }

    if(patient_data.Patient_Data.devices.device3.id === "dissociate"){
      patient_data.Patient_Data.alerts.bloodpressure_PR_alert.activated    = false;
      patient_data.Patient_Data.alerts.bloodpressure_sys_high_alert.activated    = false;
      patient_data.Patient_Data.alerts.bloodpressure_dia_alert.activated    = false;
    }

    if(patient_data.Patient_Data.devices.device4.id === "dissociate"){
      patient_data.Patient_Data.alerts.weight_alert.activated    = false;
    }

    return patient_data;

  }

  //Function to check if a gateway and a device have been correctly selected
  const testGatewayAndDevicesSelect = () => {
    if((selectedDeviceList.device1.id !== "dissociate")||(selectedDeviceList.device2.id !== "dissociate")||(selectedDeviceList.device3.id !== "dissociate")||(selectedDeviceList.device4.id !== "dissociate")){
      return(false);
    }
    else{
      return(true);
    }
  }

  // ###### CHECK DOCA AND CONFIG FUNCTIONS ######

  const isCloudUpdated = () => {

    let isCloudUpdated = false;
    if(
        (props.profileData.Patient_Data.INS_Data.NumIdentifiant === null || props.profileData.Patient_Data.INS_Data.NumIdentifiant === undefined || props.profileData.Patient_Data.INS_Data.NumIdentifiant === "")
        &&
        (firstname !== props.profileData.Patient_Data.firstname || lastname !== props.profileData.Patient_Data.lastname || Utils.convert_date_to_YMD_string(birthdate) !== props.profileData.Patient_Data.birthdate)
        )
      {
        isCloudUpdated = true;
      }

    return isCloudUpdated;
  }

  const isDeviceConfigChanged = () => {

    let isDeviceConfigChanged = false;

    if(selectedDeviceList.device1.id_old !== selectedDeviceList.device1.id
      ||
      selectedDeviceList.device2.id_old!== selectedDeviceList.device2.id
      ||
      selectedDeviceList.device3.id_old !== selectedDeviceList.device3.id
      ||
      selectedDeviceList.device4.id_old !== selectedDeviceList.device4.id
      ||      
      props.profileData.Patient_Data.devices.gateway.id_gw !== selectedGw.id_gw)
      {
        isDeviceConfigChanged = true;
      }

      return isDeviceConfigChanged;
  }

  //Function to check mail addresses for alerts
  const checkMailUpdatedPatient = (mailList) => {

    let isMailListCorrect = true;

    if(mailList.length !== 0){

      let checkExp = new RegExp('^[a-z0-9]+([_|\.|-]{1}[a-z0-9]+)*@[a-z0-9]+([_|\.|-]{1}[a-z0-9]+)*[\.]{1}[a-z]{2,6}$', 'i');

      mailList.map(mail => {
        if(!checkExp.test(mail)){
          isMailListCorrect = false;
        }
      })

    }

    return isMailListCorrect;

  }

  //Function to update patient
  const checkParametersUpdate = () => {
    if (isPractitionerRequired && !hasPractitionerAssigned) {
      setmessage(<FormattedMessage id="patient.practitionerRequiredForPneumology" defaultMessage="A physician is required when Pneumologie is selected." />)
      handleInvalidValuePopupDisplay();
      return;
    }

    // Block saving while an activated alert has an unsatisfiable period condition
    const checkedByType = {
      fever_alert: checkedFever, PR_alert: checkedPR, SPO2_alert: checkedSPO2,
      bloodpressure_PR_alert: checkedPRTension, bloodpressure_sys_high_alert: checkedSystolicHigh,
      bloodpressure_dia_alert: checkedDiastolicHigh, weight_alert: checkedWeight,
      eq5d_alert: checkedEQ5D, eq5d_scale_alert: checkedEQ5DScale, sf36_alert: checkedSF36,
      mdasi_alert: checkedMDASI, pain_alert: checkedPain,
      breathing_rate_alert: checkedBreathing, breathing_oxygen_rate_alert: checkedBreathingOxygenRate,
      breathing_leakage_alert: checkedBreathingLeakage, breathing_leakage95_alert: checkedBreathingLeakage95,
      breathing_ahi_alert: checkedBreathingAhi, breathing_observance_alert: checkedBreathingObservance,
    }
    const conflicting_type = Object.keys(alertStateByType).find((type) => checkedByType[type] && getDurationConditionConflict(type, alertStateByType[type][0]))
    if (conflicting_type) {
      setmessage(<FormattedMessage id="param.alertCondition.saveBlocked" defaultMessage="Condition d'alerte impossible à déclencher en sécurité : vérifiez que l'écart min. vaut au moins 90 s par occurrence demandée et que la fenêtre dépasse (nombre de dépassements − 1) × écart min. plus 180 s." />)
      handleInvalidValuePopupDisplay();
      return;
    }

    let test_notifs_params = true;
    //Checking the notifications params validity
    if ((smsalert !== undefined && smsalert !== null && smsalert.length > 0 && smsalert[0] !== '') 
      || (reminderFirstPhone !== undefined && reminderFirstPhone !== null && reminderFirstPhone.length > 0 && reminderFirstPhone[0] !== '')
      ) {
        if(!checkMailUpdatedPatient(Utils.splitStringToList(mailalert, ',', true))){
          test_notifs_params = false;
          setmessage(<FormattedMessage id="param.wrongMailAddress" defaultMessage="Incorrect alert email address(es). Please enter one or more valid email addresses, separated by commas"/>)
          handleInvalidValuePopupDisplay();
        }
      let i = 0;
      while (smsalert[i]) {
        if (testValidPhoneNumber(smsalert[i]) === false) {
          test_notifs_params = false;
          setmessage(<FormattedMessage id="message.error.wrongPhoneNumber" defaultMessage="Incorrect phone number(s)."/>)
          handleInvalidValuePopupDisplay();
        }
        i++;
      }
      i = 0;
      while (reminderFirstPhone[i]) {
        if (testValidPhoneNumber(reminderFirstPhone[i]) === false) {
          test_notifs_params = false;
          setmessage(<FormattedMessage id="message.error.wrongPhoneNumber" defaultMessage="Incorrect phone number(s)."/>)
          handleInvalidValuePopupDisplay();
        }
        i++;
      }
      while (smsalertMultirecipient[i]) {
        if (smsalertMultirecipient[i].value !== '' && testValidPhoneNumber(smsalertMultirecipient[i].value) === false) {
          test_notifs_params = false;
          setmessage(<FormattedMessage id="message.error.wrongPhoneNumber" defaultMessage="Incorrect phone number(s)."/>)
          handleInvalidValuePopupDisplay();
        }
        i++;
      }
    }

    if (test_notifs_params) {
      //Checkings when "gateway" monitoring is selected, or when devices are associated but no gateway yet
      if(props.displayDevicesParams === "gateway" || (props.displayDevicesParams === "no_device" && !testGatewayAndDevicesSelect())){
        if(selectedGw.id_gw === "dissociate"){
          setmessage(<FormattedMessage id="param.gatewayNotSelected" defaultMessage="Please select a Gateway"/>)
          handleInvalidValuePopupDisplay();
        }
        else if(selectedDeviceList.device1.id !== selectedDeviceList.device1.id_old
            ||  selectedDeviceList.device2.id !== selectedDeviceList.device2.id_old
            ||  selectedDeviceList.device3.id !== selectedDeviceList.device3.id_old
            ||  selectedDeviceList.device4.id !== selectedDeviceList.device4.id_old          
            ||  selectedDeviceList.device5.id !== selectedDeviceList.device5.id_old
            ||  selectedGw.id_gw !== props.profileData.Patient_Data.devices.gateway.id){
          setmessage(<FormattedMessage id="param.validationChangesVerify" defaultMessage="Do you want to apply these changes"/>)
          handleValidationPopupDisplay();
        }
        else if((group !== props.profileData.Patient_Data.group)){
          setmessage(<FormattedMessage id="param.changePatientGroup" defaultMessage="Patient's group has changed, are you sure you want to apply your changes?"/>)
          handleValidationPopupDisplay();
        }
        else{
          setmessage(<FormattedMessage id="param.validationChangesVerify" defaultMessage="Do you want to apply these changes"/>)
          handleValidationPopupDisplay();
        }
      }

      //Checkings when "smartphone" or "deactivated" monitoring is selected
      else if(props.displayDevicesParams === "smartphone"||props.displayDevicesParams === "no"){

        if(((props.profileData.Patient_Data.devices.device1.id !== "dissociate")||(props.profileData.Patient_Data.devices.device2.id !== "dissociate")||(props.profileData.Patient_Data.devices.device3.id !== "dissociate")||(props.profileData.Patient_Data.devices.device4.id !== "dissociate")||(props.profileData.Patient_Data.devices.device5.id !== "dissociate")||(props.profileData.Patient_Data.devices.gateway.id !== "dissociate"))&&(props.profileData.Patient_Data.monitoring_activation === "gateway")){
          setmessage(<FormattedMessage id="param.associationEraseConfig" defaultMessage="Change monitoring type will erase current Device and Gateway configuration. Do you want to continue?"/>)
          handleValidationPopupDisplay();
        }
        else if(group !== props.profileData.Patient_Data.group){
          setmessage(<FormattedMessage id="param.changePatientGroup" defaultMessage="Patient's group has changed, are you sure you want to apply your changes?"/>)
          handleValidationPopupDisplay();
        }
        else{
          setmessage(<FormattedMessage id="param.validationChangesVerify" defaultMessage="Do you want to apply these changes"/>)
          handleValidationPopupDisplay();
        }
      }

      else{
        setmessage(<FormattedMessage id="param.validationChangesVerify" defaultMessage="Do you want to apply these changes"/>)
        handleValidationPopupDisplay();
      }
    }
  };


  // ###### UPDATE FUNCTIONS ######

  const redefineDeviceList = () => {
    let newDeviceList = selectedDeviceList;
    newDeviceList.device1.id_old = newDeviceList.device1.id;
    newDeviceList.device2.id_old = newDeviceList.device2.id;
    newDeviceList.device3.id_old = newDeviceList.device3.id;
    newDeviceList.device4.id_old = newDeviceList.device4.id;    
    newDeviceList.device5.id_old = newDeviceList.device5.id;
    newDeviceList.gateway.id_old = newDeviceList.gateway.id;
    setSelectedDeviceList(newDeviceList);
  }

  const testUpdateSubscriptions = (newMonitoring_activation, oldMonitoring_activation) => {
    let ret = true;
    // Subscription management: if monitoring change occured
    if (newMonitoring_activation !== oldMonitoring_activation) {
      //if monitoring stopped
      if ((newMonitoring_activation === "no")){
        props.subscription_info.sub_used -= 1
      }
      //if new monitoring
      else if ((oldMonitoring_activation === "no") && (newMonitoring_activation !== "no")){
        //if subscriptions are full
        if (props.subscription_info.sub_used === props.subscription_info.sub_total) {
          setmessage(<FormattedMessage id="account.subscriptionErrorExceedBlock" defaultMessage="Error: your subscription doesn't allow more monitoring" />);
          handleInvalidValuePopupDisplay();
          handleValidationPopupDisplay();
          props.changeDisplayDevices("no");
          props.profileData.Patient_Data.monitoring_activation = "no"
          ret = false;
        }
        else {
          props.subscription_info.sub_used += 1
        }
      }
    }
    return ret;
  };

  const checkGatewayDevicesValid = () => {
    let ret = false
    let deviceList = selectedDeviceList;
    if ((deviceList.gateway.id !== "dissociate" || deviceList.gateway.id_gw !== "dissociate")
      &&
      (
        deviceList.device1.id !== "dissociate"
      ||deviceList.device2.id !== "dissociate"
      ||deviceList.device3.id !== "dissociate"
      ||deviceList.device4.id !== "dissociate"
      )) {
      ret = true
    }
    else if (
        (deviceList.gateway.id === "dissociate" || deviceList.gateway.id_gw === "dissociate")
      &&deviceList.device1.id === "dissociate"
      &&deviceList.device2.id === "dissociate"
      &&deviceList.device3.id === "dissociate"
      &&deviceList.device4.id === "dissociate"
      ) {
      ret = true
    }
    return ret
  }

  //Function to send updates to cloud
  const updatePatientDeviceAndGateway = async () => {
    let isGatewayDevicesValid = checkGatewayDevicesValid();

    if (isGatewayDevicesValid) {
    let cloudUpdated = isCloudUpdated();
    let deviceConfigChanged = isDeviceConfigChanged();
    let updated_patient = getUpdatedPatient();
    let ret;

    let old_patient_info = await PatientFunctionsGetter.get_Patients("patient", props.profileData.Patient_Data.id_patient)

    // Subscription management: if monitoring change occured
    let test_sub = testUpdateSubscriptions(updated_patient.Patient_Data.monitoring_activation, old_patient_info?.[0]?.monitoring_activation)

    if (test_sub) {
      if(cloudUpdated){

        ret = await PatientFunctionsGetter.update_SQL_patient(updated_patient);
        if (ret === true) {
          setmessage(<FormattedMessage id="param.validationChangesConfirm" defaultMessage="Success: These changes will be effective in a few minutes."/>);
          props.setChangeOngoing(false)
          redefineDeviceList()
        }
        else {
          setmessage(<FormattedMessage id={ret.id} defaultMessage={ret.defaultMessage} />);
        }
        // reload data
        if(deviceConfigChanged){
          await props.reloadUserAndProfiles();
        }
        else{
          props.updateProfileParameters(updated_patient);
        }

      }

      else{
        if((props.userRole === "admin")||(props.userRole === "staff")){

          ret = await PatientFunctionsGetter.update_SQL_patient(updated_patient);
          if (ret === true){
              setmessage(<FormattedMessage id="param.validationChangesConfirm" defaultMessage="Success: These changes will be effective in a few minutes."/>);
            props.setChangeOngoing(false)
              redefineDeviceList()
          }
          else {
            setmessage(<FormattedMessage id={ret.id} defaultMessage={ret.defaultMessage} />);
          }
          // reload data
          if(deviceConfigChanged){
            await props.reloadUserAndProfiles();
          }
          else{
            props.updateProfileParameters(updated_patient);
          }
        }
        else{
          setmessage("No changes detected!");
        }
      }
    }
    else {
      props.setChangeOngoing(false);
    }

    setsubmitted(true);
  }
    else {
      setmessage(<FormattedMessage id="message.error.gateway.devicesWrongParameters" defaultMessage="Error: Gateway and devices parameters are not valid."/>);      
    }
  }

  const getConcernedReminderCheck = (type) => {
    let ret = false;
    switch (type) {
      case "tucky_reminder":
        ret = checkedReminderTucky
        break
      case "oximeter_reminder":
        ret = checkedReminderOximeter
        break
      case "tensiometer_reminder":
        ret = checkedReminderTensiometer
        break
      case "scale_reminder":
        ret = checkedReminderScale
        break
    }
    return ret;
  }

  const addNewHours = (e, type) => {
    let new_hours = Utils.get_reminder_from_type(checkedReminderList, type).alert_hours
    new_hours = new_hours.split(",")
      if (new_hours[0] === '') {
        new_hours[0] = e
      }
      else {
      new_hours.push(e)
      }
    new_hours = new_hours.join()
    let new_reminder = checkedReminderList.slice() //the slice is needed to make react understand that checkedReminderList is updated
    new_reminder.forEach(reminder => {
      if (reminder.alert_type === type) {
        reminder.alert_hours = new_hours;
      }
    })
    setCheckedReminderList(new_reminder)
    props.setChangeOngoing(true)
  }

  const deleteHours = (index, type) => {
    let new_hours = Utils.get_reminder_from_type(checkedReminderList, type).alert_hours
    new_hours = new_hours.split(",")
    new_hours.splice(index, 1)
    new_hours = new_hours.join()
    let new_reminder = checkedReminderList.slice() //the slice is needed to make react understand that checkedReminderList is updated
    new_reminder.forEach(reminder => {
      if (reminder.alert_type === type) {
        reminder.alert_hours = new_hours;
      }
    })
    setCheckedReminderList(new_reminder)
    props.setChangeOngoing(true)
  }

  const handleChangeReminderHours = (new_value, index, type) => {
    let new_hours = Utils.get_reminder_from_type(checkedReminderList, type).alert_hours
    new_hours = new_hours.split(",")
    new_hours[index] = new_value
    new_hours = new_hours.join()
    let new_reminder = checkedReminderList.slice() //the slice is needed to make react understand that checkedReminderList is updated
    new_reminder.forEach(reminder => {
      if (reminder.alert_type === type) {
        reminder.alert_hours = new_hours;
      }
    })
    setCheckedReminderList(new_reminder)
    props.setChangeOngoing(true)
  }

  //Function to get reminder update form
  const renderReminderForm = (type) => {
    let reminder_activated = Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("reminder"))
    if (reminder_activated === true) {    
    return(
      <div>
        {renderReminderRow("param.reminderMode", "Reminder", type, findSetCheckedReminder(type), findCheckedReminder(type), type)}
      </div>
    );
  }
    else {
      return (null)
    }
  }


  //Function to get reminder update form
  const renderReminderFormNoCheck = (type, force) => {
    let reminder_activated = Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("reminder"))
    if (reminder_activated === true || force === true) {
      return(
        <div>
          {renderReminderRow("param.reminderMode", "Reminder", type, findSetCheckedReminder(type), true, "disabled")}
        </div>
      );
    }
    else {
      return (null)
    }
  }


  const alert_filling = (type) => {
    let alert
    switch (type) {
      case "fever_alert":
        alert = default_device.fever_alert
        alert.type = "fever_alert"
        alert.threshold.defaut = feverAlert.threshold
        alert.sup_or_inf = feverAlert.sup_or_inf
        alert.sup_or_inf2 = feverAlert.sup_or_inf2
        if (feverAlert.threshold2 !== undefined) {
          alert.threshold2.defaut = feverAlert.threshold2
        }
        alert.delay.defaut = feverAlert.delay
        break
      case "FS20F":
        alert = default_device.pulseRateAlertOxymetre
        alert.type = "PR_alert"
        alert.threshold.defaut = PRAlert.threshold
        alert.sup_or_inf = PRAlert.sup_or_inf
        alert.sup_or_inf2 = PRAlert.sup_or_inf2
        if (PRAlert.threshold2 !== undefined) {
          alert.threshold2.defaut = PRAlert.threshold2
        }
        alert.delay.defaut = PRAlert.delay
        break
      case "SPO2":
        alert = default_device.spo2Alert
        alert.type = "SPO2_alert"
        alert.sup_or_inf = SPO2Alert.sup_or_inf
        alert.threshold.defaut = SPO2Alert.threshold
        alert.delay.defaut = SPO2Alert.delay
        break
      case "bloodpressure_PR_alert":
        alert = default_device.pulseRateAlertTension
        alert.type = "bloodpressure_PR_alert"
        alert.sup_or_inf = PRTensionAlert.sup_or_inf
        alert.threshold.defaut = PRTensionAlert.threshold
        alert.sup_or_inf2 = PRTensionAlert.sup_or_inf2
        if (PRTensionAlert.threshold2 !== undefined) {
          alert.threshold2.defaut = PRTensionAlert.threshold2
        }
        alert.delay.defaut = PRTensionAlert.delay
        break
      case "bloodpressure_sys_high_alert":
        alert = default_device.systolicHighAlert
        alert.type = "bloodpressure_sys_high_alert"
        alert.sup_or_inf = systolicHighAlert.sup_or_inf
        alert.threshold.defaut = systolicHighAlert.threshold
        alert.sup_or_inf2 = systolicHighAlert.sup_or_inf2
        if (systolicHighAlert.threshold2 !== undefined) {
          alert.threshold2.defaut = systolicHighAlert.threshold2
        }
        alert.delay.defaut = systolicHighAlert.delay
        break
      case "bloodpressure_dia_alert":
        alert = default_device.diastolicHighAlert
        alert.type = "bloodpressure_dia_alert"
        alert.sup_or_inf = diastolicHighAlert.sup_or_inf
        alert.threshold.defaut = diastolicHighAlert.threshold
        alert.sup_or_inf2 = diastolicHighAlert.sup_or_inf2
        if (diastolicHighAlert.threshold2 !== undefined) {
          alert.threshold2.defaut = diastolicHighAlert.threshold2
        }
        alert.delay.defaut = diastolicHighAlert.delay
        break
      case "LESCALE":
        alert = default_device.weightAlert
        alert.type = "weight_alert"
        alert.sup_or_inf = weightAlert.sup_or_inf
        alert.threshold.defaut = weightAlert.threshold
        alert.sup_or_inf2 = weightAlert.sup_or_inf2
        if (weightAlert.threshold2 !== undefined) {
          alert.threshold2.defaut = weightAlert.threshold2
        }
        alert.delay.defaut = weightAlert.delay
        break
      case "eq5d":
        alert = default_device.eq5dAlert
        alert.type = "eq5d_alert"
        alert.sup_or_inf = eq5dAlert.sup_or_inf
        alert.threshold.defaut = eq5dAlert.threshold
        alert.sup_or_inf2 = eq5dAlert.sup_or_inf2
        if (eq5dAlert.threshold2 !== undefined) {
          alert.threshold2.defaut = eq5dAlert.threshold2
        }
        alert.delay.defaut = eq5dAlert.delay
        break
      case "eq5d_scale":
        alert = default_device.eq5dScaleAlert
        alert.type = "eq5d_scale_alert"
        alert.sup_or_inf = eq5dScaleAlert.sup_or_inf
        alert.threshold.defaut = eq5dScaleAlert.threshold
        alert.sup_or_inf2 = eq5dScaleAlert.sup_or_inf2
        if (eq5dScaleAlert.threshold2 !== undefined) {
          alert.threshold2.defaut = eq5dScaleAlert.threshold2
        }
        alert.delay.defaut = eq5dScaleAlert.delay
        break
      case "sf36":
        alert = default_device.sf36Alert
        alert.type = "sf36_alert"
        alert.sup_or_inf = sf36Alert.sup_or_inf
        alert.threshold.defaut = sf36Alert.threshold
        alert.sup_or_inf2 = sf36Alert.sup_or_inf2
        if (sf36Alert.threshold2 !== undefined) {
          alert.threshold2.defaut = sf36Alert.threshold2
        }
        alert.delay.defaut = sf36Alert.delay
        break
      case "mdasi":
        alert = default_device.mdasiAlert
        alert.type = "mdasi_alert"
        alert.sup_or_inf = mdasiAlert.sup_or_inf
        alert.threshold.defaut = mdasiAlert.threshold
        alert.sup_or_inf2 = mdasiAlert.sup_or_inf2
        if (mdasiAlert.threshold2 !== undefined) {
          alert.threshold2.defaut = mdasiAlert.threshold2
        }
        alert.delay.defaut = mdasiAlert.delay
        break
      case "pain":
        alert = default_device.painAlert
        alert.type = "pain_alert"
        alert.sup_or_inf = painAlert.sup_or_inf
        alert.threshold.defaut = painAlert.threshold
        alert.sup_or_inf2 = painAlert.sup_or_inf2
        if (painAlert.threshold2 !== undefined) {
          alert.threshold2.defaut = painAlert.threshold2
        }
        alert.delay.defaut = painAlert.delay
        break
      case "breathing":
        alert = default_device.breathingAlert
        alert.type = "breathing_rate_alert"
        alert.sup_or_inf = breathingAlert.sup_or_inf
        alert.threshold.defaut = breathingAlert.threshold
        alert.sup_or_inf2 = breathingAlert.sup_or_inf2
        if (breathingAlert.threshold2 !== undefined) {
          alert.threshold2.defaut = breathingAlert.threshold2
        }
        alert.delay.defaut = breathingAlert.delay
        break
      case "breathing_oxygen_rate":
        alert = default_device.breathingOxygenRateAlert
        alert.type = "breathing_oxygen_rate_alert"
        alert.sup_or_inf = breathingOxygenRateAlert.sup_or_inf
        alert.threshold.defaut = breathingOxygenRateAlert.threshold
        alert.sup_or_inf2 = breathingOxygenRateAlert.sup_or_inf2
        if (breathingOxygenRateAlert.threshold2 !== undefined) {
          alert.threshold2.defaut = breathingOxygenRateAlert.threshold2
        }
        alert.delay.defaut = breathingOxygenRateAlert.delay
        break
      case "breathing_leakage":
        alert = default_device.breathingLeakageAlert
        alert.type = "breathing_leakage_alert"
        alert.sup_or_inf = breathingLeakageAlert.sup_or_inf
        alert.threshold.defaut = breathingLeakageAlert.threshold
        alert.sup_or_inf2 = breathingLeakageAlert.sup_or_inf2
        if (breathingLeakageAlert.threshold2 !== undefined) {
          alert.threshold2.defaut = breathingLeakageAlert.threshold2
        }
        alert.delay.defaut = breathingLeakageAlert.delay
        break
      case "breathing_leakage95":
        alert = default_device.breathingLeakage95Alert
        alert.type = "breathing_leakage95_alert"
        alert.sup_or_inf = breathingLeakage95Alert.sup_or_inf || 'sup'
        alert.threshold.defaut = breathingLeakage95Alert.threshold
        alert.sup_or_inf2 = breathingLeakage95Alert.sup_or_inf2
        if (breathingLeakage95Alert.threshold2 !== undefined) {
          alert.threshold2.defaut = breathingLeakage95Alert.threshold2
        }
        alert.delay.defaut = breathingLeakage95Alert.delay || 0
        break
      case "breathing_ahi":
        alert = default_device.breathingAhiAlert
        alert.type = "breathing_ahi_alert"
        alert.sup_or_inf = breathingAhiAlert.sup_or_inf || 'sup'
        alert.threshold.defaut = breathingAhiAlert.threshold
        alert.sup_or_inf2 = breathingAhiAlert.sup_or_inf2
        if (breathingAhiAlert.threshold2 !== undefined) {
          alert.threshold2.defaut = breathingAhiAlert.threshold2
        }
        alert.delay.defaut = breathingAhiAlert.delay || 0
        break
      case "breathing_observance":
        alert = default_device.breathingObservanceAlert
        alert.type = "breathing_observance_alert"
        alert.sup_or_inf = breathingObservanceAlert.sup_or_inf
        alert.threshold.defaut = breathingObservanceAlert.threshold
        alert.delay.defaut = breathingLeakageAlert.delay
        break
    }
    return (alert)
  }

  //Function to get device update form
  const renderDeviceUpdateForm = (type, device) => {
    switch (type) {
      case "Tucky": 
      case "Tucky_smartphone": 
      let this_fever_alert = alert_filling("fever_alert")
        if (device.sn !== undefined && device.sn.includes('-')) {
        type = "AOJ-20"
      }
      return(
        <DeviceForm
          type={type}
          origin={"update"}
          get_device_name={get_device_name}
          device={device}
          device_list={effectiveDeviceList}
          selectedDeviceList={selectedDeviceList}
          this_fever_alert={this_fever_alert}
          filterTuckyAOJ20={filterTuckyAOJ20}
          testThermometerType={testThermometerType}
          handleClickButtonDelete={handleClickButtonDelete}
            handleChangeDeviceId={handleChangeDeviceId}
          handleChangeFeverCheck={handleChangeFeverCheck}
          handleChangeFeverThreshold={handleChangeFeverThreshold}
          handleChangeFeverThreshold2={handleChangeFeverThreshold2}
          handleChangeFeverDelay={handleChangeFeverDelay}
          handleChangeDetachCheck={handleChangeDetachCheck}
          handleChangeBatteryCheck={handleChangeBatteryCheck}
          checkedFever={checkedFever}
          checkedDetach={checkedDetach}
          checkedBattery={checkedBattery}
          renderDeviceSelectRow={renderDeviceSelectRow}
          renderAlertThresholdAndDelayRow={renderAlertThresholdAndDelayRow}
          renderAlertSelectRow={renderAlertSelectRow}
          renderAlertSwitchRow={renderAlertSwitchRow}
          renderReminderForm={renderReminderForm}
            renderReminderFormNoCheck={renderReminderFormNoCheck}
        />
      )
      break
      case "FS20F": 
      let this_PR_alert = alert_filling("FS20F")
      let this_spo2_alert = alert_filling("SPO2")
      return(
        <DeviceForm
          type={type}
          origin={"update"}
            features={props.subscription_info.features}
          get_device_name={get_device_name}
          device={device}
          device_list={effectiveDeviceList}
          selectedDeviceList={selectedDeviceList}
          this_PR_alert={this_PR_alert}
          this_spo2_alert={this_spo2_alert}
          handleClickButtonDelete={handleClickButtonDelete}
          handleChangeDeviceId={handleChangeDeviceId}
          handleChangePRCheck={handleChangePRCheck}
          handleChangePRThreshold={handleChangePRThreshold}
          handleChangePRThreshold2={handleChangePRThreshold2}
          handleChangePRDelay={handleChangePRDelay}
          handleChangeSPO2Check={handleChangeSPO2Check}
          handleChangeSPO2Threshold={handleChangeSPO2Threshold}
          handleChangeSPO2Delay={handleChangeSPO2Delay}
          checkedSPO2={checkedSPO2}
          checkedPR={checkedPR}
          renderDeviceSelectRow={renderDeviceSelectRow}
          renderAlertThresholdAndDelayRow={renderAlertThresholdAndDelayRow}
          renderReminderForm={renderReminderForm}
            renderReminderFormNoCheck={renderReminderFormNoCheck}
        />
      )
      break
      case "BP2A": 
      case "BPB6": 
      let this_PR_tension_alert = alert_filling("bloodpressure_PR_alert")
      let this_sys_high_alert = alert_filling("bloodpressure_sys_high_alert")
        let this_dia_alert = alert_filling("bloodpressure_dia_alert")
      return(
        <DeviceForm
          type={type}
          origin={"update"}
          get_device_name={get_device_name}
          device={device}
          device_list={effectiveDeviceList}
          selectedDeviceList={selectedDeviceList}
          this_PR_tension_alert={this_PR_tension_alert}
          this_sys_high_alert={this_sys_high_alert}
          this_dia_alert={this_dia_alert}
          handleClickButtonDelete={handleClickButtonDelete}
          handleChangeDeviceId={handleChangeDeviceId}
          handleChangePRTensionCheck={handleChangePRTensionCheck}
          handleChangePRTensionThreshold={handleChangePRTensionThreshold}
          handleChangePRTensionThreshold2={handleChangePRTensionThreshold2}
          handleChangePRTensionDelay={handleChangePRTensionDelay}
          handleChangeSystolicHighChecked={handleChangeSystolicHighChecked}
          handleChangeSystolicHighThreshold={handleChangeSystolicHighThreshold}
          handleChangeSystolicHighThreshold2={handleChangeSystolicHighThreshold2}
          handleChangeSystolicHighDelay={handleChangeSystolicHighDelay}
          handleChangeDiastolicHighChecked={handleChangeDiastolicHighChecked}
          handleChangeDiastolicHighThreshold={handleChangeDiastolicHighThreshold}
          handleChangeDiastolicHighThreshold2={handleChangeDiastolicHighThreshold2}
          handleChangeDiastolicHighDelay={handleChangeDiastolicHighDelay}
          checkedPRTension={checkedPRTension}
          checkedSystolicHigh={checkedSystolicHigh}
          checkedDiastolicHigh={checkedDiastolicHigh}
          renderDeviceSelectRow={renderDeviceSelectRow}
          renderAlertThresholdAndDelayRow={renderAlertThresholdAndDelayRow}
          renderReminderForm={renderReminderForm}
        />
      )
      break
      case "LESCALE": 
      case "S5":
      let this_weight_alert = alert_filling("LESCALE")
      return(
        <DeviceForm
          type={type}
          origin={"update"}
          get_device_name={get_device_name}
          device={device}
          device_list={effectiveDeviceList}
          selectedDeviceList={selectedDeviceList}
          this_weight_alert={this_weight_alert}
          handleClickButtonDelete={handleClickButtonDelete}
          handleChangeDeviceId={handleChangeDeviceId}
          handleChangeWeightChecked={handleChangeWeightChecked}
          handleChangeWeightThreshold={handleChangeWeightThreshold}
          handleChangeWeightThreshold2={handleChangeWeightThreshold2}
          handleChangeWeightDelay={handleChangeWeightDelay}
          checkedWeight={checkedWeight}
          renderDeviceSelectRow={renderDeviceSelectRow}
          renderAlertThresholdAndDelayRow={renderAlertThresholdAndDelayRow}
          renderReminderForm={renderReminderForm}
        />
      )
      break
    }
    }

  const renderModuleUpdateForm = () => {
    let this_breathing_alert = alert_filling("breathing")
    let this_breathing_oxygen_rate_alert = alert_filling("breathing_oxygen_rate")
    let this_breathing_leakage_alert = alert_filling("breathing_leakage")
    let this_breathing_leakage95_alert = alert_filling("breathing_leakage95")
    let this_breathing_ahi_alert = alert_filling("breathing_ahi")
    let this_breathing_observance_alert = alert_filling("breathing_observance")

    let module_list = moduleActivation.filter((m) => m.name === "niv" || m.name === "oxigen_therapy")
    return(
      <div>
        {
          module_list.map((healthformtype) => {
            if (healthformtype.used === true) {
              let type
              let device
              let this_spo2_alert
              if (healthformtype.name === "pain"
                  || healthformtype.name === "niv"
                  || healthformtype.name === "oxigen_therapy") {
                type = healthformtype.name
                device = {type: healthformtype.name.toLowerCase(), id_device: healthformtype.name.toLowerCase()}
                this_spo2_alert = alert_filling("SPO2")
              }
              else {
                type = "healthform"
                device = {type: "healthform_"+healthformtype.name.toLowerCase(), id_device: "healthform_"+healthformtype.name.toLowerCase()}
              }
              return(
                <DeviceForm
                  key={healthformtype.name}
                  type={type}
                  origin={"update"}
                  get_device_name={get_device_name}
                  device={device}
                  device_list={effectiveDeviceList}
                  features={props.subscription_info.features}
                  id_patient={props.profileData.Patient_Data.id_patient}
                  moduleActivation={healthformtype}
                  this_breathing_alert={this_breathing_alert}
                  this_breathing_observance_alert={this_breathing_observance_alert}
                  this_breathing_oxygen_rate_alert={this_breathing_oxygen_rate_alert}
                  this_breathing_leakage_alert={this_breathing_leakage_alert}
                  this_breathing_leakage95_alert={this_breathing_leakage95_alert}
                  this_breathing_ahi_alert={this_breathing_ahi_alert}
                  this_spo2_alert={this_spo2_alert}
                  checkedBreathing={checkedBreathing}
                  checkedBreathingLeakage={checkedBreathingLeakage}
                  checkedBreathingLeakage95={checkedBreathingLeakage95}
                  checkedBreathingAhi={checkedBreathingAhi}
                  checkedBreathingObservance={checkedBreathingObservance}
                  checkedBreathingOxygenRate={checkedBreathingOxygenRate}
                  checkedSPO2={props.checkedSPO2}
                  handleChangeDeviceId={handleChangeDeviceId}
                  handleChangeBreathingChecked={handleChangeBreathingChecked}
                  handleChangeBreathingThreshold={handleChangeBreathingThreshold}
                  handleChangeBreathingThreshold2={handleChangeBreathingThreshold2}
                  handleChangeBreathingObservanceChecked={handleChangeBreathingObservanceChecked}
                  handleChangeBreathingObservanceThreshold={handleChangeBreathingObservanceThreshold}
                  handleChangeBreathingOxygenRateChecked={handleChangeBreathingOxygenRateChecked}
                  handleChangeBreathingOxygenRateThreshold={handleChangeBreathingOxygenRateThreshold}
                  handleChangeBreathingOxygenRateThreshold2={handleChangeBreathingOxygenRateThreshold2}
                  handleChangeBreathingOxygenRateDelay={handleChangeBreathingOxygenRateDelay}
                  handleChangeBreathingLeakageChecked={handleChangeBreathingLeakageChecked}
                  handleChangeBreathingLeakageThreshold={handleChangeBreathingLeakageThreshold}
                  handleChangeBreathingLeakageThreshold2={handleChangeBreathingLeakageThreshold2}
                  handleChangeBreathingLeakage95Checked={handleChangeBreathingLeakage95Checked}
                  handleChangeBreathingLeakage95Threshold={handleChangeBreathingLeakage95Threshold}
                  handleChangeBreathingLeakage95Threshold2={handleChangeBreathingLeakage95Threshold2}
                  handleChangeBreathingAhiChecked={handleChangeBreathingAhiChecked}
                  handleChangeBreathingAhiThreshold={handleChangeBreathingAhiThreshold}
                  handleChangeBreathingAhiThreshold2={handleChangeBreathingAhiThreshold2}
                  handleChangeSPO2Check={props.handleChangeSPO2Check}
                  handleChangeSPO2Threshold={props.handleChangeSPO2Threshold}
                  handleChangeSPO2Delay={props.handleChangeSPO2Delay}
                  handleClickButtonDelete={handleClickButtonDelete}
                  nivProvider={props.profileData.Patient_Data.niv_provider}
                  renderDeviceSelectRow={renderDeviceSelectRow}
                  renderReminderForm={renderReminderForm}
                  renderReminderFormNoCheck={renderReminderFormNoCheck}
                  renderAlertThreshold={renderAlertThreshold}
                  renderAlertThresholdAndDelayRow={renderAlertThresholdAndDelayRow}
                  renderAlertThresholdAndDelayRowNoCheck={renderAlertThresholdAndDelayRowNoCheck}
                  selectedDeviceList={selectedDeviceList}
                />
              )
            }
          })
        }
      </div>
    )
  }

  const renderHealthformUpdateForm = () => {
    let this_eq5d_alert = alert_filling("eq5d")
    let this_eq5d_scale_alert = alert_filling("eq5d_scale")
    let this_sf36_alert = alert_filling("sf36")
    let this_mdasi_alert = alert_filling("mdasi")
    let this_pain_alert = alert_filling("pain")

    let healthform_list = moduleActivation.filter((m) => m.name === "EQ5D" || m.name === "SF36" || m.name === "MDASI" || m.name === "alimentation" || m.name === "pain")
    return(
      <div>
        {
          healthform_list.map((healthformtype) => {
            if (healthformtype.used === true) {
              let type
              let device
              let this_spo2_alert
              if (healthformtype.name === "pain"
                  || healthformtype.name === "niv"
                  || healthformtype.name === "oxigen_therapy") {
                type = healthformtype.name
                device = {type: healthformtype.name.toLowerCase(), id_device: healthformtype.name.toLowerCase()}
                this_spo2_alert = alert_filling("SPO2")
              }
              else {
                type = "healthform"
                device = {type: "healthform_"+healthformtype.name.toLowerCase(), id_device: "healthform_"+healthformtype.name.toLowerCase()}
              }
              return(
                <DeviceForm
                  key={healthformtype.name}
                  type={type}
                  origin={"update"}
                  get_device_name={get_device_name}
                  device={device}
                  device_list={effectiveDeviceList}
                  features={props.subscription_info.features}
                  id_patient={props.profileData.Patient_Data.id_patient}
                  moduleActivation={healthformtype}
                  this_eq5d_alert={this_eq5d_alert}
                  this_eq5d_scale_alert={this_eq5d_scale_alert}
                  this_sf36_alert={this_sf36_alert}
                  this_mdasi_alert={this_mdasi_alert}
                  this_pain_alert={this_pain_alert}
                  this_spo2_alert={this_spo2_alert}
                  checkedEQ5D={checkedEQ5D}
                  checkedEQ5DScale={checkedEQ5DScale}
                  checkedSF36={checkedSF36}
                  checkedMDASI={checkedMDASI}
                  checkedPain={checkedPain}
                  checkedSPO2={props.checkedSPO2}
                  handleChangeDeviceId={handleChangeDeviceId}
                  handleChangeEq5dChecked={handleChangeEq5dChecked}
                  handleChangeEq5dThreshold={handleChangeEq5dThreshold}
                  handleChangeEq5dDelay={handleChangeEq5dDelay}
                  handleChangeEq5dScaleChecked={handleChangeEq5dScaleChecked}
                  handleChangeEq5dScaleThreshold={handleChangeEq5dScaleThreshold}
                  handleChangeEq5dScaleDelay={handleChangeEq5dScaleDelay}
                  handleChangeSf36Checked={handleChangeSf36Checked}
                  handleChangeSf36Threshold={handleChangeSf36Threshold}
                  handleChangeSf36Delay={handleChangeSf36Delay}
                  handleChangeMDASIChecked={handleChangeMDASIChecked}
                  handleChangeMDASIThreshold={handleChangeMDASIThreshold}
                  handleChangeMDASIDelay={handleChangeMDASIDelay}
                  handleChangePainChecked={handleChangePainChecked}
                  handleChangePainThreshold={handleChangePainThreshold}
                  handleChangePainThreshold2={handleChangePainThreshold2}
                  handleChangePainDelay={handleChangePainDelay}
                  handleChangeSPO2Check={props.handleChangeSPO2Check}
                  handleChangeSPO2Threshold={props.handleChangeSPO2Threshold}
                  handleChangeSPO2Delay={props.handleChangeSPO2Delay}
                  handleClickButtonDelete={handleClickButtonDelete}
                  nivProvider={props.profileData.Patient_Data.niv_provider}
                  renderDeviceSelectRow={renderDeviceSelectRow}
                  renderReminderForm={renderReminderForm}
                  renderReminderFormNoCheck={renderReminderFormNoCheck}
                  renderAlertThreshold={renderAlertThreshold}
                  renderAlertThresholdAndDelayRow={renderAlertThresholdAndDelayRow}
                  renderAlertThresholdAndDelayRowNoCheck={renderAlertThresholdAndDelayRowNoCheck}
                  selectedDeviceList={selectedDeviceList}
                />
              )
            }
          })
        }
      </div>
    )
  }

  const renderDevicesCards = () => {

    let devices = effectiveDeviceList.filter((d) => d.type === "Tucky" || d.type === "FS20F" || d.type === "BP2A" || d.type === "BPB6" || d.type === "LESCALE" || d.type === "S5")

    devices.sort(function(a, b) {
        var textA = a.converted;
        var textB = b.converted;
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });

    return(
      devices.map((device,index)=>{
        if (device.id_device !== "dissociate" &&
            (device.id_device === selectedDeviceList.device1.id ||
             device.id_device === selectedDeviceList.device2.id ||
             device.id_device === selectedDeviceList.device3.id ||             
             device.id_device === selectedDeviceList.device4.id)) {
          return (
            <div key={device.id_device}>
              {renderDeviceUpdateForm(device.type, device)}
                </div>
          )
        }
        else {
          return null
        }
      })
    )
  }





  // ###### RENDER FUNCTIONS ######
  const { classes } = props;

  return (
    <div>
      <div style={{height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form" style={{ "maxHeight":"100%", height: "100%", margin:"0px", borderRadius: "5px",  padding:"10px"}}>
          <div style={{textAlign: 'left'}}>
            {renderPatientIdentificationAndLocation()}
            {((props.userRole === "admin")||(props.userRole === "staff")) ?
              renderMonitoringParametersEdit()
              :
              null
            }
            <br/>
            <div style={{textAlign:"center", position:"relative"}}>
              {workingOnCancel ?
                <button onClick={restorePatient} className="btn btn-danger" disabled={!props.changeOngoing}>
                  <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
                </button>
                :
                null
              }
              <b>&emsp;</b>
              {props.accountInformation.readOnly === true ?
                null
                :
              <button onClick={checkParametersUpdate} className="btn btn-success" disabled={!props.changeOngoing}>
                <FormattedMessage id="button.submit" defaultMessage="Submit" />
              </button>
              }
            </div>
            {displayInvalidValuePopup ?
              <InvalidObject cancelPopup={handleInvalidValuePopupDisplay} message={message}/>
              :
              null
            }
            {displayValidationPopup ?
              <ValidationPopup cancelPopup={handleValidationPopupDisplay} validate={updatePatientDeviceAndGateway} message={message}/>
              :
              null
            }
            {inviteToCancel ?
              <ValidationPopup
                cancelPopup={() => setInviteToCancel(null)}
                validate={async () => {
                  const inv = inviteToCancel;
                  setInviteToCancel(null);
                  if (!inv) return;
                  setPendingInvites(prev => prev.filter(i => i.request_id !== inv.request_id));
                  const ok = await PatientFunctionsGetter.delete_patient_pending_invite(props.profileData.Patient_Data.id_patient, inv.request_id);
                  if (!ok) {
                    fetchPendingInvites();
                  }
                }}
                message={<FormattedMessage id="patient.cancelInviteConfirm" defaultMessage="Annuler cette invitation ?" />}
              />
              :
              null
            }
          </div>
        </div>
      </div>
      {displayAddDevicePopup ?
          <AddDevicePopup
            features={props.subscription_info.features}
            profileData={props.profileData}
            device_list={effectiveDeviceList}
            moduleActivation={moduleActivation}
            newReminderHours={newReminderHours}
            reminder_list={checkedReminderList}
            rerender={rerender}
            subscription_info={props.subscription_info}
            cancelPopup={handleClickButton}
            alert_filling={alert_filling}
            addNewHours={addNewHours}
            deleteHours={deleteHours}
            select_tooltip={props.select_tooltip}
            testHoursDisabled={testHoursDisabled}
            testThermometerType={testThermometerType}
            checkedFever={checkedFever}
            checkedReminderTucky={checkedReminderTucky}
            checkedReminderOximeter={checkedReminderOximeter}
            checkedReminderTensiometer={checkedReminderTensiometer}
            checkedReminderScale={checkedReminderScale}
            checkedDetach={checkedDetach}
            checkedBattery={checkedBattery}
            checkedPR={checkedPR}
            checkedSPO2={checkedSPO2}
            checkedPRTension={checkedPRTension}
            checkedSystolicHigh={checkedSystolicHigh}
            checkedDiastolicHigh={checkedDiastolicHigh}
            checkedWeight={checkedWeight}
            checkedEQ5D={checkedEQ5D}
            checkedEQ5DScale={checkedEQ5DScale}
            checkedSF36={checkedSF36}
            checkedMDASI={checkedMDASI}
            checkedPain={checkedPain}
            checkedBreathing={checkedBreathing}
            checkedBreathingLeakage={checkedBreathingLeakage}
            checkedBreathingLeakage95={checkedBreathingLeakage95}
            checkedBreathingAhi={checkedBreathingAhi}
            checkedBreathingObservance={checkedBreathingObservance}
            checkedBreathingOxygenRate={checkedBreathingOxygenRate}
            findSetCheckedReminder={findSetCheckedReminder}
            findCheckedReminder={findCheckedReminder}
            getConcernedReminderCheck={getConcernedReminderCheck}
            get_device_name={get_device_name}
            getNewReminderHour={getNewReminderHour}
            handleDisplayTuckyParams={handleDisplayTuckyParams}
            handleChangeReminderTuckyCheck={handleChangeReminderTuckyCheck}
            handleChangeFeverCheck={handleChangeFeverCheck}
            handleChangeFeverThreshold={handleChangeFeverThreshold}
            handleChangeFeverThreshold2={handleChangeFeverThreshold2}
            handleChangeFeverDelay={handleChangeFeverDelay}
            handleChangeDetachCheck={handleChangeDetachCheck}
            handleChangeBatteryCheck={handleChangeBatteryCheck}
            handleChangePRCheck={handleChangePRCheck}
            handleChangePRThreshold={handleChangePRThreshold}
            handleChangePRThreshold2={handleChangePRThreshold2}
            handleChangePRDelay={handleChangePRDelay}
            handleChangeSPO2Check={handleChangeSPO2Check}
            handleChangeSPO2Threshold={handleChangeSPO2Threshold}
            handleChangeSPO2Delay={handleChangeSPO2Delay}
            handleChangePRTensionCheck={handleChangePRTensionCheck}
            handleChangePRTensionThreshold={handleChangePRTensionThreshold}
            handleChangePRTensionThreshold2={handleChangePRTensionThreshold2}
            handleChangePRTensionDelay={handleChangePRTensionDelay}
            handleChangeSystolicHighChecked={handleChangeSystolicHighChecked}
            handleChangeDiastolicHighChecked={handleChangeDiastolicHighChecked}
            handleChangeSystolicHighThreshold={handleChangeSystolicHighThreshold}
            handleChangeSystolicHighThreshold2={handleChangeSystolicHighThreshold2}
            handleChangeSystolicHighDelay={handleChangeSystolicHighDelay}
            handleChangeWeightChecked={handleChangeWeightChecked}
            handleChangeEq5dChecked={handleChangeEq5dChecked}
            handleChangeEq5dThreshold={handleChangeEq5dThreshold}
            handleChangeEq5dDelay={handleChangeEq5dDelay}
            handleChangeEq5dScaleChecked={handleChangeEq5dScaleChecked}
            handleChangeEq5dScaleThreshold={handleChangeEq5dScaleThreshold}
            handleChangeEq5dScaleDelay={handleChangeEq5dScaleDelay}
            handleChangeSf36Checked={handleChangeSf36Checked}
            handleChangeSf36Threshold={handleChangeSf36Threshold}
            handleChangeSf36Delay={handleChangeSf36Delay}
            handleChangeMDASIChecked={handleChangeMDASIChecked}
            handleChangeMDASIThreshold={handleChangeMDASIThreshold}
            handleChangeMDASIDelay={handleChangeMDASIDelay}
            handleChangePainChecked={handleChangePainChecked}
            handleChangePainThreshold={handleChangePainThreshold}
            handleChangePainThreshold2={handleChangePainThreshold2}
            handleChangePainDelay={handleChangePainDelay}
            handleChangeWeightThreshold={handleChangeWeightThreshold}
            handleChangeWeightThreshold2={handleChangeWeightThreshold2}
            handleChangeWeightDelay={handleChangeWeightDelay}
            handleChangeBreathingChecked={handleChangeBreathingChecked}
            handleChangeBreathingThreshold={handleChangeBreathingThreshold}
            handleChangeBreathingThreshold2={handleChangeBreathingThreshold2}
            handleChangeBreathingObservanceChecked={handleChangeBreathingObservanceChecked}
            handleChangeBreathingObservanceThreshold={handleChangeBreathingObservanceThreshold}
            handleChangeBreathingOxygenRateChecked={handleChangeBreathingOxygenRateChecked}
            handleChangeBreathingOxygenRateThreshold={handleChangeBreathingOxygenRateThreshold}
            handleChangeBreathingOxygenRateThreshold2={handleChangeBreathingOxygenRateThreshold2}
            handleChangeBreathingOxygenRateDelay={handleChangeBreathingOxygenRateDelay}
            handleChangeBreathingLeakageChecked={handleChangeBreathingLeakageChecked}
            handleChangeBreathingLeakageThreshold={handleChangeBreathingLeakageThreshold}
            handleChangeBreathingLeakageThreshold2={handleChangeBreathingLeakageThreshold2}
            handleChangeBreathingLeakage95Checked={handleChangeBreathingLeakage95Checked}
            handleChangeBreathingLeakage95Threshold={handleChangeBreathingLeakage95Threshold}
            handleChangeBreathingLeakage95Threshold2={handleChangeBreathingLeakage95Threshold2}
            handleChangeBreathingAhiChecked={handleChangeBreathingAhiChecked}
            handleChangeBreathingAhiThreshold={handleChangeBreathingAhiThreshold}
            handleChangeBreathingAhiThreshold2={handleChangeBreathingAhiThreshold2}
            handleChangeReminderOximeterCheck={handleChangeReminderOximeterCheck}
            handleChangeReminderTensiometerCheck={handleChangeReminderTensiometerCheck}
            handleChangeReminderScaleCheck={handleChangeReminderScaleCheck}
            handleChangeReminderHealthformEQ5DCheck={handleChangeReminderHealthformEQ5DCheck}
            handleChangeReminderHours={handleChangeReminderHours}
            handleChangeReminderFrequency={handleChangeReminderFrequency}
            renderReminderForm={renderReminderForm}
            renderReminderFormNoCheck={renderReminderFormNoCheck}
            renderDeviceSelectRow={renderDeviceSelectRow}
            renderAlertThreshold={renderAlertThreshold}
            renderAlertThresholdAndDelayRow={renderAlertThresholdAndDelayRow}
            renderAlertThresholdAndDelayRowNoCheck={renderAlertThresholdAndDelayRowNoCheck}
            renderAlertSelectRow={renderAlertSelectRow}
            renderAlertSwitchRow={renderAlertSwitchRow}
            setReminder_list={setCheckedReminderList}
            setDisplayAlertModes={setDisplayAlertModes}
            setDisplayTuckyParams={setDisplayTuckyParams}
            setDisplayOximeterParams={setDisplayOximeterParams}
            setDisplayTensiometerParams={setDisplayTensiometerParams}
            setDisplayScaleParams={setDisplayScaleParams}            
            setCheckedFever={setCheckedFever}
            setFeverAlert={setFeverAlert}
            setSPO2Alert={setSPO2Alert}
            setPRAlert={setPRAlert}
            setPRTensionAlert={setPRTensionAlert}
            setSystolicHighAlert={setSystolicHighAlert}
            setDiastolicHighAlert={setDiastolicHighAlert}
            setWeightAlert={setWeightAlert}
            setPosition={setPosition}
            setEq5dAlert={setEq5dAlert}
            setEq5dScaleAlert={setEq5dScaleAlert}
            setSf36Alert={setSf36Alert}
            setMDASIAlert={setMDASIAlert}
            setPainAlert={setPainAlert}
            setBreathingAlert={setBreathingAlert}
            setBreathingLeakageAlert={setBreathingLeakageAlert}
            setBreathingLeakageAlert={setBreathingLeakageAlert}
            setCheckedDetach={setCheckedDetach}
            setCheckedBattery={setCheckedBattery}
            setCheckedPR={setCheckedPR}
            setCheckedSPO2={setCheckedSPO2}
            setCheckedPRTension={setCheckedPRTension}
            setCheckedSystolicHigh={setCheckedSystolicHigh}
            setCheckedDiastolicHigh={setCheckedDiastolicHigh}
            setCheckedWeight={setCheckedWeight}
            setCheckedEQ5D={setCheckedEQ5D}
            setCheckedEQ5DScale={setCheckedEQ5DScale}
            setCheckedSF36={setCheckedSF36}
            setCheckedMDASI={setCheckedMDASI}
            setCheckedPain={setCheckedPain}
            setCheckedBreathing={setCheckedBreathing}
            setCheckedBreathingLeakage={setCheckedBreathingLeakage}
            setCheckedBreathingObservance={setCheckedBreathingObservance}
            setChangeOngoing={props.setChangeOngoing}
            setModuleActivation={setModuleActivation}
            selectedDeviceList={selectedDeviceList}
            setSelectedDeviceList={setSelectedDeviceList}
            setRerender={setRerender}
            setDevicesVisible={setDevicesVisible}
            setModulesVisible={setModulesVisible}
            setHealthformsVisible={setHealthformsVisible}
            setSmartphoneVisible={setSmartphoneVisible}
          />
          :
          null
      }
      {displayDeleteDevicePopup ?
          <DeleteDevicePopup
            cancelPopup={handleClickButtonDelete}
            cleanModulesDisplays={cleanModulesDisplays}
            device_list={effectiveDeviceList}
            profileData={props.profileData}
            moduleActivation={moduleActivation}
            setModuleActivation={setModuleActivation}
            setDisplayDeleteDevicePopup={setDisplayDeleteDevicePopup}
            displayDeleteDevicePopup={displayDeleteDevicePopup}
            setDeleteDeviceID={setDeleteDeviceID}
            deleteDeviceID={deleteDeviceID}
            setChangeOngoing={props.setChangeOngoing}
            selectedDeviceList={selectedDeviceList}
            setSelectedDeviceList={setSelectedDeviceList}
            checkedReminderList={checkedReminderList}
            setCheckedReminderList={setCheckedReminderList}
            reminderToDelete={reminderToDelete}
            setReminderToDelete={setReminderToDelete}
            setCheckedReminder={findSetCheckedReminder(reminderToDelete)}
            painAlert={painAlert}
            setPainAlert={setPainAlert}
            setCheckedPain={setCheckedPain}
            breathingAlert={breathingAlert}
            setBreathingAlert={setBreathingAlert}
            setCheckedBreathing={setCheckedBreathing}
            breathingOxygenRateAlert={breathingOxygenRateAlert}
            setBreathingOxygenRateAlert={setBreathingOxygenRateAlert}
            setCheckedBreathingOxygenRate={setCheckedBreathingOxygenRate}
            breathingLeakageAlert={breathingLeakageAlert}
            setBreathingLeakageAlert={setBreathingLeakageAlert}
            setCheckedBreathingLeakage={setCheckedBreathingLeakage}
            breathingObservanceAlert={breathingObservanceAlert}
            setBreathingObservanceAlert={setBreathingObservanceAlert}
            setCheckedBreathingObservance={setCheckedBreathingObservance}
          />
          :
          null
      }
      {displayDeletePatientPopup ?
        <DeleteObject
          cancelPopup={manageDeletePatientDisplay}
          object_type={"patient"}
          closeAfterDelete={closeAfterDeletion}
          accountInformation={props.accountInformation}
          structure_Id={props.structure_Id}
          patient={props.profileData}
          subscription_info={props.subscription_info}
          object_name={props.profileData.Patient_Data.firstname + " " + props.profileData.Patient_Data.lastname}
        />
        :
        null
      }
    </div>
  );
};

export default withStyles(Constants.styles)(PatientParamsEditTab);
